import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Circle: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Dimension: { input: any; output: any; }
  HexColor: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Quality: { input: any; output: any; }
  Rectangle: { input: any; output: any; }
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = _Node & {
  __typename?: 'Asset';
  _id: Scalars['ID']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
  __typename?: 'AssetCursorCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  basicPageCollection?: Maybe<BasicPageCollection>;
  basicPageCursorCollection?: Maybe<BasicPageCursorCollection>;
  blockClassyCollection?: Maybe<BlockClassyCollection>;
  blockClassyCursorCollection?: Maybe<BlockClassyCursorCollection>;
  blockCtaCollection?: Maybe<BlockCtaCollection>;
  blockCtaCursorCollection?: Maybe<BlockCtaCursorCollection>;
  blockFundraiseUpCollection?: Maybe<BlockFundraiseUpCollection>;
  blockFundraiseUpCursorCollection?: Maybe<BlockFundraiseUpCursorCollection>;
  blockHighlightCollection?: Maybe<BlockHighlightCollection>;
  blockHighlightCursorCollection?: Maybe<BlockHighlightCursorCollection>;
  blockImagesCollection?: Maybe<BlockImagesCollection>;
  blockImagesCursorCollection?: Maybe<BlockImagesCursorCollection>;
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  blockQuotationCollection?: Maybe<BlockQuotationCollection>;
  blockQuotationCursorCollection?: Maybe<BlockQuotationCursorCollection>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  blockVideoCursorCollection?: Maybe<BlockVideoCursorCollection>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogCategoryCursorCollection?: Maybe<BlogCategoryCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  donationAppealCollection?: Maybe<DonationAppealCollection>;
  donationAppealCursorCollection?: Maybe<DonationAppealCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroCursorCollection?: Maybe<HeroCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
  layoutCopyCollection?: Maybe<LayoutCopyCollection>;
  layoutCopyCursorCollection?: Maybe<LayoutCopyCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  personCollection?: Maybe<PersonCollection>;
  personCursorCollection?: Maybe<PersonCursorCollection>;
  pressReleaseCollection?: Maybe<PressReleaseCollection>;
  pressReleaseCursorCollection?: Maybe<PressReleaseCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
  statisticCollection?: Maybe<StatisticCollection>;
  statisticCursorCollection?: Maybe<StatisticCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type AssetLinkingCollectionsBasicPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBasicPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockClassyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockClassyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockFundraiseUpCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockFundraiseUpCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockQuotationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockQuotationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlockVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlogCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsDonationAppealCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsDonationAppealCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLayoutCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLayoutCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPressReleaseCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPressReleaseCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsStatisticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsStatisticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPage = Entry & _Node & {
  __typename?: 'BasicPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<BasicPageCopy>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BasicPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageMetaKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/basicPage) */
export type BasicPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BasicPageCollection = {
  __typename?: 'BasicPageCollection';
  items: Array<Maybe<BasicPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BasicPageCopy = {
  __typename?: 'BasicPageCopy';
  json: Scalars['JSON']['output'];
  links: BasicPageCopyLinks;
};

export type BasicPageCopyAssets = {
  __typename?: 'BasicPageCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BasicPageCopyEntries = {
  __typename?: 'BasicPageCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BasicPageCopyLinks = {
  __typename?: 'BasicPageCopyLinks';
  assets: BasicPageCopyAssets;
  entries: BasicPageCopyEntries;
  resources: BasicPageCopyResources;
};

export type BasicPageCopyResources = {
  __typename?: 'BasicPageCopyResources';
  block: Array<BasicPageCopyResourcesBlock>;
  hyperlink: Array<BasicPageCopyResourcesHyperlink>;
  inline: Array<BasicPageCopyResourcesInline>;
};

export type BasicPageCopyResourcesBlock = ResourceLink & {
  __typename?: 'BasicPageCopyResourcesBlock';
  sys: ResourceSys;
};

export type BasicPageCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'BasicPageCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type BasicPageCopyResourcesInline = ResourceLink & {
  __typename?: 'BasicPageCopyResourcesInline';
  sys: ResourceSys;
};

export type BasicPageCursorCollection = {
  __typename?: 'BasicPageCursorCollection';
  items: Array<Maybe<BasicPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BasicPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BasicPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BasicPageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BasicPageLinkingCollections = {
  __typename?: 'BasicPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
};


export type BasicPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BasicPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BasicPageLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BasicPageLinkingCollectionsKnowledgeBasedResourceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BasicPageLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BasicPageLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BasicPageLinkingCollectionsKnowledgeBasedResourceCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BasicPageLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BasicPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPosts = Entry & _Node & {
  __typename?: 'BlockBlogPosts';
  _id: Scalars['ID']['output'];
  blogPostsCollection?: Maybe<BlockBlogPostsBlogPostsCollection>;
  blogPostsCursorCollection?: Maybe<BlockBlogPostsBlogPostsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockBlogPostsLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPostsBlogPostsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsBlogPostsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPostsBlogPostsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsBlogPostsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPostsHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPostsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockBlogPosts) */
export type BlockBlogPostsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockBlogPostsBlogPostsCollection = {
  __typename?: 'BlockBlogPostsBlogPostsCollection';
  items: Array<Maybe<BlogPost>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockBlogPostsBlogPostsCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockBlogPostsBlogPostsCursorCollection = {
  __typename?: 'BlockBlogPostsBlogPostsCursorCollection';
  items: Array<Maybe<BlogPost>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockBlogPostsBlogPostsCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockBlogPostsCollection = {
  __typename?: 'BlockBlogPostsCollection';
  items: Array<Maybe<BlockBlogPosts>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockBlogPostsCursorCollection = {
  __typename?: 'BlockBlogPostsCursorCollection';
  items: Array<Maybe<BlockBlogPosts>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockBlogPostsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockBlogPostsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockBlogPostsFilter>>>;
  blogPosts?: InputMaybe<CfBlogPostNestedFilter>;
  blogPostsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockBlogPostsLinkingCollections = {
  __typename?: 'BlockBlogPostsLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
};


export type BlockBlogPostsLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockBlogPostsLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockBlogPostsLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockBlogPostsOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassy = Entry & _Node & {
  __typename?: 'BlockClassy';
  _id: Scalars['ID']['output'];
  campaignId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BlockClassyLinkingCollections>;
  recurringNudges?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyCampaignIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyRecurringNudgesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassySizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockClassy) */
export type BlockClassyTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockClassyCollection = {
  __typename?: 'BlockClassyCollection';
  items: Array<Maybe<BlockClassy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockClassyCursorCollection = {
  __typename?: 'BlockClassyCursorCollection';
  items: Array<Maybe<BlockClassy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockClassyFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockClassyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockClassyFilter>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignId_contains?: InputMaybe<Scalars['String']['input']>;
  campaignId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignId_not?: InputMaybe<Scalars['String']['input']>;
  campaignId_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  recurringNudges?: InputMaybe<Scalars['Boolean']['input']>;
  recurringNudges_exists?: InputMaybe<Scalars['Boolean']['input']>;
  recurringNudges_not?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockClassyLinkingCollections = {
  __typename?: 'BlockClassyLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockClassyLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockClassyLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockClassyLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockClassyOrder {
  CampaignIdAsc = 'campaignId_ASC',
  CampaignIdDesc = 'campaignId_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  RecurringNudgesAsc = 'recurringNudges_ASC',
  RecurringNudgesDesc = 'recurringNudges_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsible = Entry & _Node & {
  __typename?: 'BlockCollapsible';
  _id: Scalars['ID']['output'];
  block?: Maybe<BlockCollapsibleBlock>;
  collapsedBlock?: Maybe<BlockCollapsibleCollapsedBlock>;
  contentfulMetadata: ContentfulMetadata;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockCollapsibleLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsibleBlockArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsibleCollapsedBlockArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsibleCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsibleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCollapsible) */
export type BlockCollapsibleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockCollapsibleBlock = BlockClassy | BlockCustomComponent | BlockDonate | BlockElfsightWidget | BlockEmailCollection | BlockFormAssembly | BlockFundraiseUp | BlockImages | BlockImpactStatistics | BlockPeople | BlockPrograms | BlockQuotation | BlockShare | BlockThermometer | BlockVideo | BulletinBoard | Hero | LayoutCopy;

export type BlockCollapsibleCollapsedBlock = BlockClassy | BlockCustomComponent | BlockDonate | BlockElfsightWidget | BlockEmailCollection | BlockFormAssembly | BlockFundraiseUp | BlockImages | BlockImpactStatistics | BlockPeople | BlockPrograms | BlockQuotation | BlockShare | BlockThermometer | BlockVideo | BulletinBoard | LayoutCopy;

export type BlockCollapsibleCollection = {
  __typename?: 'BlockCollapsibleCollection';
  items: Array<Maybe<BlockCollapsible>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockCollapsibleCursorCollection = {
  __typename?: 'BlockCollapsibleCursorCollection';
  items: Array<Maybe<BlockCollapsible>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockCollapsibleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockCollapsibleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockCollapsibleFilter>>>;
  block_exists?: InputMaybe<Scalars['Boolean']['input']>;
  collapsedBlock_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockCollapsibleLinkingCollections = {
  __typename?: 'BlockCollapsibleLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockCollapsibleLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCollapsibleLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockCollapsibleLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCollapsibleOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCta = Entry & _Node & {
  __typename?: 'BlockCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<BlockCtaCopy>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockCtaCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockCtaCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BlockCtaLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCtaCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCtaCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCta) */
export type BlockCtaVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockCtaCollection = {
  __typename?: 'BlockCtaCollection';
  items: Array<Maybe<BlockCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockCtaCopy = {
  __typename?: 'BlockCtaCopy';
  json: Scalars['JSON']['output'];
  links: BlockCtaCopyLinks;
};

export type BlockCtaCopyAssets = {
  __typename?: 'BlockCtaCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlockCtaCopyEntries = {
  __typename?: 'BlockCtaCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlockCtaCopyLinks = {
  __typename?: 'BlockCtaCopyLinks';
  assets: BlockCtaCopyAssets;
  entries: BlockCtaCopyEntries;
  resources: BlockCtaCopyResources;
};

export type BlockCtaCopyResources = {
  __typename?: 'BlockCtaCopyResources';
  block: Array<BlockCtaCopyResourcesBlock>;
  hyperlink: Array<BlockCtaCopyResourcesHyperlink>;
  inline: Array<BlockCtaCopyResourcesInline>;
};

export type BlockCtaCopyResourcesBlock = ResourceLink & {
  __typename?: 'BlockCtaCopyResourcesBlock';
  sys: ResourceSys;
};

export type BlockCtaCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'BlockCtaCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type BlockCtaCopyResourcesInline = ResourceLink & {
  __typename?: 'BlockCtaCopyResourcesInline';
  sys: ResourceSys;
};

export type BlockCtaCtaLinkContentCollection = {
  __typename?: 'BlockCtaCtaLinkContentCollection';
  items: Array<Maybe<BlockCtaCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockCtaCtaLinkContentCursorCollection = {
  __typename?: 'BlockCtaCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockCtaCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockCtaCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockCtaCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockCtaCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockCtaCtaLinkContentItem = BlogPost | Page | Program;

export type BlockCtaCursorCollection = {
  __typename?: 'BlockCtaCursorCollection';
  items: Array<Maybe<BlockCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockCtaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockCtaLinkingCollections = {
  __typename?: 'BlockCtaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
};


export type BlockCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCtaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCtaLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCtaLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCtaLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockCtaLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCtaLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCtaLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCtaLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCtaOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCustomComponent) */
export type BlockCustomComponent = Entry & _Node & {
  __typename?: 'BlockCustomComponent';
  _id: Scalars['ID']['output'];
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockCustomComponentLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCustomComponent) */
export type BlockCustomComponentComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCustomComponent) */
export type BlockCustomComponentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockCustomComponent) */
export type BlockCustomComponentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockCustomComponentCollection = {
  __typename?: 'BlockCustomComponentCollection';
  items: Array<Maybe<BlockCustomComponent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockCustomComponentCursorCollection = {
  __typename?: 'BlockCustomComponentCursorCollection';
  items: Array<Maybe<BlockCustomComponent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockCustomComponentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockCustomComponentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockCustomComponentFilter>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockCustomComponentLinkingCollections = {
  __typename?: 'BlockCustomComponentLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockCustomComponentLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockCustomComponentLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockCustomComponentLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockCustomComponentOrder {
  ComponentNameAsc = 'componentName_ASC',
  ComponentNameDesc = 'componentName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonate = Entry & _Node & {
  __typename?: 'BlockDonate';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  donationAppealsCollection?: Maybe<BlockDonateDonationAppealsCollection>;
  donationAppealsCursorCollection?: Maybe<BlockDonateDonationAppealsCursorCollection>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockDonateLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateDonationAppealsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateDonationAppealsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateDonationAppealsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateDonationAppealsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockDonate) */
export type BlockDonateTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockDonateCollection = {
  __typename?: 'BlockDonateCollection';
  items: Array<Maybe<BlockDonate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockDonateCursorCollection = {
  __typename?: 'BlockDonateCursorCollection';
  items: Array<Maybe<BlockDonate>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockDonateDonationAppealsCollection = {
  __typename?: 'BlockDonateDonationAppealsCollection';
  items: Array<Maybe<DonationAppeal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockDonateDonationAppealsCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockDonateDonationAppealsCursorCollection = {
  __typename?: 'BlockDonateDonationAppealsCursorCollection';
  items: Array<Maybe<DonationAppeal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockDonateDonationAppealsCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockDonateFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockDonateFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockDonateFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  donationAppeals?: InputMaybe<CfDonationAppealNestedFilter>;
  donationAppealsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockDonateLinkingCollections = {
  __typename?: 'BlockDonateLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockDonateLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockDonateLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockDonateLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockDonateOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidget = Entry & _Node & {
  __typename?: 'BlockElfsightWidget';
  _id: Scalars['ID']['output'];
  appId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockElfsightWidgetLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetAppIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockElfsightWidget) */
export type BlockElfsightWidgetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockElfsightWidgetCollection = {
  __typename?: 'BlockElfsightWidgetCollection';
  items: Array<Maybe<BlockElfsightWidget>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockElfsightWidgetCursorCollection = {
  __typename?: 'BlockElfsightWidgetCursorCollection';
  items: Array<Maybe<BlockElfsightWidget>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockElfsightWidgetFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetFilter>>>;
  appId?: InputMaybe<Scalars['String']['input']>;
  appId_contains?: InputMaybe<Scalars['String']['input']>;
  appId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appId_not?: InputMaybe<Scalars['String']['input']>;
  appId_not_contains?: InputMaybe<Scalars['String']['input']>;
  appId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockElfsightWidgetLinkingCollections = {
  __typename?: 'BlockElfsightWidgetLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockElfsightWidgetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockElfsightWidgetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockElfsightWidgetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockElfsightWidgetLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockElfsightWidgetLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockElfsightWidgetLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockElfsightWidgetLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockElfsightWidgetOrder {
  AppIdAsc = 'appId_ASC',
  AppIdDesc = 'appId_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollection = Entry & _Node & {
  __typename?: 'BlockEmailCollection';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  formId?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockEmailCollectionLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  urlEndpoint?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionFormIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockEmailCollection) */
export type BlockEmailCollectionUrlEndpointArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockEmailCollectionCollection = {
  __typename?: 'BlockEmailCollectionCollection';
  items: Array<Maybe<BlockEmailCollection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockEmailCollectionCursorCollection = {
  __typename?: 'BlockEmailCollectionCursorCollection';
  items: Array<Maybe<BlockEmailCollection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockEmailCollectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockEmailCollectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockEmailCollectionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formId?: InputMaybe<Scalars['String']['input']>;
  formId_contains?: InputMaybe<Scalars['String']['input']>;
  formId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formId_not?: InputMaybe<Scalars['String']['input']>;
  formId_not_contains?: InputMaybe<Scalars['String']['input']>;
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlEndpoint?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint_contains?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  urlEndpoint_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urlEndpoint_not?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint_not_contains?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockEmailCollectionLinkingCollections = {
  __typename?: 'BlockEmailCollectionLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockEmailCollectionLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockEmailCollectionLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockEmailCollectionLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockEmailCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  FormIdAsc = 'formId_ASC',
  FormIdDesc = 'formId_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlEndpointAsc = 'urlEndpoint_ASC',
  UrlEndpointDesc = 'urlEndpoint_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFormAssembly) */
export type BlockFormAssembly = Entry & _Node & {
  __typename?: 'BlockFormAssembly';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  html?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockFormAssemblyLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFormAssembly) */
export type BlockFormAssemblyHtmlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFormAssembly) */
export type BlockFormAssemblyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFormAssembly) */
export type BlockFormAssemblySeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFormAssembly) */
export type BlockFormAssemblyTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFormAssemblyCollection = {
  __typename?: 'BlockFormAssemblyCollection';
  items: Array<Maybe<BlockFormAssembly>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockFormAssemblyCursorCollection = {
  __typename?: 'BlockFormAssemblyCursorCollection';
  items: Array<Maybe<BlockFormAssembly>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockFormAssemblyFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockFormAssemblyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockFormAssemblyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  html?: InputMaybe<Scalars['String']['input']>;
  html_contains?: InputMaybe<Scalars['String']['input']>;
  html_exists?: InputMaybe<Scalars['Boolean']['input']>;
  html_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  html_not?: InputMaybe<Scalars['String']['input']>;
  html_not_contains?: InputMaybe<Scalars['String']['input']>;
  html_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockFormAssemblyLinkingCollections = {
  __typename?: 'BlockFormAssemblyLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type BlockFormAssemblyLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFormAssemblyLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFormAssemblyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFormAssemblyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFormAssemblyLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFormAssemblyLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockFormAssemblyLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFormAssemblyLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFormAssemblyLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFormAssemblyLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFormAssemblyOrder {
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUp = Entry & _Node & {
  __typename?: 'BlockFundraiseUp';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  elementId?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BlockFundraiseUpLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  widgetType?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpElementIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockFundraiseUp) */
export type BlockFundraiseUpWidgetTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockFundraiseUpCollection = {
  __typename?: 'BlockFundraiseUpCollection';
  items: Array<Maybe<BlockFundraiseUp>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockFundraiseUpCursorCollection = {
  __typename?: 'BlockFundraiseUpCursorCollection';
  items: Array<Maybe<BlockFundraiseUp>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockFundraiseUpFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockFundraiseUpFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockFundraiseUpFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  elementId?: InputMaybe<Scalars['String']['input']>;
  elementId_contains?: InputMaybe<Scalars['String']['input']>;
  elementId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  elementId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  elementId_not?: InputMaybe<Scalars['String']['input']>;
  elementId_not_contains?: InputMaybe<Scalars['String']['input']>;
  elementId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  widgetType?: InputMaybe<Scalars['String']['input']>;
  widgetType_contains?: InputMaybe<Scalars['String']['input']>;
  widgetType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  widgetType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  widgetType_not?: InputMaybe<Scalars['String']['input']>;
  widgetType_not_contains?: InputMaybe<Scalars['String']['input']>;
  widgetType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockFundraiseUpLinkingCollections = {
  __typename?: 'BlockFundraiseUpLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockFundraiseUpLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockFundraiseUpLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockFundraiseUpLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockFundraiseUpOrder {
  ElementIdAsc = 'elementId_ASC',
  ElementIdDesc = 'elementId_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  WidgetTypeAsc = 'widgetType_ASC',
  WidgetTypeDesc = 'widgetType_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlight = Entry & _Node & {
  __typename?: 'BlockHighlight';
  _id: Scalars['ID']['output'];
  aspectRatio?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockHighlightCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockHighlightCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  ctaVariant?: Maybe<Scalars['String']['output']>;
  decoration?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockHighlightLinkingCollections>;
  reversed?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  text?: Maybe<BlockHighlightText>;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  videoAsset?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockHighlightCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockHighlightCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightCtaVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightDecorationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightReversedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockHighlight) */
export type BlockHighlightVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockHighlightCollection = {
  __typename?: 'BlockHighlightCollection';
  items: Array<Maybe<BlockHighlight>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockHighlightCtaLinkContentCollection = {
  __typename?: 'BlockHighlightCtaLinkContentCollection';
  items: Array<Maybe<BlockHighlightCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockHighlightCtaLinkContentCursorCollection = {
  __typename?: 'BlockHighlightCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockHighlightCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockHighlightCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockHighlightCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockHighlightCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockHighlightCtaLinkContentItem = BlogPost | Page | Program;

export type BlockHighlightCursorCollection = {
  __typename?: 'BlockHighlightCursorCollection';
  items: Array<Maybe<BlockHighlight>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockHighlightFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockHighlightFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockHighlightFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background?: InputMaybe<Scalars['String']['input']>;
  background_contains?: InputMaybe<Scalars['String']['input']>;
  background_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_not?: InputMaybe<Scalars['String']['input']>;
  background_not_contains?: InputMaybe<Scalars['String']['input']>;
  background_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaVariant?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaVariant_not?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decoration?: InputMaybe<Scalars['String']['input']>;
  decoration_contains?: InputMaybe<Scalars['String']['input']>;
  decoration_exists?: InputMaybe<Scalars['Boolean']['input']>;
  decoration_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decoration_not?: InputMaybe<Scalars['String']['input']>;
  decoration_not_contains?: InputMaybe<Scalars['String']['input']>;
  decoration_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  reversed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reversed_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockHighlightLinkingCollections = {
  __typename?: 'BlockHighlightLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockHighlightLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHighlightLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockHighlightLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockHighlightOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type BlockHighlightText = {
  __typename?: 'BlockHighlightText';
  json: Scalars['JSON']['output'];
  links: BlockHighlightTextLinks;
};

export type BlockHighlightTextAssets = {
  __typename?: 'BlockHighlightTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlockHighlightTextEntries = {
  __typename?: 'BlockHighlightTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlockHighlightTextLinks = {
  __typename?: 'BlockHighlightTextLinks';
  assets: BlockHighlightTextAssets;
  entries: BlockHighlightTextEntries;
  resources: BlockHighlightTextResources;
};

export type BlockHighlightTextResources = {
  __typename?: 'BlockHighlightTextResources';
  block: Array<BlockHighlightTextResourcesBlock>;
  hyperlink: Array<BlockHighlightTextResourcesHyperlink>;
  inline: Array<BlockHighlightTextResourcesInline>;
};

export type BlockHighlightTextResourcesBlock = ResourceLink & {
  __typename?: 'BlockHighlightTextResourcesBlock';
  sys: ResourceSys;
};

export type BlockHighlightTextResourcesHyperlink = ResourceLink & {
  __typename?: 'BlockHighlightTextResourcesHyperlink';
  sys: ResourceSys;
};

export type BlockHighlightTextResourcesInline = ResourceLink & {
  __typename?: 'BlockHighlightTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImages = Entry & _Node & {
  __typename?: 'BlockImages';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockImagesCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockImagesCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  imagesCollection?: Maybe<AssetCollection>;
  imagesCursorCollection?: Maybe<AssetCursorCollection>;
  linkedFrom?: Maybe<BlockImagesLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImagesCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImagesCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImages) */
export type BlockImagesTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImagesCollection = {
  __typename?: 'BlockImagesCollection';
  items: Array<Maybe<BlockImages>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockImagesCtaLinkContentCollection = {
  __typename?: 'BlockImagesCtaLinkContentCollection';
  items: Array<Maybe<BlockImagesCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockImagesCtaLinkContentCursorCollection = {
  __typename?: 'BlockImagesCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockImagesCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockImagesCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockImagesCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockImagesCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockImagesCtaLinkContentItem = BlogPost | Page | Program;

export type BlockImagesCursorCollection = {
  __typename?: 'BlockImagesCursorCollection';
  items: Array<Maybe<BlockImages>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockImagesFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockImagesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockImagesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockImagesLinkingCollections = {
  __typename?: 'BlockImagesLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockImagesLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImagesLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockImagesLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImagesOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatistics = Entry & _Node & {
  __typename?: 'BlockImpactStatistics';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockImpactStatisticsCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockImpactStatisticsCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockImpactStatisticsLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  statisticsCollection?: Maybe<BlockImpactStatisticsStatisticsCollection>;
  statisticsCursorCollection?: Maybe<BlockImpactStatisticsStatisticsCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImpactStatisticsCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImpactStatisticsCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsStatisticsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsStatisticsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockImpactStatistics) */
export type BlockImpactStatisticsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockImpactStatisticsCollection = {
  __typename?: 'BlockImpactStatisticsCollection';
  items: Array<Maybe<BlockImpactStatistics>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockImpactStatisticsCtaLinkContentCollection = {
  __typename?: 'BlockImpactStatisticsCtaLinkContentCollection';
  items: Array<Maybe<BlockImpactStatisticsCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockImpactStatisticsCtaLinkContentCursorCollection = {
  __typename?: 'BlockImpactStatisticsCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockImpactStatisticsCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockImpactStatisticsCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockImpactStatisticsCtaLinkContentItem = BlogPost | Page | Program;

export type BlockImpactStatisticsCursorCollection = {
  __typename?: 'BlockImpactStatisticsCursorCollection';
  items: Array<Maybe<BlockImpactStatistics>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockImpactStatisticsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statistics?: InputMaybe<CfStatisticNestedFilter>;
  statisticsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockImpactStatisticsLinkingCollections = {
  __typename?: 'BlockImpactStatisticsLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockImpactStatisticsLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockImpactStatisticsOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockImpactStatisticsStatisticsCollection = {
  __typename?: 'BlockImpactStatisticsStatisticsCollection';
  items: Array<Maybe<Statistic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockImpactStatisticsStatisticsCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockImpactStatisticsStatisticsCursorCollection = {
  __typename?: 'BlockImpactStatisticsStatisticsCursorCollection';
  items: Array<Maybe<Statistic>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockImpactStatisticsStatisticsCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartners = Entry & _Node & {
  __typename?: 'BlockPartners';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockPartnersCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockPartnersCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockPartnersLinkingCollections>;
  partnersCollection?: Maybe<BlockPartnersPartnersCollection>;
  partnersCursorCollection?: Maybe<BlockPartnersPartnersCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPartnersCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPartnersCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersPartnersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersPartnersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPartners) */
export type BlockPartnersTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPartnersCollection = {
  __typename?: 'BlockPartnersCollection';
  items: Array<Maybe<BlockPartners>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockPartnersCtaLinkContentCollection = {
  __typename?: 'BlockPartnersCtaLinkContentCollection';
  items: Array<Maybe<BlockPartnersCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockPartnersCtaLinkContentCursorCollection = {
  __typename?: 'BlockPartnersCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockPartnersCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockPartnersCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockPartnersCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockPartnersCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockPartnersCtaLinkContentItem = BlogPost | Page | Program;

export type BlockPartnersCursorCollection = {
  __typename?: 'BlockPartnersCursorCollection';
  items: Array<Maybe<BlockPartners>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockPartnersFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockPartnersFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockPartnersFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout?: InputMaybe<Scalars['String']['input']>;
  layout_contains?: InputMaybe<Scalars['String']['input']>;
  layout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  layout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout_not?: InputMaybe<Scalars['String']['input']>;
  layout_not_contains?: InputMaybe<Scalars['String']['input']>;
  layout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partners?: InputMaybe<CfPartnerNestedFilter>;
  partnersCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockPartnersLinkingCollections = {
  __typename?: 'BlockPartnersLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type BlockPartnersLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPartnersLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPartnersLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPartnersLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockPartnersLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPartnersLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPartnersOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockPartnersPartnersCollection = {
  __typename?: 'BlockPartnersPartnersCollection';
  items: Array<Maybe<Partner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockPartnersPartnersCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockPartnersPartnersCursorCollection = {
  __typename?: 'BlockPartnersPartnersCursorCollection';
  items: Array<Maybe<Partner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockPartnersPartnersCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeople = Entry & _Node & {
  __typename?: 'BlockPeople';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockPeopleLinkingCollections>;
  peopleCollection?: Maybe<BlockPeoplePeopleCollection>;
  peopleCursorCollection?: Maybe<BlockPeoplePeopleCursorCollection>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeopleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeopleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeopleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeoplePeopleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeoplePeopleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeoplePeopleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeoplePeopleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeopleSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPeople) */
export type BlockPeopleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockPeopleCollection = {
  __typename?: 'BlockPeopleCollection';
  items: Array<Maybe<BlockPeople>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockPeopleCursorCollection = {
  __typename?: 'BlockPeopleCursorCollection';
  items: Array<Maybe<BlockPeople>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockPeopleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockPeopleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockPeopleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  people?: InputMaybe<CfPersonNestedFilter>;
  peopleCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockPeopleLinkingCollections = {
  __typename?: 'BlockPeopleLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockPeopleLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockPeopleLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockPeopleLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockPeopleOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockPeoplePeopleCollection = {
  __typename?: 'BlockPeoplePeopleCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockPeoplePeopleCollectionOrder {
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPeoplePeopleCursorCollection = {
  __typename?: 'BlockPeoplePeopleCursorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockPeoplePeopleCursorCollectionOrder {
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockPrograms = Entry & _Node & {
  __typename?: 'BlockPrograms';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockProgramsLinkingCollections>;
  programsCollection?: Maybe<BlockProgramsProgramsCollection>;
  programsCursorCollection?: Maybe<BlockProgramsProgramsCursorCollection>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsProgramsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsProgramsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsProgramsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsProgramsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockPrograms) */
export type BlockProgramsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockProgramsCollection = {
  __typename?: 'BlockProgramsCollection';
  items: Array<Maybe<BlockPrograms>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockProgramsCursorCollection = {
  __typename?: 'BlockProgramsCursorCollection';
  items: Array<Maybe<BlockPrograms>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockProgramsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockProgramsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockProgramsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  programs?: InputMaybe<CfProgramNestedFilter>;
  programsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockProgramsLinkingCollections = {
  __typename?: 'BlockProgramsLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockProgramsLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockProgramsLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockProgramsLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockProgramsOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockProgramsProgramsCollection = {
  __typename?: 'BlockProgramsProgramsCollection';
  items: Array<Maybe<Program>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockProgramsProgramsCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockProgramsProgramsCursorCollection = {
  __typename?: 'BlockProgramsProgramsCursorCollection';
  items: Array<Maybe<Program>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockProgramsProgramsCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotation = Entry & _Node & {
  __typename?: 'BlockQuotation';
  _id: Scalars['ID']['output'];
  attribution?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockQuotationCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockQuotationCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BlockQuotationLinkingCollections>;
  quote?: Maybe<Scalars['String']['output']>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationAttributionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationQuoteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotation) */
export type BlockQuotationVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockQuotationCollection = {
  __typename?: 'BlockQuotationCollection';
  items: Array<Maybe<BlockQuotation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockQuotationCtaLinkContentCollection = {
  __typename?: 'BlockQuotationCtaLinkContentCollection';
  items: Array<Maybe<BlockQuotationCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockQuotationCtaLinkContentCursorCollection = {
  __typename?: 'BlockQuotationCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockQuotationCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockQuotationCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockQuotationCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockQuotationCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockQuotationCtaLinkContentItem = BlogPost | Page | Program;

export type BlockQuotationCursorCollection = {
  __typename?: 'BlockQuotationCursorCollection';
  items: Array<Maybe<BlockQuotation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockQuotationFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockQuotationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockQuotationFilter>>>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  attribution_contains?: InputMaybe<Scalars['String']['input']>;
  attribution_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribution_not?: InputMaybe<Scalars['String']['input']>;
  attribution_not_contains?: InputMaybe<Scalars['String']['input']>;
  attribution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  quote_contains?: InputMaybe<Scalars['String']['input']>;
  quote_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote_not?: InputMaybe<Scalars['String']['input']>;
  quote_not_contains?: InputMaybe<Scalars['String']['input']>;
  quote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockQuotationLinkingCollections = {
  __typename?: 'BlockQuotationLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blockQuotationsCollection?: Maybe<BlockQuotationsCollection>;
  blockQuotationsCursorCollection?: Maybe<BlockQuotationsCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockQuotationLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsBlockQuotationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlockQuotationsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsBlockQuotationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlockQuotationsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockQuotationLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsBlockQuotationsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlockQuotationLinkingCollectionsBlockQuotationsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlockQuotationLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotations = Entry & _Node & {
  __typename?: 'BlockQuotations';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockQuotationsLinkingCollections>;
  quotationsCollection?: Maybe<BlockQuotationsQuotationsCollection>;
  quotationsCursorCollection?: Maybe<BlockQuotationsQuotationsCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotationsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotationsQuotationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsQuotationsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotationsQuotationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsQuotationsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotationsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockQuotations) */
export type BlockQuotationsVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockQuotationsCollection = {
  __typename?: 'BlockQuotationsCollection';
  items: Array<Maybe<BlockQuotations>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockQuotationsCursorCollection = {
  __typename?: 'BlockQuotationsCursorCollection';
  items: Array<Maybe<BlockQuotations>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockQuotationsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockQuotationsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockQuotationsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  quotations?: InputMaybe<CfBlockQuotationNestedFilter>;
  quotationsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockQuotationsLinkingCollections = {
  __typename?: 'BlockQuotationsLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockQuotationsLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockQuotationsLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockQuotationsLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockQuotationsOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type BlockQuotationsQuotationsCollection = {
  __typename?: 'BlockQuotationsQuotationsCollection';
  items: Array<Maybe<BlockQuotation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockQuotationsQuotationsCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type BlockQuotationsQuotationsCursorCollection = {
  __typename?: 'BlockQuotationsQuotationsCursorCollection';
  items: Array<Maybe<BlockQuotation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockQuotationsQuotationsCursorCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShare = Entry & _Node & {
  __typename?: 'BlockShare';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockShareLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockShare) */
export type BlockShareUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockShareCollection = {
  __typename?: 'BlockShareCollection';
  items: Array<Maybe<BlockShare>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockShareCursorCollection = {
  __typename?: 'BlockShareCursorCollection';
  items: Array<Maybe<BlockShare>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockShareFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockShareFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockShareFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockShareLinkingCollections = {
  __typename?: 'BlockShareLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type BlockShareLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockShareLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockShareLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockShareLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockShareLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockShareLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockShareLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockShareLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockShareLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockShareLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockShareOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockTabs) */
export type BlockTabs = Entry & _Node & {
  __typename?: 'BlockTabs';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockTabsLinkingCollections>;
  sys: Sys;
  tabsCollection?: Maybe<BlockTabsTabsCollection>;
  tabsCursorCollection?: Maybe<BlockTabsTabsCursorCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockTabs) */
export type BlockTabsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockTabs) */
export type BlockTabsTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockTabs) */
export type BlockTabsTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsTabsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockTabs) */
export type BlockTabsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockTabsCollection = {
  __typename?: 'BlockTabsCollection';
  items: Array<Maybe<BlockTabs>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockTabsCursorCollection = {
  __typename?: 'BlockTabsCursorCollection';
  items: Array<Maybe<BlockTabs>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockTabsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockTabsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockTabsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tabs?: InputMaybe<CfTabNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockTabsLinkingCollections = {
  __typename?: 'BlockTabsLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockTabsLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockTabsLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockTabsLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockTabsOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockTabsTabsCollection = {
  __typename?: 'BlockTabsTabsCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlockTabsTabsCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlockTabsTabsCursorCollection = {
  __typename?: 'BlockTabsTabsCursorCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlockTabsTabsCursorCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometer = Entry & _Node & {
  __typename?: 'BlockThermometer';
  _id: Scalars['ID']['output'];
  amountGoal?: Maybe<Scalars['Int']['output']>;
  amountRaised?: Maybe<Scalars['Float']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockThermometerLinkingCollections>;
  milestones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometerAmountGoalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometerAmountRaisedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometerMilestonesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockThermometer) */
export type BlockThermometerTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockThermometerCollection = {
  __typename?: 'BlockThermometerCollection';
  items: Array<Maybe<BlockThermometer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockThermometerCursorCollection = {
  __typename?: 'BlockThermometerCursorCollection';
  items: Array<Maybe<BlockThermometer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockThermometerFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockThermometerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockThermometerFilter>>>;
  amountGoal?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  amountGoal_gt?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_gte?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  amountGoal_lt?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_lte?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_not?: InputMaybe<Scalars['Int']['input']>;
  amountGoal_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  amountRaised?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_exists?: InputMaybe<Scalars['Boolean']['input']>;
  amountRaised_gt?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_gte?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amountRaised_lt?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_lte?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_not?: InputMaybe<Scalars['Float']['input']>;
  amountRaised_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  milestones_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  milestones_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  milestones_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  milestones_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockThermometerLinkingCollections = {
  __typename?: 'BlockThermometerLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type BlockThermometerLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockThermometerLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockThermometerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockThermometerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockThermometerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockThermometerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockThermometerLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockThermometerLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockThermometerLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockThermometerLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockThermometerOrder {
  AmountGoalAsc = 'amountGoal_ASC',
  AmountGoalDesc = 'amountGoal_DESC',
  AmountRaisedAsc = 'amountRaised_ASC',
  AmountRaisedDesc = 'amountRaised_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideo = Entry & _Node & {
  __typename?: 'BlockVideo';
  _id: Scalars['ID']['output'];
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BlockVideoCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BlockVideoCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BlockVideoLinkingCollections>;
  playerSize?: Maybe<Scalars['String']['output']>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnail?: Maybe<Asset>;
  title?: Maybe<Scalars['String']['output']>;
  videoAsset?: Maybe<Asset>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoAutoplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockVideoCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockVideoCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoPlayerSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoThumbnailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blockVideo) */
export type BlockVideoVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockVideoCollection = {
  __typename?: 'BlockVideoCollection';
  items: Array<Maybe<BlockVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockVideoCtaLinkContentCollection = {
  __typename?: 'BlockVideoCtaLinkContentCollection';
  items: Array<Maybe<BlockVideoCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlockVideoCtaLinkContentCursorCollection = {
  __typename?: 'BlockVideoCtaLinkContentCursorCollection';
  items: Array<Maybe<BlockVideoCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockVideoCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockVideoCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockVideoCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockVideoCtaLinkContentItem = BlogPost | Page | Program;

export type BlockVideoCursorCollection = {
  __typename?: 'BlockVideoCursorCollection';
  items: Array<Maybe<BlockVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlockVideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlockVideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlockVideoFilter>>>;
  autoplay?: InputMaybe<Scalars['Boolean']['input']>;
  autoplay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoplay_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playerSize?: InputMaybe<Scalars['String']['input']>;
  playerSize_contains?: InputMaybe<Scalars['String']['input']>;
  playerSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  playerSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  playerSize_not?: InputMaybe<Scalars['String']['input']>;
  playerSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  playerSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  thumbnail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockVideoLinkingCollections = {
  __typename?: 'BlockVideoLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BlockVideoLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockVideoLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlockVideoLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlockVideoOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogCategory) */
export type BlogCategory = Entry & _Node & {
  __typename?: 'BlogCategory';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Asset>;
  linkedFrom?: Maybe<BlogCategoryLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogCategory) */
export type BlogCategoryColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogCategory) */
export type BlogCategoryIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogCategory) */
export type BlogCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogCategory) */
export type BlogCategoryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogCategoryCollection = {
  __typename?: 'BlogCategoryCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogCategoryCursorCollection = {
  __typename?: 'BlogCategoryCursorCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogCategoryLinkingCollections = {
  __typename?: 'BlogCategoryLinkingCollections';
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BlogCategoryLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlogCategoryLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogCategoryLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogCategoryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPost = Entry & _Node & {
  __typename?: 'BlogPost';
  _id: Scalars['ID']['output'];
  authorsCollection?: Maybe<BlogPostAuthorsCollection>;
  authorsCursorCollection?: Maybe<BlogPostAuthorsCursorCollection>;
  categoriesCollection?: Maybe<BlogPostCategoriesCollection>;
  categoriesCursorCollection?: Maybe<BlogPostCategoriesCursorCollection>;
  closerBlocksCollection?: Maybe<BlogPostCloserBlocksCollection>;
  closerBlocksCursorCollection?: Maybe<BlogPostCloserBlocksCursorCollection>;
  contentBlocksCollection?: Maybe<BlogPostContentBlocksCollection>;
  contentBlocksCursorCollection?: Maybe<BlogPostContentBlocksCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  date?: Maybe<Scalars['DateTime']['output']>;
  featuredOrder?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<BlogPostLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostAuthorsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostAuthorsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostAuthorsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostAuthorsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostCategoriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostCategoriesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostCloserBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostCloserBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostCloserBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostCloserBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostFeaturedOrderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostMetaKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/blogPost) */
export type BlogPostTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogPostAuthorsCollection = {
  __typename?: 'BlogPostAuthorsCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlogPostAuthorsCollectionOrder {
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlogPostAuthorsCursorCollection = {
  __typename?: 'BlogPostAuthorsCursorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlogPostAuthorsCursorCollectionOrder {
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlogPostCategoriesCollection = {
  __typename?: 'BlogPostCategoriesCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BlogPostCategoriesCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlogPostCategoriesCursorCollection = {
  __typename?: 'BlogPostCategoriesCursorCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BlogPostCategoriesCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlogPostCloserBlocksCollection = {
  __typename?: 'BlogPostCloserBlocksCollection';
  items: Array<Maybe<BlogPostCloserBlocksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogPostCloserBlocksCursorCollection = {
  __typename?: 'BlogPostCloserBlocksCursorCollection';
  items: Array<Maybe<BlogPostCloserBlocksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogPostCloserBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogPostCloserBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogPostCloserBlocksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostCloserBlocksItem = BlockBlogPosts | BlockEmailCollection | BlockHighlight | BulletinBoard;

export type BlogPostCollection = {
  __typename?: 'BlogPostCollection';
  items: Array<Maybe<BlogPost>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogPostContentBlocksCollection = {
  __typename?: 'BlogPostContentBlocksCollection';
  items: Array<Maybe<BlogPostContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogPostContentBlocksCursorCollection = {
  __typename?: 'BlogPostContentBlocksCursorCollection';
  items: Array<Maybe<BlogPostContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogPostContentBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogPostContentBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogPostContentBlocksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostContentBlocksItem = BlockClassy | BlockCollapsible | BlockDonate | BlockEmailCollection | BlockFundraiseUp | BlockHighlight | BlockImages | BlockImpactStatistics | BlockPeople | BlockPrograms | BlockQuotation | BlockQuotations | BlockTabs | BlockVideo | BulletinBoard | LayoutCopy;

export type BlogPostCursorCollection = {
  __typename?: 'BlogPostCursorCollection';
  items: Array<Maybe<BlogPost>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogPostFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogPostFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogPostFilter>>>;
  authors?: InputMaybe<CfPersonNestedFilter>;
  authorsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<CfBlogCategoryNestedFilter>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  closerBlocks?: InputMaybe<CfcloserBlocksMultiTypeNestedFilter>;
  closerBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentBlocks?: InputMaybe<CfcontentBlocksMultiTypeNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  featuredOrder?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featuredOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featuredOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_not?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_not?: InputMaybe<Scalars['String']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostLinkingCollections = {
  __typename?: 'BlogPostLinkingCollections';
  blockBlogPostsCollection?: Maybe<BlockBlogPostsCollection>;
  blockBlogPostsCursorCollection?: Maybe<BlockBlogPostsCursorCollection>;
  blockCtaCollection?: Maybe<BlockCtaCollection>;
  blockCtaCursorCollection?: Maybe<BlockCtaCursorCollection>;
  blockHighlightCollection?: Maybe<BlockHighlightCollection>;
  blockHighlightCursorCollection?: Maybe<BlockHighlightCursorCollection>;
  blockImagesCollection?: Maybe<BlockImagesCollection>;
  blockImagesCursorCollection?: Maybe<BlockImagesCursorCollection>;
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  blockQuotationCollection?: Maybe<BlockQuotationCollection>;
  blockQuotationCursorCollection?: Maybe<BlockQuotationCursorCollection>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  blockVideoCursorCollection?: Maybe<BlockVideoCursorCollection>;
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  donationAppealCollection?: Maybe<DonationAppealCollection>;
  donationAppealCursorCollection?: Maybe<DonationAppealCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroCursorCollection?: Maybe<HeroCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
  layoutCopyCollection?: Maybe<LayoutCopyCollection>;
  layoutCopyCursorCollection?: Maybe<LayoutCopyCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  statisticCollection?: Maybe<StatisticCollection>;
  statisticCursorCollection?: Maybe<StatisticCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type BlogPostLinkingCollectionsBlockBlogPostsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockBlogPostsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockBlogPostsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockBlogPostsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockHighlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockHighlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockImagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockImpactStatisticsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockPartnersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockPartnersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockQuotationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockQuotationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockQuotationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockQuotationCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockVideoCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBlockVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBlockVideoCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBulletinBoardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBulletinBoardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBulletinCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsBulletinCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsDonationAppealCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsDonationAppealCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsDonationAppealCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsDonationAppealCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsKnowledgeBasedResourceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsLayoutCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsLayoutCopyCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsLayoutCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsLayoutCopyCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsStatisticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsStatisticCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsStatisticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsStatisticCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlogPostLinkingCollectionsBlockBlogPostsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockBlogPostsCursorCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockCtaCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockCtaCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockHighlightCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockHighlightCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockImagesCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockImagesCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockImpactStatisticsCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockPartnersCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockPartnersCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBlockQuotationCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockQuotationCursorCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum BlogPostLinkingCollectionsBlockVideoCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum BlogPostLinkingCollectionsBlockVideoCursorCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum BlogPostLinkingCollectionsBulletinBoardCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BlogPostLinkingCollectionsBulletinBoardCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BlogPostLinkingCollectionsBulletinCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsBulletinCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsDonationAppealCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsDonationAppealCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsHeroCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsHeroCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsKnowledgeBasedResourceCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsLayoutCopyCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BlogPostLinkingCollectionsLayoutCopyCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BlogPostLinkingCollectionsNavigationLinkCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsNavigationLinkCursorCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsStatisticCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsStatisticCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsTabCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostLinkingCollectionsTabCursorCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogPostOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type Bulletin = Entry & _Node & {
  __typename?: 'Bulletin';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BulletinCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BulletinCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  internalTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BulletinLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletin) */
export type BulletinTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoard = Entry & _Node & {
  __typename?: 'BulletinBoard';
  _id: Scalars['ID']['output'];
  bulletinsCollection?: Maybe<BulletinBoardBulletinsCollection>;
  bulletinsCursorCollection?: Maybe<BulletinBoardBulletinsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<BulletinBoardCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<BulletinBoardCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BulletinBoardLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  visualStyle?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardBulletinsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardBulletinsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardBulletinsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardBulletinsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinBoardCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinBoardCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/bulletinBoard) */
export type BulletinBoardVisualStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulletinBoardBulletinsCollection = {
  __typename?: 'BulletinBoardBulletinsCollection';
  items: Array<Maybe<Bulletin>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BulletinBoardBulletinsCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BulletinBoardBulletinsCursorCollection = {
  __typename?: 'BulletinBoardBulletinsCursorCollection';
  items: Array<Maybe<Bulletin>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BulletinBoardBulletinsCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BulletinBoardCollection = {
  __typename?: 'BulletinBoardCollection';
  items: Array<Maybe<BulletinBoard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulletinBoardCtaLinkContentCollection = {
  __typename?: 'BulletinBoardCtaLinkContentCollection';
  items: Array<Maybe<BulletinBoardCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulletinBoardCtaLinkContentCursorCollection = {
  __typename?: 'BulletinBoardCtaLinkContentCursorCollection';
  items: Array<Maybe<BulletinBoardCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BulletinBoardCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BulletinBoardCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BulletinBoardCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulletinBoardCtaLinkContentItem = BlogPost | Page | Program;

export type BulletinBoardCursorCollection = {
  __typename?: 'BulletinBoardCursorCollection';
  items: Array<Maybe<BulletinBoard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BulletinBoardFilter = {
  AND?: InputMaybe<Array<InputMaybe<BulletinBoardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BulletinBoardFilter>>>;
  bulletins?: InputMaybe<CfBulletinNestedFilter>;
  bulletinsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualStyle?: InputMaybe<Scalars['String']['input']>;
  visualStyle_contains?: InputMaybe<Scalars['String']['input']>;
  visualStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visualStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualStyle_not?: InputMaybe<Scalars['String']['input']>;
  visualStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  visualStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulletinBoardLinkingCollections = {
  __typename?: 'BulletinBoardLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type BulletinBoardLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinBoardLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BulletinBoardLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BulletinBoardOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export type BulletinCollection = {
  __typename?: 'BulletinCollection';
  items: Array<Maybe<Bulletin>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulletinCtaLinkContentCollection = {
  __typename?: 'BulletinCtaLinkContentCollection';
  items: Array<Maybe<BulletinCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulletinCtaLinkContentCursorCollection = {
  __typename?: 'BulletinCtaLinkContentCursorCollection';
  items: Array<Maybe<BulletinCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BulletinCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BulletinCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BulletinCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulletinCtaLinkContentItem = BlogPost | Page | PressRelease | Program;

export type BulletinCursorCollection = {
  __typename?: 'BulletinCursorCollection';
  items: Array<Maybe<Bulletin>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BulletinFilter = {
  AND?: InputMaybe<Array<InputMaybe<BulletinFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BulletinFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BulletinLinkingCollections = {
  __typename?: 'BulletinLinkingCollections';
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BulletinLinkingCollectionsBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinLinkingCollectionsBulletinBoardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinLinkingCollectionsBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinLinkingCollectionsBulletinBoardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BulletinLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BulletinLinkingCollectionsBulletinBoardCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BulletinLinkingCollectionsBulletinBoardCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum BulletinOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CursorPages = {
  __typename?: 'CursorPages';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppeal = Entry & _Node & {
  __typename?: 'DonationAppeal';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<DonationAppealCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<DonationAppealCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<DonationAppealLinkingCollections>;
  moreLink?: Maybe<Scalars['String']['output']>;
  moreLinkAsset?: Maybe<Asset>;
  moreLinkContentCollection?: Maybe<DonationAppealMoreLinkContentCollection>;
  moreLinkContentCursorCollection?: Maybe<DonationAppealMoreLinkContentCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealMoreLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealMoreLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealMoreLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealMoreLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealMoreLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealMoreLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/donationAppeal) */
export type DonationAppealTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationAppealCollection = {
  __typename?: 'DonationAppealCollection';
  items: Array<Maybe<DonationAppeal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DonationAppealCtaLinkContentCollection = {
  __typename?: 'DonationAppealCtaLinkContentCollection';
  items: Array<Maybe<DonationAppealCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DonationAppealCtaLinkContentCursorCollection = {
  __typename?: 'DonationAppealCtaLinkContentCursorCollection';
  items: Array<Maybe<DonationAppealCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DonationAppealCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<DonationAppealCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationAppealCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationAppealCtaLinkContentItem = BlogPost | Page | Program;

export type DonationAppealCursorCollection = {
  __typename?: 'DonationAppealCursorCollection';
  items: Array<Maybe<DonationAppeal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DonationAppealFilter = {
  AND?: InputMaybe<Array<InputMaybe<DonationAppealFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationAppealFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink?: InputMaybe<Scalars['String']['input']>;
  moreLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLinkContent?: InputMaybe<CfmoreLinkContentMultiTypeNestedFilter>;
  moreLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink_contains?: InputMaybe<Scalars['String']['input']>;
  moreLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moreLink_not?: InputMaybe<Scalars['String']['input']>;
  moreLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  moreLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationAppealLinkingCollections = {
  __typename?: 'DonationAppealLinkingCollections';
  blockDonateCollection?: Maybe<BlockDonateCollection>;
  blockDonateCursorCollection?: Maybe<BlockDonateCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type DonationAppealLinkingCollectionsBlockDonateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DonationAppealLinkingCollectionsBlockDonateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DonationAppealLinkingCollectionsBlockDonateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DonationAppealLinkingCollectionsBlockDonateCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DonationAppealLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DonationAppealLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DonationAppealLinkingCollectionsBlockDonateCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum DonationAppealLinkingCollectionsBlockDonateCursorCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type DonationAppealMoreLinkContentCollection = {
  __typename?: 'DonationAppealMoreLinkContentCollection';
  items: Array<Maybe<DonationAppealMoreLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DonationAppealMoreLinkContentCursorCollection = {
  __typename?: 'DonationAppealMoreLinkContentCursorCollection';
  items: Array<Maybe<DonationAppealMoreLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DonationAppealMoreLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<DonationAppealMoreLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationAppealMoreLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationAppealMoreLinkContentItem = BlogPost | Page | Program;

export enum DonationAppealOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedInstagram) */
export type EmbedInstagram = Entry & _Node & {
  __typename?: 'EmbedInstagram';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<EmbedInstagramLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedInstagram) */
export type EmbedInstagramLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedInstagram) */
export type EmbedInstagramTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedInstagram) */
export type EmbedInstagramUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmbedInstagramCollection = {
  __typename?: 'EmbedInstagramCollection';
  items: Array<Maybe<EmbedInstagram>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EmbedInstagramCursorCollection = {
  __typename?: 'EmbedInstagramCursorCollection';
  items: Array<Maybe<EmbedInstagram>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EmbedInstagramFilter = {
  AND?: InputMaybe<Array<InputMaybe<EmbedInstagramFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EmbedInstagramFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmbedInstagramLinkingCollections = {
  __typename?: 'EmbedInstagramLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type EmbedInstagramLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmbedInstagramLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EmbedInstagramOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedTwitter) */
export type EmbedTwitter = Entry & _Node & {
  __typename?: 'EmbedTwitter';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<EmbedTwitterLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedTwitter) */
export type EmbedTwitterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedTwitter) */
export type EmbedTwitterTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/embedTwitter) */
export type EmbedTwitterUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmbedTwitterCollection = {
  __typename?: 'EmbedTwitterCollection';
  items: Array<Maybe<EmbedTwitter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EmbedTwitterCursorCollection = {
  __typename?: 'EmbedTwitterCursorCollection';
  items: Array<Maybe<EmbedTwitter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EmbedTwitterFilter = {
  AND?: InputMaybe<Array<InputMaybe<EmbedTwitterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EmbedTwitterFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmbedTwitterLinkingCollections = {
  __typename?: 'EmbedTwitterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type EmbedTwitterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmbedTwitterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EmbedTwitterOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
  __typename?: 'EntryCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type Hero = Entry & _Node & {
  __typename?: 'Hero';
  _id: Scalars['ID']['output'];
  aspectRatio?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaLinkAssetPrimary?: Maybe<Asset>;
  ctaLinkAssetSecondary?: Maybe<Asset>;
  ctaLinkContentPrimaryCollection?: Maybe<HeroCtaLinkContentPrimaryCollection>;
  ctaLinkContentPrimaryCursorCollection?: Maybe<HeroCtaLinkContentPrimaryCursorCollection>;
  ctaLinkContentSecondaryCollection?: Maybe<HeroCtaLinkContentSecondaryCollection>;
  ctaLinkContentSecondaryCursorCollection?: Maybe<HeroCtaLinkContentSecondaryCursorCollection>;
  ctaLinkPrimary?: Maybe<Scalars['String']['output']>;
  ctaLinkSecondary?: Maybe<Scalars['String']['output']>;
  ctaProminence?: Maybe<Scalars['String']['output']>;
  ctaTitlePrimary?: Maybe<Scalars['String']['output']>;
  ctaTitleSecondary?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  kicker?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<HeroLinkingCollections>;
  logo?: Maybe<Asset>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  videoAsset?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkAssetPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkAssetSecondaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkContentPrimaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroCtaLinkContentPrimaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkContentPrimaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroCtaLinkContentPrimaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkContentSecondaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroCtaLinkContentSecondaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkContentSecondaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroCtaLinkContentSecondaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaLinkSecondaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaProminenceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaTitlePrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroCtaTitleSecondaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroKickerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroSeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hero) */
export type HeroVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroCollection = {
  __typename?: 'HeroCollection';
  items: Array<Maybe<Hero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroCtaLinkContentPrimaryCollection = {
  __typename?: 'HeroCtaLinkContentPrimaryCollection';
  items: Array<Maybe<HeroCtaLinkContentPrimaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroCtaLinkContentPrimaryCursorCollection = {
  __typename?: 'HeroCtaLinkContentPrimaryCursorCollection';
  items: Array<Maybe<HeroCtaLinkContentPrimaryItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroCtaLinkContentPrimaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroCtaLinkContentPrimaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroCtaLinkContentPrimaryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HeroCtaLinkContentPrimaryItem = BlogPost | Page | Program;

export type HeroCtaLinkContentSecondaryCollection = {
  __typename?: 'HeroCtaLinkContentSecondaryCollection';
  items: Array<Maybe<HeroCtaLinkContentSecondaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroCtaLinkContentSecondaryCursorCollection = {
  __typename?: 'HeroCtaLinkContentSecondaryCursorCollection';
  items: Array<Maybe<HeroCtaLinkContentSecondaryItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroCtaLinkContentSecondaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroCtaLinkContentSecondaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroCtaLinkContentSecondaryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HeroCtaLinkContentSecondaryItem = BlogPost | Page | Program;

export type HeroCursorCollection = {
  __typename?: 'HeroCursorCollection';
  items: Array<Maybe<Hero>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkAssetPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkAssetSecondary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentPrimary?: InputMaybe<CfctaLinkContentPrimaryMultiTypeNestedFilter>;
  ctaLinkContentPrimaryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentSecondary?: InputMaybe<CfctaLinkContentSecondaryMultiTypeNestedFilter>;
  ctaLinkContentSecondaryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkPrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkSecondary?: InputMaybe<Scalars['String']['input']>;
  ctaLinkSecondary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkSecondary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkSecondary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkSecondary_not?: InputMaybe<Scalars['String']['input']>;
  ctaLinkSecondary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkSecondary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaProminence?: InputMaybe<Scalars['String']['input']>;
  ctaProminence_contains?: InputMaybe<Scalars['String']['input']>;
  ctaProminence_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaProminence_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaProminence_not?: InputMaybe<Scalars['String']['input']>;
  ctaProminence_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaProminence_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitlePrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitleSecondary?: InputMaybe<Scalars['String']['input']>;
  ctaTitleSecondary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitleSecondary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitleSecondary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitleSecondary_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitleSecondary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitleSecondary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  kicker?: InputMaybe<Scalars['String']['input']>;
  kicker_contains?: InputMaybe<Scalars['String']['input']>;
  kicker_exists?: InputMaybe<Scalars['Boolean']['input']>;
  kicker_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kicker_not?: InputMaybe<Scalars['String']['input']>;
  kicker_not_contains?: InputMaybe<Scalars['String']['input']>;
  kicker_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroLinkingCollections = {
  __typename?: 'HeroLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type HeroLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HeroLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type Hospital = Entry & _Node & {
  __typename?: 'Hospital';
  _id: Scalars['ID']['output'];
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  excludeFromGeoHighlight?: Maybe<Scalars['Boolean']['output']>;
  geoloc?: Maybe<Location>;
  linkedFrom?: Maybe<HospitalLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  needGowns?: Maybe<Scalars['Int']['output']>;
  needNintendoSwitch?: Maybe<Scalars['Int']['output']>;
  needTotal?: Maybe<Scalars['Int']['output']>;
  needVirtualReality?: Maybe<Scalars['Int']['output']>;
  needWagons?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalCityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalExcludeFromGeoHighlightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalGeolocArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNeedGownsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNeedNintendoSwitchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNeedTotalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNeedVirtualRealityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalNeedWagonsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/hospital) */
export type HospitalStateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HospitalCollection = {
  __typename?: 'HospitalCollection';
  items: Array<Maybe<Hospital>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HospitalCursorCollection = {
  __typename?: 'HospitalCursorCollection';
  items: Array<Maybe<Hospital>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HospitalFilter = {
  AND?: InputMaybe<Array<InputMaybe<HospitalFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HospitalFilter>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_contains?: InputMaybe<Scalars['String']['input']>;
  city_exists?: InputMaybe<Scalars['Boolean']['input']>;
  city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city_not?: InputMaybe<Scalars['String']['input']>;
  city_not_contains?: InputMaybe<Scalars['String']['input']>;
  city_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_contains?: InputMaybe<Scalars['String']['input']>;
  code_exists?: InputMaybe<Scalars['Boolean']['input']>;
  code_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code_not?: InputMaybe<Scalars['String']['input']>;
  code_not_contains?: InputMaybe<Scalars['String']['input']>;
  code_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  excludeFromGeoHighlight?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromGeoHighlight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromGeoHighlight_not?: InputMaybe<Scalars['Boolean']['input']>;
  geoloc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  geoloc_within_circle?: InputMaybe<Scalars['Circle']['input']>;
  geoloc_within_rectangle?: InputMaybe<Scalars['Rectangle']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needGowns?: InputMaybe<Scalars['Int']['input']>;
  needGowns_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needGowns_gt?: InputMaybe<Scalars['Int']['input']>;
  needGowns_gte?: InputMaybe<Scalars['Int']['input']>;
  needGowns_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needGowns_lt?: InputMaybe<Scalars['Int']['input']>;
  needGowns_lte?: InputMaybe<Scalars['Int']['input']>;
  needGowns_not?: InputMaybe<Scalars['Int']['input']>;
  needGowns_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needNintendoSwitch?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needNintendoSwitch_gt?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_gte?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needNintendoSwitch_lt?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_lte?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_not?: InputMaybe<Scalars['Int']['input']>;
  needNintendoSwitch_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needTotal?: InputMaybe<Scalars['Int']['input']>;
  needTotal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needTotal_gt?: InputMaybe<Scalars['Int']['input']>;
  needTotal_gte?: InputMaybe<Scalars['Int']['input']>;
  needTotal_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needTotal_lt?: InputMaybe<Scalars['Int']['input']>;
  needTotal_lte?: InputMaybe<Scalars['Int']['input']>;
  needTotal_not?: InputMaybe<Scalars['Int']['input']>;
  needTotal_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needVirtualReality?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needVirtualReality_gt?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_gte?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needVirtualReality_lt?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_lte?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_not?: InputMaybe<Scalars['Int']['input']>;
  needVirtualReality_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needWagons?: InputMaybe<Scalars['Int']['input']>;
  needWagons_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needWagons_gt?: InputMaybe<Scalars['Int']['input']>;
  needWagons_gte?: InputMaybe<Scalars['Int']['input']>;
  needWagons_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needWagons_lt?: InputMaybe<Scalars['Int']['input']>;
  needWagons_lte?: InputMaybe<Scalars['Int']['input']>;
  needWagons_not?: InputMaybe<Scalars['Int']['input']>;
  needWagons_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_contains?: InputMaybe<Scalars['String']['input']>;
  state_exists?: InputMaybe<Scalars['Boolean']['input']>;
  state_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_not?: InputMaybe<Scalars['String']['input']>;
  state_not_contains?: InputMaybe<Scalars['String']['input']>;
  state_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HospitalLinkingCollections = {
  __typename?: 'HospitalLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type HospitalLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HospitalLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HospitalOrder {
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  ExcludeFromGeoHighlightAsc = 'excludeFromGeoHighlight_ASC',
  ExcludeFromGeoHighlightDesc = 'excludeFromGeoHighlight_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NeedGownsAsc = 'needGowns_ASC',
  NeedGownsDesc = 'needGowns_DESC',
  NeedNintendoSwitchAsc = 'needNintendoSwitch_ASC',
  NeedNintendoSwitchDesc = 'needNintendoSwitch_DESC',
  NeedTotalAsc = 'needTotal_ASC',
  NeedTotalDesc = 'needTotal_DESC',
  NeedVirtualRealityAsc = 'needVirtualReality_ASC',
  NeedVirtualRealityDesc = 'needVirtualReality_DESC',
  NeedWagonsAsc = 'needWagons_ASC',
  NeedWagonsDesc = 'needWagons_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResource = Entry & _Node & {
  __typename?: 'KnowledgeBasedResource';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  context?: Maybe<KnowledgeBasedResourceContext>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<KnowledgeBasedResourceLinkingCollections>;
  pdf?: Maybe<Asset>;
  resourceType?: Maybe<Scalars['String']['output']>;
  starlightPage?: Maybe<KnowledgeBasedResourceStarlightPage>;
  syncStatus?: Maybe<Scalars['String']['output']>;
  syncStatusJson?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceExternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourcePdfArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceResourceTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceStarlightPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceSyncStatusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceSyncStatusJsonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/knowledgeBasedResource) */
export type KnowledgeBasedResourceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KnowledgeBasedResourceCollection = {
  __typename?: 'KnowledgeBasedResourceCollection';
  items: Array<Maybe<KnowledgeBasedResource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type KnowledgeBasedResourceContext = {
  __typename?: 'KnowledgeBasedResourceContext';
  json: Scalars['JSON']['output'];
  links: KnowledgeBasedResourceContextLinks;
};

export type KnowledgeBasedResourceContextAssets = {
  __typename?: 'KnowledgeBasedResourceContextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type KnowledgeBasedResourceContextEntries = {
  __typename?: 'KnowledgeBasedResourceContextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type KnowledgeBasedResourceContextLinks = {
  __typename?: 'KnowledgeBasedResourceContextLinks';
  assets: KnowledgeBasedResourceContextAssets;
  entries: KnowledgeBasedResourceContextEntries;
  resources: KnowledgeBasedResourceContextResources;
};

export type KnowledgeBasedResourceContextResources = {
  __typename?: 'KnowledgeBasedResourceContextResources';
  block: Array<KnowledgeBasedResourceContextResourcesBlock>;
  hyperlink: Array<KnowledgeBasedResourceContextResourcesHyperlink>;
  inline: Array<KnowledgeBasedResourceContextResourcesInline>;
};

export type KnowledgeBasedResourceContextResourcesBlock = ResourceLink & {
  __typename?: 'KnowledgeBasedResourceContextResourcesBlock';
  sys: ResourceSys;
};

export type KnowledgeBasedResourceContextResourcesHyperlink = ResourceLink & {
  __typename?: 'KnowledgeBasedResourceContextResourcesHyperlink';
  sys: ResourceSys;
};

export type KnowledgeBasedResourceContextResourcesInline = ResourceLink & {
  __typename?: 'KnowledgeBasedResourceContextResourcesInline';
  sys: ResourceSys;
};

export type KnowledgeBasedResourceCursorCollection = {
  __typename?: 'KnowledgeBasedResourceCursorCollection';
  items: Array<Maybe<KnowledgeBasedResource>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type KnowledgeBasedResourceFilter = {
  AND?: InputMaybe<Array<InputMaybe<KnowledgeBasedResourceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<KnowledgeBasedResourceFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  context_contains?: InputMaybe<Scalars['String']['input']>;
  context_exists?: InputMaybe<Scalars['Boolean']['input']>;
  context_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  resourceType_contains?: InputMaybe<Scalars['String']['input']>;
  resourceType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourceType_not?: InputMaybe<Scalars['String']['input']>;
  resourceType_not_contains?: InputMaybe<Scalars['String']['input']>;
  resourceType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  starlightPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  syncStatus?: InputMaybe<Scalars['String']['input']>;
  syncStatusJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  syncStatus_contains?: InputMaybe<Scalars['String']['input']>;
  syncStatus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  syncStatus_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncStatus_not?: InputMaybe<Scalars['String']['input']>;
  syncStatus_not_contains?: InputMaybe<Scalars['String']['input']>;
  syncStatus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type KnowledgeBasedResourceLinkingCollections = {
  __typename?: 'KnowledgeBasedResourceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type KnowledgeBasedResourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type KnowledgeBasedResourceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum KnowledgeBasedResourceOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type KnowledgeBasedResourceStarlightPage = BasicPage | BlogPost | Page | PressRelease | Program;

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopy = Entry & _Node & {
  __typename?: 'LayoutCopy';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<LayoutCopyCopy>;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<LayoutCopyCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<LayoutCopyCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  dropCap?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LayoutCopyLinkingCollections>;
  separator?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  visualStyle?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LayoutCopyCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LayoutCopyCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyDropCapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopySeparatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/layoutCopy) */
export type LayoutCopyVisualStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LayoutCopyCollection = {
  __typename?: 'LayoutCopyCollection';
  items: Array<Maybe<LayoutCopy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LayoutCopyCopy = {
  __typename?: 'LayoutCopyCopy';
  json: Scalars['JSON']['output'];
  links: LayoutCopyCopyLinks;
};

export type LayoutCopyCopyAssets = {
  __typename?: 'LayoutCopyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type LayoutCopyCopyEntries = {
  __typename?: 'LayoutCopyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type LayoutCopyCopyLinks = {
  __typename?: 'LayoutCopyCopyLinks';
  assets: LayoutCopyCopyAssets;
  entries: LayoutCopyCopyEntries;
  resources: LayoutCopyCopyResources;
};

export type LayoutCopyCopyResources = {
  __typename?: 'LayoutCopyCopyResources';
  block: Array<LayoutCopyCopyResourcesBlock>;
  hyperlink: Array<LayoutCopyCopyResourcesHyperlink>;
  inline: Array<LayoutCopyCopyResourcesInline>;
};

export type LayoutCopyCopyResourcesBlock = ResourceLink & {
  __typename?: 'LayoutCopyCopyResourcesBlock';
  sys: ResourceSys;
};

export type LayoutCopyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'LayoutCopyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type LayoutCopyCopyResourcesInline = ResourceLink & {
  __typename?: 'LayoutCopyCopyResourcesInline';
  sys: ResourceSys;
};

export type LayoutCopyCtaLinkContentCollection = {
  __typename?: 'LayoutCopyCtaLinkContentCollection';
  items: Array<Maybe<LayoutCopyCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LayoutCopyCtaLinkContentCursorCollection = {
  __typename?: 'LayoutCopyCtaLinkContentCursorCollection';
  items: Array<Maybe<LayoutCopyCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LayoutCopyCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<LayoutCopyCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LayoutCopyCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LayoutCopyCtaLinkContentItem = BlogPost | Page | Program;

export type LayoutCopyCursorCollection = {
  __typename?: 'LayoutCopyCursorCollection';
  items: Array<Maybe<LayoutCopy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LayoutCopyFilter = {
  AND?: InputMaybe<Array<InputMaybe<LayoutCopyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LayoutCopyFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dropCap?: InputMaybe<Scalars['Boolean']['input']>;
  dropCap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  dropCap_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualStyle?: InputMaybe<Scalars['String']['input']>;
  visualStyle_contains?: InputMaybe<Scalars['String']['input']>;
  visualStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visualStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualStyle_not?: InputMaybe<Scalars['String']['input']>;
  visualStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  visualStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LayoutCopyLinkingCollections = {
  __typename?: 'LayoutCopyLinkingCollections';
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
};


export type LayoutCopyLinkingCollectionsBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsBlockCollapsibleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsBlockCollapsibleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsPartnerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsPartnerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsProgramCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LayoutCopyLinkingCollectionsProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyLinkingCollectionsProgramCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LayoutCopyLinkingCollectionsBlockCollapsibleCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsBlockCollapsibleCursorCollectionOrder {
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsPageCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsPageCursorCollectionOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsPartnerCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsPartnerCursorCollectionOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsProgramCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyLinkingCollectionsProgramCursorCollectionOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LayoutCopyOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export type Location = {
  __typename?: 'Location';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationDropdown) */
export type NavigationDropdown = Entry & _Node & {
  __typename?: 'NavigationDropdown';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavigationDropdownLinkingCollections>;
  linksCollection?: Maybe<NavigationDropdownLinksCollection>;
  linksCursorCollection?: Maybe<NavigationDropdownLinksCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationDropdown) */
export type NavigationDropdownLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationDropdown) */
export type NavigationDropdownLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationDropdown) */
export type NavigationDropdownLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationDropdown) */
export type NavigationDropdownTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationDropdownCollection = {
  __typename?: 'NavigationDropdownCollection';
  items: Array<Maybe<NavigationDropdown>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationDropdownCursorCollection = {
  __typename?: 'NavigationDropdownCursorCollection';
  items: Array<Maybe<NavigationDropdown>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationDropdownFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationDropdownFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationDropdownFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  links?: InputMaybe<CfNavigationLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationDropdownLinkingCollections = {
  __typename?: 'NavigationDropdownLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationPrimaryCollection?: Maybe<NavigationPrimaryCollection>;
  navigationPrimaryCursorCollection?: Maybe<NavigationPrimaryCursorCollection>;
};


export type NavigationDropdownLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationDropdownLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationDropdownLinkingCollectionsNavigationPrimaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownLinkingCollectionsNavigationPrimaryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationDropdownLinkingCollectionsNavigationPrimaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownLinkingCollectionsNavigationPrimaryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NavigationDropdownLinkingCollectionsNavigationPrimaryCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationDropdownLinkingCollectionsNavigationPrimaryCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationDropdownLinksCollection = {
  __typename?: 'NavigationDropdownLinksCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum NavigationDropdownLinksCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationDropdownLinksCursorCollection = {
  __typename?: 'NavigationDropdownLinksCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum NavigationDropdownLinksCursorCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationDropdownOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLink = Entry & _Node & {
  __typename?: 'NavigationLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<NavigationLinkDescription>;
  image?: Maybe<Asset>;
  linkEntryReferenceCollection?: Maybe<NavigationLinkLinkEntryReferenceCollection>;
  linkEntryReferenceCursorCollection?: Maybe<NavigationLinkLinkEntryReferenceCursorCollection>;
  linkStatic?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<NavigationLinkLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkLinkEntryReferenceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkLinkEntryReferenceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkLinkEntryReferenceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkLinkEntryReferenceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkLinkStaticArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationLink) */
export type NavigationLinkTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationLinkCollection = {
  __typename?: 'NavigationLinkCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationLinkCursorCollection = {
  __typename?: 'NavigationLinkCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationLinkDescription = {
  __typename?: 'NavigationLinkDescription';
  json: Scalars['JSON']['output'];
  links: NavigationLinkDescriptionLinks;
};

export type NavigationLinkDescriptionAssets = {
  __typename?: 'NavigationLinkDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NavigationLinkDescriptionEntries = {
  __typename?: 'NavigationLinkDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NavigationLinkDescriptionLinks = {
  __typename?: 'NavigationLinkDescriptionLinks';
  assets: NavigationLinkDescriptionAssets;
  entries: NavigationLinkDescriptionEntries;
  resources: NavigationLinkDescriptionResources;
};

export type NavigationLinkDescriptionResources = {
  __typename?: 'NavigationLinkDescriptionResources';
  block: Array<NavigationLinkDescriptionResourcesBlock>;
  hyperlink: Array<NavigationLinkDescriptionResourcesHyperlink>;
  inline: Array<NavigationLinkDescriptionResourcesInline>;
};

export type NavigationLinkDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'NavigationLinkDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type NavigationLinkDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'NavigationLinkDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type NavigationLinkDescriptionResourcesInline = ResourceLink & {
  __typename?: 'NavigationLinkDescriptionResourcesInline';
  sys: ResourceSys;
};

export type NavigationLinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkEntryReference?: InputMaybe<CflinkEntryReferenceMultiTypeNestedFilter>;
  linkEntryReferenceCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkStatic?: InputMaybe<Scalars['String']['input']>;
  linkStatic_contains?: InputMaybe<Scalars['String']['input']>;
  linkStatic_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkStatic_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkStatic_not?: InputMaybe<Scalars['String']['input']>;
  linkStatic_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkStatic_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationLinkLinkEntryReferenceCollection = {
  __typename?: 'NavigationLinkLinkEntryReferenceCollection';
  items: Array<Maybe<NavigationLinkLinkEntryReferenceItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationLinkLinkEntryReferenceCursorCollection = {
  __typename?: 'NavigationLinkLinkEntryReferenceCursorCollection';
  items: Array<Maybe<NavigationLinkLinkEntryReferenceItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationLinkLinkEntryReferenceFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationLinkLinkEntryReferenceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationLinkLinkEntryReferenceFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationLinkLinkEntryReferenceItem = BlogPost | Page | Program;

export type NavigationLinkLinkingCollections = {
  __typename?: 'NavigationLinkLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationDropdownCollection?: Maybe<NavigationDropdownCollection>;
  navigationDropdownCursorCollection?: Maybe<NavigationDropdownCursorCollection>;
  navigationPrimaryCollection?: Maybe<NavigationPrimaryCollection>;
  navigationPrimaryCursorCollection?: Maybe<NavigationPrimaryCursorCollection>;
  navigationSecondaryCollection?: Maybe<NavigationSecondaryCollection>;
  navigationSecondaryCursorCollection?: Maybe<NavigationSecondaryCursorCollection>;
};


export type NavigationLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationDropdownCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationDropdownCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationDropdownCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationDropdownCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationPrimaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationPrimaryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationPrimaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationPrimaryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationSecondaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationSecondaryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationSecondaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationSecondaryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NavigationLinkLinkingCollectionsNavigationDropdownCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkLinkingCollectionsNavigationDropdownCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkLinkingCollectionsNavigationPrimaryCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkLinkingCollectionsNavigationPrimaryCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkLinkingCollectionsNavigationSecondaryCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkLinkingCollectionsNavigationSecondaryCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationLinkOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationPrimary) */
export type NavigationPrimary = Entry & _Node & {
  __typename?: 'NavigationPrimary';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavigationPrimaryLinkingCollections>;
  navigationItemsCollection?: Maybe<NavigationPrimaryNavigationItemsCollection>;
  navigationItemsCursorCollection?: Maybe<NavigationPrimaryNavigationItemsCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationPrimary) */
export type NavigationPrimaryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationPrimary) */
export type NavigationPrimaryNavigationItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationPrimaryNavigationItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationPrimary) */
export type NavigationPrimaryNavigationItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationPrimaryNavigationItemsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationPrimary) */
export type NavigationPrimaryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationPrimaryCollection = {
  __typename?: 'NavigationPrimaryCollection';
  items: Array<Maybe<NavigationPrimary>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationPrimaryCursorCollection = {
  __typename?: 'NavigationPrimaryCursorCollection';
  items: Array<Maybe<NavigationPrimary>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationPrimaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationPrimaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationPrimaryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationItems?: InputMaybe<CfnavigationItemsMultiTypeNestedFilter>;
  navigationItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationPrimaryLinkingCollections = {
  __typename?: 'NavigationPrimaryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type NavigationPrimaryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationPrimaryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationPrimaryNavigationItemsCollection = {
  __typename?: 'NavigationPrimaryNavigationItemsCollection';
  items: Array<Maybe<NavigationPrimaryNavigationItemsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationPrimaryNavigationItemsCursorCollection = {
  __typename?: 'NavigationPrimaryNavigationItemsCursorCollection';
  items: Array<Maybe<NavigationPrimaryNavigationItemsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationPrimaryNavigationItemsFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationPrimaryNavigationItemsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationPrimaryNavigationItemsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationPrimaryNavigationItemsItem = NavigationDropdown | NavigationLink;

export enum NavigationPrimaryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationSecondary) */
export type NavigationSecondary = Entry & _Node & {
  __typename?: 'NavigationSecondary';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavigationSecondaryLinkingCollections>;
  navigationItemsCollection?: Maybe<NavigationSecondaryNavigationItemsCollection>;
  navigationItemsCursorCollection?: Maybe<NavigationSecondaryNavigationItemsCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationSecondary) */
export type NavigationSecondaryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationSecondary) */
export type NavigationSecondaryNavigationItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationSecondaryNavigationItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationSecondary) */
export type NavigationSecondaryNavigationItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationSecondaryNavigationItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/navigationSecondary) */
export type NavigationSecondaryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationSecondaryCollection = {
  __typename?: 'NavigationSecondaryCollection';
  items: Array<Maybe<NavigationSecondary>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationSecondaryCursorCollection = {
  __typename?: 'NavigationSecondaryCursorCollection';
  items: Array<Maybe<NavigationSecondary>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationSecondaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationSecondaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationSecondaryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationItems?: InputMaybe<CfNavigationLinkNestedFilter>;
  navigationItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationSecondaryLinkingCollections = {
  __typename?: 'NavigationSecondaryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type NavigationSecondaryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationSecondaryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationSecondaryNavigationItemsCollection = {
  __typename?: 'NavigationSecondaryNavigationItemsCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum NavigationSecondaryNavigationItemsCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationSecondaryNavigationItemsCursorCollection = {
  __typename?: 'NavigationSecondaryNavigationItemsCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum NavigationSecondaryNavigationItemsCursorCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationSecondaryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type Page = Entry & _Node & {
  __typename?: 'Page';
  _id: Scalars['ID']['output'];
  contentBlocksCollection?: Maybe<PageContentBlocksCollection>;
  contentBlocksCursorCollection?: Maybe<PageContentBlocksCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  hideNavigation?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<PageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageHideNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageMetaKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/page) */
export type PageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentBlocksCollection = {
  __typename?: 'PageContentBlocksCollection';
  items: Array<Maybe<PageContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentBlocksCursorCollection = {
  __typename?: 'PageContentBlocksCursorCollection';
  items: Array<Maybe<PageContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageContentBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageContentBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageContentBlocksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageContentBlocksItem = BlockBlogPosts | BlockClassy | BlockCollapsible | BlockCta | BlockCustomComponent | BlockDonate | BlockElfsightWidget | BlockEmailCollection | BlockFormAssembly | BlockFundraiseUp | BlockHighlight | BlockImages | BlockImpactStatistics | BlockPartners | BlockPeople | BlockPrograms | BlockQuotation | BlockQuotations | BlockShare | BlockTabs | BlockThermometer | BlockVideo | BulletinBoard | Hero | LayoutCopy;

export type PageCursorCollection = {
  __typename?: 'PageCursorCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  contentBlocks?: InputMaybe<CfcontentBlocksMultiTypeNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  blockCtaCollection?: Maybe<BlockCtaCollection>;
  blockCtaCursorCollection?: Maybe<BlockCtaCursorCollection>;
  blockHighlightCollection?: Maybe<BlockHighlightCollection>;
  blockHighlightCursorCollection?: Maybe<BlockHighlightCursorCollection>;
  blockImagesCollection?: Maybe<BlockImagesCollection>;
  blockImagesCursorCollection?: Maybe<BlockImagesCursorCollection>;
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  blockQuotationCollection?: Maybe<BlockQuotationCollection>;
  blockQuotationCursorCollection?: Maybe<BlockQuotationCursorCollection>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  blockVideoCursorCollection?: Maybe<BlockVideoCursorCollection>;
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  donationAppealCollection?: Maybe<DonationAppealCollection>;
  donationAppealCursorCollection?: Maybe<DonationAppealCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroCursorCollection?: Maybe<HeroCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
  layoutCopyCollection?: Maybe<LayoutCopyCollection>;
  layoutCopyCursorCollection?: Maybe<LayoutCopyCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  statisticCollection?: Maybe<StatisticCollection>;
  statisticCursorCollection?: Maybe<StatisticCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type PageLinkingCollectionsBlockCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockHighlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockHighlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockImagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockImpactStatisticsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockPartnersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockPartnersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockQuotationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockQuotationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockQuotationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockQuotationCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockVideoCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBlockVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBlockVideoCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBulletinBoardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBulletinBoardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBulletinCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsBulletinCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsDonationAppealCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsDonationAppealCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsDonationAppealCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsDonationAppealCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsKnowledgeBasedResourceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsLayoutCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsLayoutCopyCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsLayoutCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsLayoutCopyCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsStatisticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsStatisticCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsStatisticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsStatisticCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PageLinkingCollectionsBlockCtaCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockCtaCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockHighlightCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockHighlightCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockImagesCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockImagesCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockImpactStatisticsCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockPartnersCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockPartnersCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBlockQuotationCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockQuotationCursorCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum PageLinkingCollectionsBlockVideoCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum PageLinkingCollectionsBlockVideoCursorCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum PageLinkingCollectionsBulletinBoardCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum PageLinkingCollectionsBulletinBoardCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum PageLinkingCollectionsBulletinCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsBulletinCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsDonationAppealCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsDonationAppealCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsHeroCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsHeroCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsKnowledgeBasedResourceCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsLayoutCopyCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum PageLinkingCollectionsLayoutCopyCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum PageLinkingCollectionsNavigationLinkCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsNavigationLinkCursorCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsStatisticCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsStatisticCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsTabCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsTabCursorCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageOrder {
  HideNavigationAsc = 'hideNavigation_ASC',
  HideNavigationDesc = 'hideNavigation_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type Partner = Entry & _Node & {
  __typename?: 'Partner';
  _id: Scalars['ID']['output'];
  campaignUrl?: Maybe<Scalars['String']['output']>;
  contentBlocksCollection?: Maybe<PartnerContentBlocksCollection>;
  contentBlocksCursorCollection?: Maybe<PartnerContentBlocksCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  createPage?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<PartnerLinkingCollections>;
  logo?: Maybe<Asset>;
  shortDescription?: Maybe<PartnerShortDescription>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerCampaignUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerCreatePageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerShortDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/partner) */
export type PartnerTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartnerCollection = {
  __typename?: 'PartnerCollection';
  items: Array<Maybe<Partner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PartnerContentBlocksCollection = {
  __typename?: 'PartnerContentBlocksCollection';
  items: Array<Maybe<PartnerContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PartnerContentBlocksCursorCollection = {
  __typename?: 'PartnerContentBlocksCursorCollection';
  items: Array<Maybe<PartnerContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PartnerContentBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<PartnerContentBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PartnerContentBlocksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerContentBlocksItem = BlockBlogPosts | BlockClassy | BlockCta | BlockHighlight | BlockImpactStatistics | BlockQuotation | BlockQuotations | BulletinBoard | LayoutCopy;

export type PartnerCursorCollection = {
  __typename?: 'PartnerCursorCollection';
  items: Array<Maybe<Partner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PartnerFilter = {
  AND?: InputMaybe<Array<InputMaybe<PartnerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PartnerFilter>>>;
  campaignUrl?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_contains?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaignUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignUrl_not?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentBlocks?: InputMaybe<CfcontentBlocksMultiTypeNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createPage?: InputMaybe<Scalars['Boolean']['input']>;
  createPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createPage_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerLinkingCollections = {
  __typename?: 'PartnerLinkingCollections';
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PartnerLinkingCollectionsBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PartnerLinkingCollectionsBlockPartnersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PartnerLinkingCollectionsBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PartnerLinkingCollectionsBlockPartnersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PartnerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PartnerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PartnerLinkingCollectionsBlockPartnersCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PartnerLinkingCollectionsBlockPartnersCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PartnerOrder {
  CampaignUrlAsc = 'campaignUrl_ASC',
  CampaignUrlDesc = 'campaignUrl_DESC',
  CreatePageAsc = 'createPage_ASC',
  CreatePageDesc = 'createPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PartnerShortDescription = {
  __typename?: 'PartnerShortDescription';
  json: Scalars['JSON']['output'];
  links: PartnerShortDescriptionLinks;
};

export type PartnerShortDescriptionAssets = {
  __typename?: 'PartnerShortDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PartnerShortDescriptionEntries = {
  __typename?: 'PartnerShortDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PartnerShortDescriptionLinks = {
  __typename?: 'PartnerShortDescriptionLinks';
  assets: PartnerShortDescriptionAssets;
  entries: PartnerShortDescriptionEntries;
  resources: PartnerShortDescriptionResources;
};

export type PartnerShortDescriptionResources = {
  __typename?: 'PartnerShortDescriptionResources';
  block: Array<PartnerShortDescriptionResourcesBlock>;
  hyperlink: Array<PartnerShortDescriptionResourcesHyperlink>;
  inline: Array<PartnerShortDescriptionResourcesInline>;
};

export type PartnerShortDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'PartnerShortDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type PartnerShortDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'PartnerShortDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type PartnerShortDescriptionResourcesInline = ResourceLink & {
  __typename?: 'PartnerShortDescriptionResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type Person = Entry & _Node & {
  __typename?: 'Person';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PersonLinkingCollections>;
  photo?: Maybe<Asset>;
  shortBio?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonEmailAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonFullNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonJobTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonLastNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonPhotoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/person) */
export type PersonShortBioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCollection = {
  __typename?: 'PersonCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PersonCursorCollection = {
  __typename?: 'PersonCursorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PersonFilter = {
  AND?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains?: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not?: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fullName_contains?: InputMaybe<Scalars['String']['input']>;
  fullName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName_not?: InputMaybe<Scalars['String']['input']>;
  fullName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fullName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains?: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not?: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  shortBio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PersonLinkingCollections = {
  __typename?: 'PersonLinkingCollections';
  blockPeopleCollection?: Maybe<BlockPeopleCollection>;
  blockPeopleCursorCollection?: Maybe<BlockPeopleCursorCollection>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type PersonLinkingCollectionsBlockPeopleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsBlockPeopleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsBlockPeopleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsBlockPeopleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsBlogPostCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsBlogPostCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PersonLinkingCollectionsBlockPeopleCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsBlockPeopleCursorCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsBlogPostCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsBlogPostCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  FeaturedOrderAsc = 'featuredOrder_ASC',
  FeaturedOrderDesc = 'featuredOrder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonOrder {
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressRelease = Entry & _Node & {
  __typename?: 'PressRelease';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  date?: Maybe<Scalars['DateTime']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<PressReleaseLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<PressReleaseText>;
  title?: Maybe<Scalars['String']['output']>;
  youTubeUrl?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseMetaKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/pressRelease) */
export type PressReleaseYouTubeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressReleaseCollection = {
  __typename?: 'PressReleaseCollection';
  items: Array<Maybe<PressRelease>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PressReleaseCursorCollection = {
  __typename?: 'PressReleaseCursorCollection';
  items: Array<Maybe<PressRelease>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PressReleaseFilter = {
  AND?: InputMaybe<Array<InputMaybe<PressReleaseFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PressReleaseFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeUrl?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeUrl_not?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PressReleaseLinkingCollections = {
  __typename?: 'PressReleaseLinkingCollections';
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
};


export type PressReleaseLinkingCollectionsBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseLinkingCollectionsBulletinCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressReleaseLinkingCollectionsBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseLinkingCollectionsBulletinCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressReleaseLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressReleaseLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressReleaseLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseLinkingCollectionsKnowledgeBasedResourceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressReleaseLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PressReleaseLinkingCollectionsBulletinCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PressReleaseLinkingCollectionsBulletinCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PressReleaseLinkingCollectionsKnowledgeBasedResourceCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PressReleaseLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PressReleaseOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YouTubeUrlAsc = 'youTubeUrl_ASC',
  YouTubeUrlDesc = 'youTubeUrl_DESC'
}

export type PressReleaseText = {
  __typename?: 'PressReleaseText';
  json: Scalars['JSON']['output'];
  links: PressReleaseTextLinks;
};

export type PressReleaseTextAssets = {
  __typename?: 'PressReleaseTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type PressReleaseTextEntries = {
  __typename?: 'PressReleaseTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type PressReleaseTextLinks = {
  __typename?: 'PressReleaseTextLinks';
  assets: PressReleaseTextAssets;
  entries: PressReleaseTextEntries;
  resources: PressReleaseTextResources;
};

export type PressReleaseTextResources = {
  __typename?: 'PressReleaseTextResources';
  block: Array<PressReleaseTextResourcesBlock>;
  hyperlink: Array<PressReleaseTextResourcesHyperlink>;
  inline: Array<PressReleaseTextResourcesInline>;
};

export type PressReleaseTextResourcesBlock = ResourceLink & {
  __typename?: 'PressReleaseTextResourcesBlock';
  sys: ResourceSys;
};

export type PressReleaseTextResourcesHyperlink = ResourceLink & {
  __typename?: 'PressReleaseTextResourcesHyperlink';
  sys: ResourceSys;
};

export type PressReleaseTextResourcesInline = ResourceLink & {
  __typename?: 'PressReleaseTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type Program = Entry & _Node & {
  __typename?: 'Program';
  _id: Scalars['ID']['output'];
  contentBlocksCollection?: Maybe<ProgramContentBlocksCollection>;
  contentBlocksCursorCollection?: Maybe<ProgramContentBlocksCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  donateLink?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<ProgramLinkingCollections>;
  metaKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overview?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramContentBlocksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramContentBlocksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramContentBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramDonateLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramMetaKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramOverviewArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/program) */
export type ProgramTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramCollection = {
  __typename?: 'ProgramCollection';
  items: Array<Maybe<Program>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProgramContentBlocksCollection = {
  __typename?: 'ProgramContentBlocksCollection';
  items: Array<Maybe<ProgramContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProgramContentBlocksCursorCollection = {
  __typename?: 'ProgramContentBlocksCursorCollection';
  items: Array<Maybe<ProgramContentBlocksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProgramContentBlocksFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProgramContentBlocksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProgramContentBlocksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgramContentBlocksItem = BlockClassy | BlockCollapsible | BlockCustomComponent | BlockDonate | BlockEmailCollection | BlockFundraiseUp | BlockHighlight | BlockImages | BlockImpactStatistics | BlockPeople | BlockPrograms | BlockQuotation | BlockQuotations | BlockTabs | BlockVideo | BulletinBoard | Hero | LayoutCopy;

export type ProgramCursorCollection = {
  __typename?: 'ProgramCursorCollection';
  items: Array<Maybe<Program>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProgramFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProgramFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProgramFilter>>>;
  contentBlocks?: InputMaybe<CfcontentBlocksMultiTypeNestedFilter>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  donateLink?: InputMaybe<Scalars['String']['input']>;
  donateLink_contains?: InputMaybe<Scalars['String']['input']>;
  donateLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  donateLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donateLink_not?: InputMaybe<Scalars['String']['input']>;
  donateLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  donateLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overview?: InputMaybe<Scalars['String']['input']>;
  overview_contains?: InputMaybe<Scalars['String']['input']>;
  overview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overview_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overview_not?: InputMaybe<Scalars['String']['input']>;
  overview_not_contains?: InputMaybe<Scalars['String']['input']>;
  overview_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgramLinkingCollections = {
  __typename?: 'ProgramLinkingCollections';
  blockCtaCollection?: Maybe<BlockCtaCollection>;
  blockCtaCursorCollection?: Maybe<BlockCtaCursorCollection>;
  blockHighlightCollection?: Maybe<BlockHighlightCollection>;
  blockHighlightCursorCollection?: Maybe<BlockHighlightCursorCollection>;
  blockImagesCollection?: Maybe<BlockImagesCollection>;
  blockImagesCursorCollection?: Maybe<BlockImagesCursorCollection>;
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  blockProgramsCollection?: Maybe<BlockProgramsCollection>;
  blockProgramsCursorCollection?: Maybe<BlockProgramsCursorCollection>;
  blockQuotationCollection?: Maybe<BlockQuotationCollection>;
  blockQuotationCursorCollection?: Maybe<BlockQuotationCursorCollection>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  blockVideoCursorCollection?: Maybe<BlockVideoCursorCollection>;
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  donationAppealCollection?: Maybe<DonationAppealCollection>;
  donationAppealCursorCollection?: Maybe<DonationAppealCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  heroCollection?: Maybe<HeroCollection>;
  heroCursorCollection?: Maybe<HeroCursorCollection>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
  layoutCopyCollection?: Maybe<LayoutCopyCollection>;
  layoutCopyCursorCollection?: Maybe<LayoutCopyCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  statisticCollection?: Maybe<StatisticCollection>;
  statisticCursorCollection?: Maybe<StatisticCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type ProgramLinkingCollectionsBlockCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockCtaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockHighlightCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockHighlightCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockImagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockImpactStatisticsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockPartnersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockPartnersCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockProgramsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockProgramsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockProgramsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockProgramsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockQuotationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockQuotationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockQuotationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockQuotationCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockVideoCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBlockVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBlockVideoCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBulletinBoardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBulletinBoardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBulletinCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsBulletinCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsDonationAppealCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsDonationAppealCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsDonationAppealCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsDonationAppealCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsKnowledgeBasedResourceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsLayoutCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsLayoutCopyCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsLayoutCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsLayoutCopyCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsStatisticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsStatisticCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsStatisticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsStatisticCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProgramLinkingCollectionsBlockCtaCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockCtaCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockHighlightCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockHighlightCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  CtaVariantAsc = 'ctaVariant_ASC',
  CtaVariantDesc = 'ctaVariant_DESC',
  DecorationAsc = 'decoration_ASC',
  DecorationDesc = 'decoration_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ReversedAsc = 'reversed_ASC',
  ReversedDesc = 'reversed_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockImagesCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockImagesCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockImpactStatisticsCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockPartnersCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockPartnersCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockProgramsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockProgramsCursorCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBlockQuotationCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockQuotationCursorCollectionOrder {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum ProgramLinkingCollectionsBlockVideoCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum ProgramLinkingCollectionsBlockVideoCursorCollectionOrder {
  AutoplayAsc = 'autoplay_ASC',
  AutoplayDesc = 'autoplay_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  PlayerSizeAsc = 'playerSize_ASC',
  PlayerSizeDesc = 'playerSize_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum ProgramLinkingCollectionsBulletinBoardCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum ProgramLinkingCollectionsBulletinBoardCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum ProgramLinkingCollectionsBulletinCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsBulletinCursorCollectionOrder {
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsDonationAppealCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsDonationAppealCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MoreLinkAsc = 'moreLink_ASC',
  MoreLinkDesc = 'moreLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsHeroCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsHeroCursorCollectionOrder {
  AspectRatioAsc = 'aspectRatio_ASC',
  AspectRatioDesc = 'aspectRatio_DESC',
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaLinkSecondaryAsc = 'ctaLinkSecondary_ASC',
  CtaLinkSecondaryDesc = 'ctaLinkSecondary_DESC',
  CtaProminenceAsc = 'ctaProminence_ASC',
  CtaProminenceDesc = 'ctaProminence_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  CtaTitleSecondaryAsc = 'ctaTitleSecondary_ASC',
  CtaTitleSecondaryDesc = 'ctaTitleSecondary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  KickerAsc = 'kicker_ASC',
  KickerDesc = 'kicker_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsKnowledgeBasedResourceCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsKnowledgeBasedResourceCursorCollectionOrder {
  ExternalUrlAsc = 'externalUrl_ASC',
  ExternalUrlDesc = 'externalUrl_DESC',
  ResourceTypeAsc = 'resourceType_ASC',
  ResourceTypeDesc = 'resourceType_DESC',
  SyncStatusAsc = 'syncStatus_ASC',
  SyncStatusDesc = 'syncStatus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsLayoutCopyCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum ProgramLinkingCollectionsLayoutCopyCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  DropCapAsc = 'dropCap_ASC',
  DropCapDesc = 'dropCap_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VisualStyleAsc = 'visualStyle_ASC',
  VisualStyleDesc = 'visualStyle_DESC'
}

export enum ProgramLinkingCollectionsNavigationLinkCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsNavigationLinkCursorCollectionOrder {
  LinkStaticAsc = 'linkStatic_ASC',
  LinkStaticDesc = 'linkStatic_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsStatisticCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsStatisticCursorCollectionOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsTabCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramLinkingCollectionsTabCursorCollectionOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProgramOrder {
  DonateLinkAsc = 'donateLink_ASC',
  DonateLinkDesc = 'donateLink_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  assetCursorCollection?: Maybe<AssetCursorCollection>;
  basicPage?: Maybe<BasicPage>;
  basicPageCollection?: Maybe<BasicPageCollection>;
  basicPageCursorCollection?: Maybe<BasicPageCursorCollection>;
  blockBlogPosts?: Maybe<BlockBlogPosts>;
  blockBlogPostsCollection?: Maybe<BlockBlogPostsCollection>;
  blockBlogPostsCursorCollection?: Maybe<BlockBlogPostsCursorCollection>;
  blockClassy?: Maybe<BlockClassy>;
  blockClassyCollection?: Maybe<BlockClassyCollection>;
  blockClassyCursorCollection?: Maybe<BlockClassyCursorCollection>;
  blockCollapsible?: Maybe<BlockCollapsible>;
  blockCollapsibleCollection?: Maybe<BlockCollapsibleCollection>;
  blockCollapsibleCursorCollection?: Maybe<BlockCollapsibleCursorCollection>;
  blockCta?: Maybe<BlockCta>;
  blockCtaCollection?: Maybe<BlockCtaCollection>;
  blockCtaCursorCollection?: Maybe<BlockCtaCursorCollection>;
  blockCustomComponent?: Maybe<BlockCustomComponent>;
  blockCustomComponentCollection?: Maybe<BlockCustomComponentCollection>;
  blockCustomComponentCursorCollection?: Maybe<BlockCustomComponentCursorCollection>;
  blockDonate?: Maybe<BlockDonate>;
  blockDonateCollection?: Maybe<BlockDonateCollection>;
  blockDonateCursorCollection?: Maybe<BlockDonateCursorCollection>;
  blockElfsightWidget?: Maybe<BlockElfsightWidget>;
  blockElfsightWidgetCollection?: Maybe<BlockElfsightWidgetCollection>;
  blockElfsightWidgetCursorCollection?: Maybe<BlockElfsightWidgetCursorCollection>;
  blockEmailCollection?: Maybe<BlockEmailCollection>;
  blockEmailCollectionCollection?: Maybe<BlockEmailCollectionCollection>;
  blockEmailCollectionCursorCollection?: Maybe<BlockEmailCollectionCursorCollection>;
  blockFormAssembly?: Maybe<BlockFormAssembly>;
  blockFormAssemblyCollection?: Maybe<BlockFormAssemblyCollection>;
  blockFormAssemblyCursorCollection?: Maybe<BlockFormAssemblyCursorCollection>;
  blockFundraiseUp?: Maybe<BlockFundraiseUp>;
  blockFundraiseUpCollection?: Maybe<BlockFundraiseUpCollection>;
  blockFundraiseUpCursorCollection?: Maybe<BlockFundraiseUpCursorCollection>;
  blockHighlight?: Maybe<BlockHighlight>;
  blockHighlightCollection?: Maybe<BlockHighlightCollection>;
  blockHighlightCursorCollection?: Maybe<BlockHighlightCursorCollection>;
  blockImages?: Maybe<BlockImages>;
  blockImagesCollection?: Maybe<BlockImagesCollection>;
  blockImagesCursorCollection?: Maybe<BlockImagesCursorCollection>;
  blockImpactStatistics?: Maybe<BlockImpactStatistics>;
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  blockPartners?: Maybe<BlockPartners>;
  blockPartnersCollection?: Maybe<BlockPartnersCollection>;
  blockPartnersCursorCollection?: Maybe<BlockPartnersCursorCollection>;
  blockPeople?: Maybe<BlockPeople>;
  blockPeopleCollection?: Maybe<BlockPeopleCollection>;
  blockPeopleCursorCollection?: Maybe<BlockPeopleCursorCollection>;
  blockPrograms?: Maybe<BlockPrograms>;
  blockProgramsCollection?: Maybe<BlockProgramsCollection>;
  blockProgramsCursorCollection?: Maybe<BlockProgramsCursorCollection>;
  blockQuotation?: Maybe<BlockQuotation>;
  blockQuotationCollection?: Maybe<BlockQuotationCollection>;
  blockQuotationCursorCollection?: Maybe<BlockQuotationCursorCollection>;
  blockQuotations?: Maybe<BlockQuotations>;
  blockQuotationsCollection?: Maybe<BlockQuotationsCollection>;
  blockQuotationsCursorCollection?: Maybe<BlockQuotationsCursorCollection>;
  blockShare?: Maybe<BlockShare>;
  blockShareCollection?: Maybe<BlockShareCollection>;
  blockShareCursorCollection?: Maybe<BlockShareCursorCollection>;
  blockTabs?: Maybe<BlockTabs>;
  blockTabsCollection?: Maybe<BlockTabsCollection>;
  blockTabsCursorCollection?: Maybe<BlockTabsCursorCollection>;
  blockThermometer?: Maybe<BlockThermometer>;
  blockThermometerCollection?: Maybe<BlockThermometerCollection>;
  blockThermometerCursorCollection?: Maybe<BlockThermometerCursorCollection>;
  blockVideo?: Maybe<BlockVideo>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  blockVideoCursorCollection?: Maybe<BlockVideoCursorCollection>;
  blogCategory?: Maybe<BlogCategory>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogCategoryCursorCollection?: Maybe<BlogCategoryCursorCollection>;
  blogPost?: Maybe<BlogPost>;
  blogPostCollection?: Maybe<BlogPostCollection>;
  blogPostCursorCollection?: Maybe<BlogPostCursorCollection>;
  bulletin?: Maybe<Bulletin>;
  bulletinBoard?: Maybe<BulletinBoard>;
  bulletinBoardCollection?: Maybe<BulletinBoardCollection>;
  bulletinBoardCursorCollection?: Maybe<BulletinBoardCursorCollection>;
  bulletinCollection?: Maybe<BulletinCollection>;
  bulletinCursorCollection?: Maybe<BulletinCursorCollection>;
  donationAppeal?: Maybe<DonationAppeal>;
  donationAppealCollection?: Maybe<DonationAppealCollection>;
  donationAppealCursorCollection?: Maybe<DonationAppealCursorCollection>;
  embedInstagram?: Maybe<EmbedInstagram>;
  embedInstagramCollection?: Maybe<EmbedInstagramCollection>;
  embedInstagramCursorCollection?: Maybe<EmbedInstagramCursorCollection>;
  embedTwitter?: Maybe<EmbedTwitter>;
  embedTwitterCollection?: Maybe<EmbedTwitterCollection>;
  embedTwitterCursorCollection?: Maybe<EmbedTwitterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  hero?: Maybe<Hero>;
  heroCollection?: Maybe<HeroCollection>;
  heroCursorCollection?: Maybe<HeroCursorCollection>;
  hospital?: Maybe<Hospital>;
  hospitalCollection?: Maybe<HospitalCollection>;
  hospitalCursorCollection?: Maybe<HospitalCursorCollection>;
  knowledgeBasedResource?: Maybe<KnowledgeBasedResource>;
  knowledgeBasedResourceCollection?: Maybe<KnowledgeBasedResourceCollection>;
  knowledgeBasedResourceCursorCollection?: Maybe<KnowledgeBasedResourceCursorCollection>;
  layoutCopy?: Maybe<LayoutCopy>;
  layoutCopyCollection?: Maybe<LayoutCopyCollection>;
  layoutCopyCursorCollection?: Maybe<LayoutCopyCursorCollection>;
  navigationDropdown?: Maybe<NavigationDropdown>;
  navigationDropdownCollection?: Maybe<NavigationDropdownCollection>;
  navigationDropdownCursorCollection?: Maybe<NavigationDropdownCursorCollection>;
  navigationLink?: Maybe<NavigationLink>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  navigationPrimary?: Maybe<NavigationPrimary>;
  navigationPrimaryCollection?: Maybe<NavigationPrimaryCollection>;
  navigationPrimaryCursorCollection?: Maybe<NavigationPrimaryCursorCollection>;
  navigationSecondary?: Maybe<NavigationSecondary>;
  navigationSecondaryCollection?: Maybe<NavigationSecondaryCollection>;
  navigationSecondaryCursorCollection?: Maybe<NavigationSecondaryCursorCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  partner?: Maybe<Partner>;
  partnerCollection?: Maybe<PartnerCollection>;
  partnerCursorCollection?: Maybe<PartnerCursorCollection>;
  person?: Maybe<Person>;
  personCollection?: Maybe<PersonCollection>;
  personCursorCollection?: Maybe<PersonCursorCollection>;
  pressRelease?: Maybe<PressRelease>;
  pressReleaseCollection?: Maybe<PressReleaseCollection>;
  pressReleaseCursorCollection?: Maybe<PressReleaseCursorCollection>;
  program?: Maybe<Program>;
  programCollection?: Maybe<ProgramCollection>;
  programCursorCollection?: Maybe<ProgramCursorCollection>;
  redirect?: Maybe<Redirect>;
  redirectCollection?: Maybe<RedirectCollection>;
  redirectCursorCollection?: Maybe<RedirectCursorCollection>;
  statistic?: Maybe<Statistic>;
  statisticCollection?: Maybe<StatisticCollection>;
  statisticCursorCollection?: Maybe<StatisticCursorCollection>;
  tab?: Maybe<Tab>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryBasicPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBasicPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BasicPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BasicPageFilter>;
};


export type QueryBasicPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BasicPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BasicPageFilter>;
};


export type QueryBlockBlogPostsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockBlogPostsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockBlogPostsFilter>;
};


export type QueryBlockBlogPostsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockBlogPostsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockBlogPostsFilter>;
};


export type QueryBlockClassyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockClassyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockClassyFilter>;
};


export type QueryBlockClassyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockClassyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockClassyFilter>;
};


export type QueryBlockCollapsibleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockCollapsibleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCollapsibleFilter>;
};


export type QueryBlockCollapsibleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCollapsibleOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCollapsibleFilter>;
};


export type QueryBlockCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCtaFilter>;
};


export type QueryBlockCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCtaFilter>;
};


export type QueryBlockCustomComponentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockCustomComponentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCustomComponentFilter>;
};


export type QueryBlockCustomComponentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockCustomComponentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockCustomComponentFilter>;
};


export type QueryBlockDonateArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockDonateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockDonateFilter>;
};


export type QueryBlockDonateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockDonateOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockDonateFilter>;
};


export type QueryBlockElfsightWidgetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockElfsightWidgetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockElfsightWidgetFilter>;
};


export type QueryBlockElfsightWidgetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockElfsightWidgetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockElfsightWidgetFilter>;
};


export type QueryBlockEmailCollectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockEmailCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockEmailCollectionFilter>;
};


export type QueryBlockEmailCollectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockEmailCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockEmailCollectionFilter>;
};


export type QueryBlockFormAssemblyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockFormAssemblyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockFormAssemblyFilter>;
};


export type QueryBlockFormAssemblyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFormAssemblyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockFormAssemblyFilter>;
};


export type QueryBlockFundraiseUpArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockFundraiseUpCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockFundraiseUpFilter>;
};


export type QueryBlockFundraiseUpCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockFundraiseUpOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockFundraiseUpFilter>;
};


export type QueryBlockHighlightArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockHighlightFilter>;
};


export type QueryBlockHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockHighlightOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockHighlightFilter>;
};


export type QueryBlockImagesArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImagesFilter>;
};


export type QueryBlockImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImagesOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImagesFilter>;
};


export type QueryBlockImpactStatisticsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImpactStatisticsFilter>;
};


export type QueryBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockImpactStatisticsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockImpactStatisticsFilter>;
};


export type QueryBlockPartnersArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockPartnersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPartnersFilter>;
};


export type QueryBlockPartnersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPartnersOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPartnersFilter>;
};


export type QueryBlockPeopleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockPeopleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPeopleFilter>;
};


export type QueryBlockPeopleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockPeopleOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockPeopleFilter>;
};


export type QueryBlockProgramsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockProgramsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockProgramsFilter>;
};


export type QueryBlockProgramsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockProgramsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockProgramsFilter>;
};


export type QueryBlockQuotationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockQuotationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationFilter>;
};


export type QueryBlockQuotationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationFilter>;
};


export type QueryBlockQuotationsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockQuotationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationsFilter>;
};


export type QueryBlockQuotationsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockQuotationsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockQuotationsFilter>;
};


export type QueryBlockShareArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockShareCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockShareFilter>;
};


export type QueryBlockShareCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockShareOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockShareFilter>;
};


export type QueryBlockTabsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockTabsFilter>;
};


export type QueryBlockTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockTabsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockTabsFilter>;
};


export type QueryBlockThermometerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockThermometerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockThermometerFilter>;
};


export type QueryBlockThermometerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockThermometerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockThermometerFilter>;
};


export type QueryBlockVideoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockVideoFilter>;
};


export type QueryBlockVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlockVideoOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlockVideoFilter>;
};


export type QueryBlogCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogPostArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogPostCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostFilter>;
};


export type QueryBlogPostCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogPostFilter>;
};


export type QueryBulletinArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBulletinBoardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBulletinBoardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinBoardFilter>;
};


export type QueryBulletinBoardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinBoardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinBoardFilter>;
};


export type QueryBulletinCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinFilter>;
};


export type QueryBulletinCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BulletinOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BulletinFilter>;
};


export type QueryDonationAppealArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDonationAppealCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DonationAppealOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealFilter>;
};


export type QueryDonationAppealCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DonationAppealOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DonationAppealFilter>;
};


export type QueryEmbedInstagramArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmbedInstagramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EmbedInstagramOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EmbedInstagramFilter>;
};


export type QueryEmbedInstagramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EmbedInstagramOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EmbedInstagramFilter>;
};


export type QueryEmbedTwitterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmbedTwitterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EmbedTwitterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EmbedTwitterFilter>;
};


export type QueryEmbedTwitterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EmbedTwitterOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EmbedTwitterFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroFilter>;
};


export type QueryHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroFilter>;
};


export type QueryHospitalArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHospitalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HospitalOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HospitalFilter>;
};


export type QueryHospitalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HospitalOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HospitalFilter>;
};


export type QueryKnowledgeBasedResourceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryKnowledgeBasedResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<KnowledgeBasedResourceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<KnowledgeBasedResourceFilter>;
};


export type QueryKnowledgeBasedResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<KnowledgeBasedResourceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<KnowledgeBasedResourceFilter>;
};


export type QueryLayoutCopyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLayoutCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LayoutCopyFilter>;
};


export type QueryLayoutCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LayoutCopyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LayoutCopyFilter>;
};


export type QueryNavigationDropdownArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationDropdownCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationDropdownFilter>;
};


export type QueryNavigationDropdownCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationDropdownOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationDropdownFilter>;
};


export type QueryNavigationLinkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


export type QueryNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


export type QueryNavigationPrimaryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationPrimaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationPrimaryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationPrimaryFilter>;
};


export type QueryNavigationPrimaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationPrimaryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationPrimaryFilter>;
};


export type QueryNavigationSecondaryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationSecondaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationSecondaryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationSecondaryFilter>;
};


export type QueryNavigationSecondaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationSecondaryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationSecondaryFilter>;
};


export type QueryPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


export type QueryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


export type QueryPartnerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartnerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PartnerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerFilter>;
};


export type QueryPartnerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PartnerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerFilter>;
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


export type QueryPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonFilter>;
};


export type QueryPressReleaseArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPressReleaseCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressReleaseFilter>;
};


export type QueryPressReleaseCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressReleaseFilter>;
};


export type QueryProgramArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramFilter>;
};


export type QueryProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgramFilter>;
};


export type QueryRedirectArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRedirectCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<RedirectOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RedirectFilter>;
};


export type QueryRedirectCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<RedirectOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RedirectFilter>;
};


export type QueryStatisticArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStatisticCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StatisticOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticFilter>;
};


export type QueryStatisticCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StatisticOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticFilter>;
};


export type QueryTabArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


export type QueryTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/redirect) */
export type Redirect = Entry & _Node & {
  __typename?: 'Redirect';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  destination?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<RedirectLinkingCollections>;
  source?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/redirect) */
export type RedirectDestinationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/redirect) */
export type RedirectLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/redirect) */
export type RedirectSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCollection = {
  __typename?: 'RedirectCollection';
  items: Array<Maybe<Redirect>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RedirectCursorCollection = {
  __typename?: 'RedirectCursorCollection';
  items: Array<Maybe<Redirect>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type RedirectFilter = {
  AND?: InputMaybe<Array<InputMaybe<RedirectFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RedirectFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  destination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destination_not?: InputMaybe<Scalars['String']['input']>;
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_contains?: InputMaybe<Scalars['String']['input']>;
  source_exists?: InputMaybe<Scalars['Boolean']['input']>;
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_not?: InputMaybe<Scalars['String']['input']>;
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type RedirectLinkingCollections = {
  __typename?: 'RedirectLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type RedirectLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RedirectLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RedirectOrder {
  DestinationAsc = 'destination_ASC',
  DestinationDesc = 'destination_DESC',
  SourceAsc = 'source_ASC',
  SourceDesc = 'source_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type Statistic = Entry & _Node & {
  __typename?: 'Statistic';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<Scalars['String']['output']>;
  ctaHeadline?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaLinkAsset?: Maybe<Asset>;
  ctaLinkContentCollection?: Maybe<StatisticCtaLinkContentCollection>;
  ctaLinkContentCursorCollection?: Maybe<StatisticCtaLinkContentCursorCollection>;
  ctaTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<StatisticLinkingCollections>;
  statType?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaLinkAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaLinkContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaLinkContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StatisticCtaLinkContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticCtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticStatTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/statistic) */
export type StatisticTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatisticCollection = {
  __typename?: 'StatisticCollection';
  items: Array<Maybe<Statistic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StatisticCtaLinkContentCollection = {
  __typename?: 'StatisticCtaLinkContentCollection';
  items: Array<Maybe<StatisticCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StatisticCtaLinkContentCursorCollection = {
  __typename?: 'StatisticCtaLinkContentCursorCollection';
  items: Array<Maybe<StatisticCtaLinkContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StatisticCtaLinkContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<StatisticCtaLinkContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StatisticCtaLinkContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StatisticCtaLinkContentItem = BlogPost | Page | Program;

export type StatisticCursorCollection = {
  __typename?: 'StatisticCursorCollection';
  items: Array<Maybe<Statistic>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StatisticFilter = {
  AND?: InputMaybe<Array<InputMaybe<StatisticFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StatisticFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContent?: InputMaybe<CfctaLinkContentMultiTypeNestedFilter>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  statType?: InputMaybe<Scalars['String']['input']>;
  statType_contains?: InputMaybe<Scalars['String']['input']>;
  statType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  statType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statType_not?: InputMaybe<Scalars['String']['input']>;
  statType_not_contains?: InputMaybe<Scalars['String']['input']>;
  statType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StatisticLinkingCollections = {
  __typename?: 'StatisticLinkingCollections';
  blockImpactStatisticsCollection?: Maybe<BlockImpactStatisticsCollection>;
  blockImpactStatisticsCursorCollection?: Maybe<BlockImpactStatisticsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type StatisticLinkingCollectionsBlockImpactStatisticsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StatisticLinkingCollectionsBlockImpactStatisticsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StatisticLinkingCollectionsBlockImpactStatisticsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StatisticLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StatisticLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StatisticLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StatisticLinkingCollectionsBlockImpactStatisticsCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StatisticLinkingCollectionsBlockImpactStatisticsCursorCollectionOrder {
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  SeparatorAsc = 'separator_ASC',
  SeparatorDesc = 'separator_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StatisticOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  CtaHeadlineAsc = 'ctaHeadline_ASC',
  CtaHeadlineDesc = 'ctaHeadline_DESC',
  CtaLinkAsc = 'ctaLink_ASC',
  CtaLinkDesc = 'ctaLink_DESC',
  CtaTitleAsc = 'ctaTitle_ASC',
  CtaTitleDesc = 'ctaTitle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  StatTypeAsc = 'statType_ASC',
  StatTypeDesc = 'statType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type Tab = Entry & _Node & {
  __typename?: 'Tab';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy?: Maybe<TabCopy>;
  ctaLinkAssetPrimary?: Maybe<Asset>;
  ctaLinkContentPrimaryCollection?: Maybe<TabCtaLinkContentPrimaryCollection>;
  ctaLinkContentPrimaryCursorCollection?: Maybe<TabCtaLinkContentPrimaryCursorCollection>;
  ctaLinkPrimary?: Maybe<Scalars['String']['output']>;
  ctaTitlePrimary?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<TabLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCtaLinkAssetPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCtaLinkContentPrimaryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabCtaLinkContentPrimaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCtaLinkContentPrimaryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabCtaLinkContentPrimaryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCtaLinkPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabCtaTitlePrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/kntwz3la4fsz/content_types/tab) */
export type TabTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabCollection = {
  __typename?: 'TabCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabCopy = {
  __typename?: 'TabCopy';
  json: Scalars['JSON']['output'];
  links: TabCopyLinks;
};

export type TabCopyAssets = {
  __typename?: 'TabCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TabCopyEntries = {
  __typename?: 'TabCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TabCopyLinks = {
  __typename?: 'TabCopyLinks';
  assets: TabCopyAssets;
  entries: TabCopyEntries;
  resources: TabCopyResources;
};

export type TabCopyResources = {
  __typename?: 'TabCopyResources';
  block: Array<TabCopyResourcesBlock>;
  hyperlink: Array<TabCopyResourcesHyperlink>;
  inline: Array<TabCopyResourcesInline>;
};

export type TabCopyResourcesBlock = ResourceLink & {
  __typename?: 'TabCopyResourcesBlock';
  sys: ResourceSys;
};

export type TabCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'TabCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type TabCopyResourcesInline = ResourceLink & {
  __typename?: 'TabCopyResourcesInline';
  sys: ResourceSys;
};

export type TabCtaLinkContentPrimaryCollection = {
  __typename?: 'TabCtaLinkContentPrimaryCollection';
  items: Array<Maybe<TabCtaLinkContentPrimaryItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabCtaLinkContentPrimaryCursorCollection = {
  __typename?: 'TabCtaLinkContentPrimaryCursorCollection';
  items: Array<Maybe<TabCtaLinkContentPrimaryItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TabCtaLinkContentPrimaryFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabCtaLinkContentPrimaryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabCtaLinkContentPrimaryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TabCtaLinkContentPrimaryItem = BlogPost | Page | Program;

export type TabCursorCollection = {
  __typename?: 'TabCursorCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TabFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAssetPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentPrimary?: InputMaybe<CfctaLinkContentPrimaryMultiTypeNestedFilter>;
  ctaLinkContentPrimaryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkPrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitlePrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TabLinkingCollections = {
  __typename?: 'TabLinkingCollections';
  blockTabsCollection?: Maybe<BlockTabsCollection>;
  blockTabsCursorCollection?: Maybe<BlockTabsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type TabLinkingCollectionsBlockTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsBlockTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsBlockTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsBlockTabsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TabLinkingCollectionsBlockTabsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TabLinkingCollectionsBlockTabsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TabOrder {
  CtaLinkPrimaryAsc = 'ctaLinkPrimary_ASC',
  CtaLinkPrimaryDesc = 'ctaLinkPrimary_DESC',
  CtaTitlePrimaryAsc = 'ctaTitlePrimary_ASC',
  CtaTitlePrimaryDesc = 'ctaTitlePrimary_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfBlockQuotationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlockQuotationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlockQuotationNestedFilter>>>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  attribution_contains?: InputMaybe<Scalars['String']['input']>;
  attribution_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attribution_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribution_not?: InputMaybe<Scalars['String']['input']>;
  attribution_not_contains?: InputMaybe<Scalars['String']['input']>;
  attribution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  quote_contains?: InputMaybe<Scalars['String']['input']>;
  quote_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote_not?: InputMaybe<Scalars['String']['input']>;
  quote_not_contains?: InputMaybe<Scalars['String']['input']>;
  quote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator?: InputMaybe<Scalars['String']['input']>;
  separator_contains?: InputMaybe<Scalars['String']['input']>;
  separator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  separator_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  separator_not?: InputMaybe<Scalars['String']['input']>;
  separator_not_contains?: InputMaybe<Scalars['String']['input']>;
  separator_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogPostNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogPostNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogPostNestedFilter>>>;
  authorsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  closerBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  featuredOrder?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featuredOrder_gt?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_gte?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  featuredOrder_lt?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_lte?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_not?: InputMaybe<Scalars['Int']['input']>;
  featuredOrder_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_not?: InputMaybe<Scalars['String']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  summary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBulletinNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBulletinNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBulletinNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle?: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDonationAppealNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfDonationAppealNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfDonationAppealNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption?: InputMaybe<Scalars['String']['input']>;
  imageCaption_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink?: InputMaybe<Scalars['String']['input']>;
  moreLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink_contains?: InputMaybe<Scalars['String']['input']>;
  moreLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moreLink_not?: InputMaybe<Scalars['String']['input']>;
  moreLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  moreLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNavigationLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkEntryReferenceCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkStatic?: InputMaybe<Scalars['String']['input']>;
  linkStatic_contains?: InputMaybe<Scalars['String']['input']>;
  linkStatic_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkStatic_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkStatic_not?: InputMaybe<Scalars['String']['input']>;
  linkStatic_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkStatic_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPartnerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPartnerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPartnerNestedFilter>>>;
  campaignUrl?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_contains?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaignUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignUrl_not?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  campaignUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createPage?: InputMaybe<Scalars['Boolean']['input']>;
  createPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createPage_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_contains?: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPersonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains?: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not?: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fullName_contains?: InputMaybe<Scalars['String']['input']>;
  fullName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName_not?: InputMaybe<Scalars['String']['input']>;
  fullName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fullName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains?: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not?: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  shortBio_contains?: InputMaybe<Scalars['String']['input']>;
  shortBio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shortBio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortBio_not?: InputMaybe<Scalars['String']['input']>;
  shortBio_not_contains?: InputMaybe<Scalars['String']['input']>;
  shortBio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfProgramNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProgramNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProgramNestedFilter>>>;
  contentBlocksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  donateLink?: InputMaybe<Scalars['String']['input']>;
  donateLink_contains?: InputMaybe<Scalars['String']['input']>;
  donateLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  donateLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donateLink_not?: InputMaybe<Scalars['String']['input']>;
  donateLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  donateLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overview?: InputMaybe<Scalars['String']['input']>;
  overview_contains?: InputMaybe<Scalars['String']['input']>;
  overview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overview_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overview_not?: InputMaybe<Scalars['String']['input']>;
  overview_not_contains?: InputMaybe<Scalars['String']['input']>;
  overview_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfStatisticNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfStatisticNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfStatisticNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy?: InputMaybe<Scalars['String']['input']>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not?: InputMaybe<Scalars['String']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaHeadline_not?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLink_not?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitle_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  statType?: InputMaybe<Scalars['String']['input']>;
  statType_contains?: InputMaybe<Scalars['String']['input']>;
  statType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  statType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statType_not?: InputMaybe<Scalars['String']['input']>;
  statType_not_contains?: InputMaybe<Scalars['String']['input']>;
  statType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTabNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  copy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkAssetPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkContentPrimaryCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLinkPrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLinkPrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLinkPrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaTitlePrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaTitlePrimary_not?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaTitlePrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcloserBlocksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcloserBlocksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcloserBlocksMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcontentBlocksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentBlocksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentBlocksMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfctaLinkContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfctaLinkContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfctaLinkContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfctaLinkContentPrimaryMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfctaLinkContentPrimaryMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfctaLinkContentPrimaryMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfctaLinkContentSecondaryMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfctaLinkContentSecondaryMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfctaLinkContentSecondaryMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CflinkEntryReferenceMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CflinkEntryReferenceMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CflinkEntryReferenceMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfmoreLinkContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfmoreLinkContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfmoreLinkContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaKeywords_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfnavigationItemsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfnavigationItemsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfnavigationItemsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AssetFragment = { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BasicPageFragment = { __typename: 'BasicPage', title?: string | null, slug?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, copy?: { __typename?: 'BasicPageCopy', json: any, links: { __typename?: 'BasicPageCopyLinks', entries: { __typename?: 'BasicPageCopyEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBasicPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBasicPageBySlugQuery = { __typename?: 'Query', basicPageCollection?: { __typename?: 'BasicPageCollection', items: Array<{ __typename: 'BasicPage', title?: string | null, slug?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, copy?: { __typename?: 'BasicPageCopy', json: any, links: { __typename?: 'BasicPageCopyLinks', entries: { __typename?: 'BasicPageCopyEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetBasicPageSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBasicPageSlugByIdQuery = { __typename?: 'Query', basicPage?: { __typename?: 'BasicPage', slug?: string | null } | null };

export type GetBasicPageSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBasicPageSlugsQuery = { __typename?: 'Query', basicPageCollection?: { __typename?: 'BasicPageCollection', total: number, items: Array<{ __typename: 'BasicPage', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type BlockBlogPostsFragment = { __typename: 'BlockBlogPosts', headline?: string | null, blogPostsCollection?: { __typename?: 'BlockBlogPostsBlogPostsCollection', items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, summary?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockBlogPostsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockBlogPostsQuery = { __typename?: 'Query', blockBlogPosts?: { __typename: 'BlockBlogPosts', headline?: string | null, blogPostsCollection?: { __typename?: 'BlockBlogPostsBlogPostsCollection', items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, summary?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BulletinItemFragment = { __typename: 'Bulletin', imageCaption?: string | null, icon?: string | null, copy?: string | null, title?: string | null, ctaTitle?: string | null, ctaLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BulletinCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockBulletinBoardFragment = { __typename: 'BulletinBoard', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, visualStyle?: string | null, separator?: string | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BulletinBoardCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, bulletinsCollection?: { __typename?: 'BulletinBoardBulletinsCollection', items: Array<{ __typename: 'Bulletin', imageCaption?: string | null, icon?: string | null, copy?: string | null, title?: string | null, ctaTitle?: string | null, ctaLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BulletinCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockBulletinBoardQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockBulletinBoardQuery = { __typename?: 'Query', bulletinBoard?: { __typename: 'BulletinBoard', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, visualStyle?: string | null, separator?: string | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BulletinBoardCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, bulletinsCollection?: { __typename?: 'BulletinBoardBulletinsCollection', items: Array<{ __typename: 'Bulletin', imageCaption?: string | null, icon?: string | null, copy?: string | null, title?: string | null, ctaTitle?: string | null, ctaLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BulletinCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockClassyFragment = { __typename: 'BlockClassy', headline?: string | null, campaignId?: string | null, recurringNudges?: boolean | null, size?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockClassyQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockClassyQuery = { __typename?: 'Query', blockClassy?: { __typename: 'BlockClassy', headline?: string | null, campaignId?: string | null, recurringNudges?: boolean | null, size?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockCollapsibleFragment = { __typename: 'BlockCollapsible', ctaTitle?: string | null, block?: { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null, collapsedBlock?: { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockCollapsibleQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockCollapsibleQuery = { __typename?: 'Query', blockCollapsible?: { __typename: 'BlockCollapsible', ctaTitle?: string | null, block?: { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null, collapsedBlock?: { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockCopyFragment = { __typename: 'LayoutCopy', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, visualStyle?: string | null, dropCap?: boolean | null, separator?: string | null, text?: { __typename?: 'LayoutCopyCopy', json: any, links: { __typename?: 'LayoutCopyCopyLinks', entries: { __typename?: 'LayoutCopyCopyEntries', block: Array<{ __typename: 'BasicPage' } | { __typename: 'BlockBlogPosts' } | { __typename: 'BlockClassy' } | { __typename: 'BlockCollapsible' } | { __typename: 'BlockCta' } | { __typename: 'BlockCustomComponent' } | { __typename: 'BlockDonate' } | { __typename: 'BlockElfsightWidget' } | { __typename: 'BlockEmailCollection' } | { __typename: 'BlockFormAssembly' } | { __typename: 'BlockFundraiseUp' } | { __typename: 'BlockHighlight' } | { __typename: 'BlockImages' } | { __typename: 'BlockImpactStatistics' } | { __typename: 'BlockPartners' } | { __typename: 'BlockPeople' } | { __typename: 'BlockPrograms' } | { __typename: 'BlockQuotation' } | { __typename: 'BlockQuotations' } | { __typename: 'BlockShare' } | { __typename: 'BlockTabs' } | { __typename: 'BlockThermometer' } | { __typename: 'BlockVideo' } | { __typename: 'BlogCategory' } | { __typename: 'BlogPost' } | { __typename: 'Bulletin' } | { __typename: 'BulletinBoard' } | { __typename: 'DonationAppeal' } | { __typename: 'EmbedInstagram', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero' } | { __typename: 'Hospital' } | { __typename: 'KnowledgeBasedResource' } | { __typename: 'LayoutCopy' } | { __typename: 'NavigationDropdown' } | { __typename: 'NavigationLink' } | { __typename: 'NavigationPrimary' } | { __typename: 'NavigationSecondary' } | { __typename: 'Page' } | { __typename: 'Partner' } | { __typename: 'Person' } | { __typename: 'PressRelease' } | { __typename: 'Program' } | { __typename: 'Redirect' } | { __typename: 'Statistic' } | { __typename: 'Tab' } | null>, hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'LayoutCopyCopyAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, ctaLinkContentCollection?: { __typename?: 'LayoutCopyCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockCopyQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockCopyQuery = { __typename?: 'Query', layoutCopy?: { __typename: 'LayoutCopy', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, visualStyle?: string | null, dropCap?: boolean | null, separator?: string | null, text?: { __typename?: 'LayoutCopyCopy', json: any, links: { __typename?: 'LayoutCopyCopyLinks', entries: { __typename?: 'LayoutCopyCopyEntries', block: Array<{ __typename: 'BasicPage' } | { __typename: 'BlockBlogPosts' } | { __typename: 'BlockClassy' } | { __typename: 'BlockCollapsible' } | { __typename: 'BlockCta' } | { __typename: 'BlockCustomComponent' } | { __typename: 'BlockDonate' } | { __typename: 'BlockElfsightWidget' } | { __typename: 'BlockEmailCollection' } | { __typename: 'BlockFormAssembly' } | { __typename: 'BlockFundraiseUp' } | { __typename: 'BlockHighlight' } | { __typename: 'BlockImages' } | { __typename: 'BlockImpactStatistics' } | { __typename: 'BlockPartners' } | { __typename: 'BlockPeople' } | { __typename: 'BlockPrograms' } | { __typename: 'BlockQuotation' } | { __typename: 'BlockQuotations' } | { __typename: 'BlockShare' } | { __typename: 'BlockTabs' } | { __typename: 'BlockThermometer' } | { __typename: 'BlockVideo' } | { __typename: 'BlogCategory' } | { __typename: 'BlogPost' } | { __typename: 'Bulletin' } | { __typename: 'BulletinBoard' } | { __typename: 'DonationAppeal' } | { __typename: 'EmbedInstagram', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero' } | { __typename: 'Hospital' } | { __typename: 'KnowledgeBasedResource' } | { __typename: 'LayoutCopy' } | { __typename: 'NavigationDropdown' } | { __typename: 'NavigationLink' } | { __typename: 'NavigationPrimary' } | { __typename: 'NavigationSecondary' } | { __typename: 'Page' } | { __typename: 'Partner' } | { __typename: 'Person' } | { __typename: 'PressRelease' } | { __typename: 'Program' } | { __typename: 'Redirect' } | { __typename: 'Statistic' } | { __typename: 'Tab' } | null>, hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'LayoutCopyCopyAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, ctaLinkContentCollection?: { __typename?: 'LayoutCopyCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockCtaFragment = { __typename: 'BlockCta', headline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, variant?: string | null, copy?: { __typename?: 'BlockCtaCopy', json: any, links: { __typename?: 'BlockCtaCopyLinks', entries: { __typename?: 'BlockCtaCopyEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'BlockCtaCopyAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockCtaCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockCtaQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockCtaQuery = { __typename?: 'Query', blockCta?: { __typename: 'BlockCta', headline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, variant?: string | null, copy?: { __typename?: 'BlockCtaCopy', json: any, links: { __typename?: 'BlockCtaCopyLinks', entries: { __typename?: 'BlockCtaCopyEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'BlockCtaCopyAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockCtaCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockCustomComponentFragment = { __typename: 'BlockCustomComponent', componentName?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockCustomComponentQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockCustomComponentQuery = { __typename?: 'Query', blockCustomComponent?: { __typename: 'BlockCustomComponent', componentName?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type DonateAppealItemFragment = { __typename: 'DonationAppeal', icon?: string | null, headline?: string | null, copy?: string | null, imageCaption?: string | null, ctaTitle?: string | null, ctaLink?: string | null, moreLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'DonationAppealCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, moreLinkContentCollection?: { __typename?: 'DonationAppealMoreLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, moreLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockDonateFragment = { __typename: 'BlockDonate', icon?: string | null, headline?: string | null, separator?: string | null, donationAppealsCollection?: { __typename?: 'BlockDonateDonationAppealsCollection', items: Array<{ __typename: 'DonationAppeal', icon?: string | null, headline?: string | null, copy?: string | null, imageCaption?: string | null, ctaTitle?: string | null, ctaLink?: string | null, moreLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'DonationAppealCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, moreLinkContentCollection?: { __typename?: 'DonationAppealMoreLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, moreLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockDonateQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockDonateQuery = { __typename?: 'Query', blockDonate?: { __typename: 'BlockDonate', icon?: string | null, headline?: string | null, separator?: string | null, donationAppealsCollection?: { __typename?: 'BlockDonateDonationAppealsCollection', items: Array<{ __typename: 'DonationAppeal', icon?: string | null, headline?: string | null, copy?: string | null, imageCaption?: string | null, ctaTitle?: string | null, ctaLink?: string | null, moreLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'DonationAppealCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, moreLinkContentCollection?: { __typename?: 'DonationAppealMoreLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, moreLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockElfsightWidgetFragment = { __typename: 'BlockElfsightWidget', headline?: string | null, icon?: string | null, appId?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockElfsightCalendarQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockElfsightCalendarQuery = { __typename?: 'Query', blockElfsightWidget?: { __typename: 'BlockElfsightWidget', headline?: string | null, icon?: string | null, appId?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockEmailCollectionFragment = { __typename: 'BlockEmailCollection', heading?: string | null, copy?: string | null, icon?: string | null, ctaTitle?: string | null, formId?: string | null, separator?: string | null, urlEndpoint?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockEmailCollectionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockEmailCollectionQuery = { __typename?: 'Query', blockEmailCollection?: { __typename: 'BlockEmailCollection', heading?: string | null, copy?: string | null, icon?: string | null, ctaTitle?: string | null, formId?: string | null, separator?: string | null, urlEndpoint?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockFormAssemblyFragment = { __typename: 'BlockFormAssembly', html?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockFormAssemblyQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockFormAssemblyQuery = { __typename?: 'Query', blockFormAssembly?: { __typename: 'BlockFormAssembly', html?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockFundraiseUpFragment = { __typename: 'BlockFundraiseUp', elementId?: string | null, headline?: string | null, widgetType?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockFundraiseUpQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockFundraiseUpQuery = { __typename?: 'Query', blockFundraiseUp?: { __typename: 'BlockFundraiseUp', elementId?: string | null, headline?: string | null, widgetType?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockHeroFragment = { __typename: 'Hero', kicker?: string | null, headline?: string | null, copy?: string | null, ctaTitlePrimary?: string | null, ctaLinkPrimary?: string | null, ctaTitleSecondary?: string | null, ctaLinkSecondary?: string | null, ctaProminence?: string | null, separator?: string | null, aspectRatio?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, logo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentPrimaryCollection?: { __typename?: 'HeroCtaLinkContentPrimaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetPrimary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentSecondaryCollection?: { __typename?: 'HeroCtaLinkContentSecondaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetSecondary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockHeroQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockHeroQuery = { __typename?: 'Query', hero?: { __typename: 'Hero', kicker?: string | null, headline?: string | null, copy?: string | null, ctaTitlePrimary?: string | null, ctaLinkPrimary?: string | null, ctaTitleSecondary?: string | null, ctaLinkSecondary?: string | null, ctaProminence?: string | null, separator?: string | null, aspectRatio?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, logo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentPrimaryCollection?: { __typename?: 'HeroCtaLinkContentPrimaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetPrimary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentSecondaryCollection?: { __typename?: 'HeroCtaLinkContentSecondaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetSecondary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockHighlightFragment = { __typename: 'BlockHighlight', headline?: string | null, copy?: string | null, imageCaption?: string | null, ctaTitle?: string | null, ctaLink?: string | null, ctaVariant?: string | null, decoration?: string | null, aspectRatio?: string | null, reversed?: boolean | null, background?: string | null, text?: { __typename?: 'BlockHighlightText', json: any, links: { __typename?: 'BlockHighlightTextLinks', entries: { __typename?: 'BlockHighlightTextEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'BlockHighlightTextAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockHighlightCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockHighlightQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockHighlightQuery = { __typename?: 'Query', blockHighlight?: { __typename: 'BlockHighlight', headline?: string | null, copy?: string | null, imageCaption?: string | null, ctaTitle?: string | null, ctaLink?: string | null, ctaVariant?: string | null, decoration?: string | null, aspectRatio?: string | null, reversed?: boolean | null, background?: string | null, text?: { __typename?: 'BlockHighlightText', json: any, links: { __typename?: 'BlockHighlightTextLinks', entries: { __typename?: 'BlockHighlightTextEntries', hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'BlockHighlightTextAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockHighlightCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockImagesFragment = { __typename: 'BlockImages', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, ctaLinkContentCollection?: { __typename?: 'BlockImagesCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, imagesCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename: 'Asset', title?: string | null, description?: string | null, url?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockImagesQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockImagesQuery = { __typename?: 'Query', blockImages?: { __typename: 'BlockImages', icon?: string | null, headline?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, ctaLinkContentCollection?: { __typename?: 'BlockImagesCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, imagesCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename: 'Asset', title?: string | null, description?: string | null, url?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type StatisticItemFragment = { __typename: 'Statistic', headline?: string | null, copy?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, statType?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'StatisticCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockStatisticsFragment = { __typename: 'BlockImpactStatistics', icon?: string | null, headline?: string | null, copy?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, statisticsCollection?: { __typename?: 'BlockImpactStatisticsStatisticsCollection', items: Array<{ __typename: 'Statistic', headline?: string | null, copy?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, statType?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'StatisticCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockImpactStatisticsCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockStatisticsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockStatisticsQuery = { __typename?: 'Query', blockImpactStatistics?: { __typename: 'BlockImpactStatistics', icon?: string | null, headline?: string | null, copy?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, statisticsCollection?: { __typename?: 'BlockImpactStatisticsStatisticsCollection', items: Array<{ __typename: 'Statistic', headline?: string | null, copy?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, statType?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'StatisticCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockImpactStatisticsCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type GetBlockImpactStatisticIdsByStatisticIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBlockImpactStatisticIdsByStatisticIdQuery = { __typename?: 'Query', statistic?: { __typename?: 'Statistic', linkedFrom?: { __typename?: 'StatisticLinkingCollections', blockImpactStatisticsCollection?: { __typename?: 'BlockImpactStatisticsCollection', items: Array<{ __typename?: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null } | null };

export type PartnerTeaserFragment = { __typename: 'Partner', title?: string | null, slug?: string | null, createPage?: boolean | null, shortDescription?: { __typename?: 'PartnerShortDescription', json: any } | null, logo?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, image?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockPartnersFragment = { __typename: 'BlockPartners', headline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, layout?: string | null, partnersCollection?: { __typename?: 'BlockPartnersPartnersCollection', items: Array<{ __typename: 'Partner', title?: string | null, slug?: string | null, createPage?: boolean | null, shortDescription?: { __typename?: 'PartnerShortDescription', json: any } | null, logo?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, image?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkContentCollection?: { __typename?: 'BlockPartnersCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockPartnersQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockPartnersQuery = { __typename?: 'Query', blockPartners?: { __typename: 'BlockPartners', headline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, layout?: string | null, partnersCollection?: { __typename?: 'BlockPartnersPartnersCollection', items: Array<{ __typename: 'Partner', title?: string | null, slug?: string | null, createPage?: boolean | null, shortDescription?: { __typename?: 'PartnerShortDescription', json: any } | null, logo?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, image?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkContentCollection?: { __typename?: 'BlockPartnersCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type PersonItemFragment = { __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockPeopleFragment = { __typename: 'BlockPeople', headline?: string | null, icon?: string | null, separator?: string | null, peopleCollection?: { __typename?: 'BlockPeoplePeopleCollection', items: Array<{ __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockPeopleQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockPeopleQuery = { __typename?: 'Query', blockPeople?: { __typename: 'BlockPeople', headline?: string | null, icon?: string | null, separator?: string | null, peopleCollection?: { __typename?: 'BlockPeoplePeopleCollection', items: Array<{ __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type GetBlockPeopleIdsByPersonIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBlockPeopleIdsByPersonIdQuery = { __typename?: 'Query', person?: { __typename?: 'Person', linkedFrom?: { __typename?: 'PersonLinkingCollections', blockPeopleCollection?: { __typename?: 'BlockPeopleCollection', items: Array<{ __typename?: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null } | null };

export type ProgramItemFragment = { __typename: 'Program', title?: string | null, icon?: string | null, slug?: string | null, overview?: string | null, donateLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockProgramsFragment = { __typename: 'BlockPrograms', icon?: string | null, headline?: string | null, separator?: string | null, programsCollection?: { __typename?: 'BlockProgramsProgramsCollection', items: Array<{ __typename: 'Program', title?: string | null, icon?: string | null, slug?: string | null, overview?: string | null, donateLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockProgramsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockProgramsQuery = { __typename?: 'Query', blockPrograms?: { __typename: 'BlockPrograms', icon?: string | null, headline?: string | null, separator?: string | null, programsCollection?: { __typename?: 'BlockProgramsProgramsCollection', items: Array<{ __typename: 'Program', title?: string | null, icon?: string | null, slug?: string | null, overview?: string | null, donateLink?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type GetBlockProgramIdsByProgramIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBlockProgramIdsByProgramIdQuery = { __typename?: 'Query', program?: { __typename?: 'Program', linkedFrom?: { __typename?: 'ProgramLinkingCollections', blockProgramsCollection?: { __typename?: 'BlockProgramsCollection', items: Array<{ __typename?: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null } | null };

export type BlockQuotationFragment = { __typename: 'BlockQuotation', quote?: string | null, attribution?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, variant?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockQuotationCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockQuotationQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockQuotationQuery = { __typename?: 'Query', blockQuotation?: { __typename: 'BlockQuotation', quote?: string | null, attribution?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, variant?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockQuotationCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockQuotationsFragment = { __typename: 'BlockQuotations', variant?: string | null, quotationsCollection?: { __typename?: 'BlockQuotationsQuotationsCollection', items: Array<{ __typename: 'BlockQuotation', quote?: string | null, attribution?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, variant?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockQuotationCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockQuotationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockQuotationsQuery = { __typename?: 'Query', blockQuotations?: { __typename: 'BlockQuotations', variant?: string | null, quotationsCollection?: { __typename?: 'BlockQuotationsQuotationsCollection', items: Array<{ __typename: 'BlockQuotation', quote?: string | null, attribution?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, variant?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockQuotationCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockShareFragment = { __typename: 'BlockShare', icon?: string | null, heading?: string | null, copy?: string | null, url?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockShareQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockShareQuery = { __typename?: 'Query', blockShare?: { __typename: 'BlockShare', icon?: string | null, heading?: string | null, copy?: string | null, url?: string | null, separator?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type TabItemFragment = { __typename: 'Tab', headline?: string | null, ctaTitlePrimary?: string | null, ctaLinkPrimary?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, copy?: { __typename?: 'TabCopy', json: any, links: { __typename?: 'TabCopyLinks', assets: { __typename?: 'TabCopyAssets', hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, ctaLinkContentPrimaryCollection?: { __typename?: 'TabCtaLinkContentPrimaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetPrimary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlockTabsFragment = { __typename: 'BlockTabs', tabsCollection?: { __typename?: 'BlockTabsTabsCollection', items: Array<{ __typename: 'Tab', headline?: string | null, ctaTitlePrimary?: string | null, ctaLinkPrimary?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, copy?: { __typename?: 'TabCopy', json: any, links: { __typename?: 'TabCopyLinks', assets: { __typename?: 'TabCopyAssets', hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, ctaLinkContentPrimaryCollection?: { __typename?: 'TabCtaLinkContentPrimaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetPrimary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockTabsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockTabsQuery = { __typename?: 'Query', blockTabs?: { __typename: 'BlockTabs', tabsCollection?: { __typename?: 'BlockTabsTabsCollection', items: Array<{ __typename: 'Tab', headline?: string | null, ctaTitlePrimary?: string | null, ctaLinkPrimary?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, copy?: { __typename?: 'TabCopy', json: any, links: { __typename?: 'TabCopyLinks', assets: { __typename?: 'TabCopyAssets', hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, ctaLinkContentPrimaryCollection?: { __typename?: 'TabCtaLinkContentPrimaryCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAssetPrimary?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type GetBlockTabsIdsByTabIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBlockTabsIdsByTabIdQuery = { __typename?: 'Query', tab?: { __typename?: 'Tab', linkedFrom?: { __typename?: 'TabLinkingCollections', blockTabsCollection?: { __typename?: 'BlockTabsCollection', items: Array<{ __typename?: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null } | null };

export type BlockThermometerFragment = { __typename: 'BlockThermometer', title?: string | null, milestones?: Array<string | null> | null, amountRaised?: number | null, amountGoal?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockThermometerQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockThermometerQuery = { __typename?: 'Query', blockThermometer?: { __typename: 'BlockThermometer', title?: string | null, milestones?: Array<string | null> | null, amountRaised?: number | null, amountGoal?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlockVideoFragment = { __typename: 'BlockVideo', icon?: string | null, headline?: string | null, autoplay?: boolean | null, playerSize?: string | null, videoUrl?: string | null, description?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, thumbnail?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockVideoCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetBlockVideoQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlockVideoQuery = { __typename?: 'Query', blockVideo?: { __typename: 'BlockVideo', icon?: string | null, headline?: string | null, autoplay?: boolean | null, playerSize?: string | null, videoUrl?: string | null, description?: string | null, ctaHeadline?: string | null, ctaTitle?: string | null, ctaLink?: string | null, separator?: string | null, thumbnail?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, ctaLinkContentCollection?: { __typename?: 'BlockVideoCtaLinkContentCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, ctaLinkAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, videoAsset?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type BlogTeaserFragment = { __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, summary?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlogPageFragment = { __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'BlogPostContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, closerBlocks?: { __typename?: 'BlogPostCloserBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | null> } | null, authors?: { __typename?: 'BlogPostAuthorsCollection', items: Array<{ __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type BlogCategoryFragment = { __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type GetBlogSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostFilter>;
  order?: InputMaybe<Array<InputMaybe<BlogPostOrder>> | InputMaybe<BlogPostOrder>>;
}>;


export type GetBlogSlugsQuery = { __typename?: 'Query', blogPostCollection?: { __typename?: 'BlogPostCollection', total: number, items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetBlogPostsQueryVariables = Exact<{
  where?: InputMaybe<BlogPostFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostOrder>> | InputMaybe<BlogPostOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  isTeaser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlogPostsQuery = { __typename?: 'Query', blogs?: { __typename?: 'BlogPostCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, summary?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, blocks?: { __typename?: 'BlogPostContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, closerBlocks?: { __typename?: 'BlogPostCloserBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | null> } | null, authors?: { __typename?: 'BlogPostAuthorsCollection', items: Array<{ __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type SearchBlogPostsQueryVariables = Exact<{
  where?: InputMaybe<BlogPostFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogPostOrder>> | InputMaybe<BlogPostOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchBlogPostsQuery = { __typename?: 'Query', blogs?: { __typename?: 'BlogPostCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, summary?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetBlogPostBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlogPostBySlugQuery = { __typename?: 'Query', blogPostCollection?: { __typename?: 'BlogPostCollection', items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'BlogPostContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, closerBlocks?: { __typename?: 'BlogPostCloserBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | null> } | null, authors?: { __typename?: 'BlogPostAuthorsCollection', items: Array<{ __typename: 'Person', fullName?: string | null, firstName?: string | null, lastName?: string | null, jobTitle?: string | null, emailAddress?: string | null, shortBio?: string | null, photo?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, categories?: { __typename?: 'BlogPostCategoriesCollection', items: Array<{ __typename?: 'BlogCategory', title?: string | null, color?: any | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetBlogPostSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBlogPostSlugByIdQuery = { __typename?: 'Query', blogPost?: { __typename?: 'BlogPost', slug?: string | null } | null };

export type GetBlogPostSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBlogPostSlugsQuery = { __typename?: 'Query', blogPostCollection?: { __typename?: 'BlogPostCollection', total: number, items: Array<{ __typename: 'BlogPost', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

type ContentBlock_BasicPage_Fragment = { __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockCta_Fragment = { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockImages_Fragment = { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockShare_Fragment = { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BlogPost_Fragment = { __typename: 'BlogPost', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Bulletin_Fragment = { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Hero_Fragment = { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Hospital_Fragment = { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Partner_Fragment = { __typename: 'Partner', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Person_Fragment = { __typename: 'Person', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_PressRelease_Fragment = { __typename: 'PressRelease', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Program_Fragment = { __typename: 'Program', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Redirect_Fragment = { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Statistic_Fragment = { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string } };

type ContentBlock_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } };

export type ContentBlockFragment = ContentBlock_BasicPage_Fragment | ContentBlock_BlockBlogPosts_Fragment | ContentBlock_BlockClassy_Fragment | ContentBlock_BlockCollapsible_Fragment | ContentBlock_BlockCta_Fragment | ContentBlock_BlockCustomComponent_Fragment | ContentBlock_BlockDonate_Fragment | ContentBlock_BlockElfsightWidget_Fragment | ContentBlock_BlockEmailCollection_Fragment | ContentBlock_BlockFormAssembly_Fragment | ContentBlock_BlockFundraiseUp_Fragment | ContentBlock_BlockHighlight_Fragment | ContentBlock_BlockImages_Fragment | ContentBlock_BlockImpactStatistics_Fragment | ContentBlock_BlockPartners_Fragment | ContentBlock_BlockPeople_Fragment | ContentBlock_BlockPrograms_Fragment | ContentBlock_BlockQuotation_Fragment | ContentBlock_BlockQuotations_Fragment | ContentBlock_BlockShare_Fragment | ContentBlock_BlockTabs_Fragment | ContentBlock_BlockThermometer_Fragment | ContentBlock_BlockVideo_Fragment | ContentBlock_BlogCategory_Fragment | ContentBlock_BlogPost_Fragment | ContentBlock_Bulletin_Fragment | ContentBlock_BulletinBoard_Fragment | ContentBlock_DonationAppeal_Fragment | ContentBlock_EmbedInstagram_Fragment | ContentBlock_EmbedTwitter_Fragment | ContentBlock_Hero_Fragment | ContentBlock_Hospital_Fragment | ContentBlock_KnowledgeBasedResource_Fragment | ContentBlock_LayoutCopy_Fragment | ContentBlock_NavigationDropdown_Fragment | ContentBlock_NavigationLink_Fragment | ContentBlock_NavigationPrimary_Fragment | ContentBlock_NavigationSecondary_Fragment | ContentBlock_Page_Fragment | ContentBlock_Partner_Fragment | ContentBlock_Person_Fragment | ContentBlock_PressRelease_Fragment | ContentBlock_Program_Fragment | ContentBlock_Redirect_Fragment | ContentBlock_Statistic_Fragment | ContentBlock_Tab_Fragment;

type Entry_BasicPage_Fragment = { __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockCta_Fragment = { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockImages_Fragment = { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockShare_Fragment = { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BlogPost_Fragment = { __typename: 'BlogPost', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Bulletin_Fragment = { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Hero_Fragment = { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Hospital_Fragment = { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Partner_Fragment = { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Person_Fragment = { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_PressRelease_Fragment = { __typename: 'PressRelease', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Program_Fragment = { __typename: 'Program', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Redirect_Fragment = { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Statistic_Fragment = { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type Entry_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type EntryFragment = Entry_BasicPage_Fragment | Entry_BlockBlogPosts_Fragment | Entry_BlockClassy_Fragment | Entry_BlockCollapsible_Fragment | Entry_BlockCta_Fragment | Entry_BlockCustomComponent_Fragment | Entry_BlockDonate_Fragment | Entry_BlockElfsightWidget_Fragment | Entry_BlockEmailCollection_Fragment | Entry_BlockFormAssembly_Fragment | Entry_BlockFundraiseUp_Fragment | Entry_BlockHighlight_Fragment | Entry_BlockImages_Fragment | Entry_BlockImpactStatistics_Fragment | Entry_BlockPartners_Fragment | Entry_BlockPeople_Fragment | Entry_BlockPrograms_Fragment | Entry_BlockQuotation_Fragment | Entry_BlockQuotations_Fragment | Entry_BlockShare_Fragment | Entry_BlockTabs_Fragment | Entry_BlockThermometer_Fragment | Entry_BlockVideo_Fragment | Entry_BlogCategory_Fragment | Entry_BlogPost_Fragment | Entry_Bulletin_Fragment | Entry_BulletinBoard_Fragment | Entry_DonationAppeal_Fragment | Entry_EmbedInstagram_Fragment | Entry_EmbedTwitter_Fragment | Entry_Hero_Fragment | Entry_Hospital_Fragment | Entry_KnowledgeBasedResource_Fragment | Entry_LayoutCopy_Fragment | Entry_NavigationDropdown_Fragment | Entry_NavigationLink_Fragment | Entry_NavigationPrimary_Fragment | Entry_NavigationSecondary_Fragment | Entry_Page_Fragment | Entry_Partner_Fragment | Entry_Person_Fragment | Entry_PressRelease_Fragment | Entry_Program_Fragment | Entry_Redirect_Fragment | Entry_Statistic_Fragment | Entry_Tab_Fragment;

type LinkedContentSlugs_BasicPage_Fragment = { __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockCta_Fragment = { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockImages_Fragment = { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockShare_Fragment = { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BlogPost_Fragment = { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Bulletin_Fragment = { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Hero_Fragment = { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Hospital_Fragment = { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Page_Fragment = { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Partner_Fragment = { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Person_Fragment = { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_PressRelease_Fragment = { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Program_Fragment = { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Redirect_Fragment = { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Statistic_Fragment = { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

type LinkedContentSlugs_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type LinkedContentSlugsFragment = LinkedContentSlugs_BasicPage_Fragment | LinkedContentSlugs_BlockBlogPosts_Fragment | LinkedContentSlugs_BlockClassy_Fragment | LinkedContentSlugs_BlockCollapsible_Fragment | LinkedContentSlugs_BlockCta_Fragment | LinkedContentSlugs_BlockCustomComponent_Fragment | LinkedContentSlugs_BlockDonate_Fragment | LinkedContentSlugs_BlockElfsightWidget_Fragment | LinkedContentSlugs_BlockEmailCollection_Fragment | LinkedContentSlugs_BlockFormAssembly_Fragment | LinkedContentSlugs_BlockFundraiseUp_Fragment | LinkedContentSlugs_BlockHighlight_Fragment | LinkedContentSlugs_BlockImages_Fragment | LinkedContentSlugs_BlockImpactStatistics_Fragment | LinkedContentSlugs_BlockPartners_Fragment | LinkedContentSlugs_BlockPeople_Fragment | LinkedContentSlugs_BlockPrograms_Fragment | LinkedContentSlugs_BlockQuotation_Fragment | LinkedContentSlugs_BlockQuotations_Fragment | LinkedContentSlugs_BlockShare_Fragment | LinkedContentSlugs_BlockTabs_Fragment | LinkedContentSlugs_BlockThermometer_Fragment | LinkedContentSlugs_BlockVideo_Fragment | LinkedContentSlugs_BlogCategory_Fragment | LinkedContentSlugs_BlogPost_Fragment | LinkedContentSlugs_Bulletin_Fragment | LinkedContentSlugs_BulletinBoard_Fragment | LinkedContentSlugs_DonationAppeal_Fragment | LinkedContentSlugs_EmbedInstagram_Fragment | LinkedContentSlugs_EmbedTwitter_Fragment | LinkedContentSlugs_Hero_Fragment | LinkedContentSlugs_Hospital_Fragment | LinkedContentSlugs_KnowledgeBasedResource_Fragment | LinkedContentSlugs_LayoutCopy_Fragment | LinkedContentSlugs_NavigationDropdown_Fragment | LinkedContentSlugs_NavigationLink_Fragment | LinkedContentSlugs_NavigationPrimary_Fragment | LinkedContentSlugs_NavigationSecondary_Fragment | LinkedContentSlugs_Page_Fragment | LinkedContentSlugs_Partner_Fragment | LinkedContentSlugs_Person_Fragment | LinkedContentSlugs_PressRelease_Fragment | LinkedContentSlugs_Program_Fragment | LinkedContentSlugs_Redirect_Fragment | LinkedContentSlugs_Statistic_Fragment | LinkedContentSlugs_Tab_Fragment;

export type NavigationDropdownFragment = { __typename: 'NavigationDropdown', title?: string | null, linksCollection?: { __typename?: 'NavigationDropdownLinksCollection', items: Array<{ __typename: 'NavigationLink', title?: string | null, linkStatic?: string | null, description?: { __typename?: 'NavigationLinkDescription', json: any } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, linkEntryReferenceCollection?: { __typename?: 'NavigationLinkLinkEntryReferenceCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type NavigationLinkFragment = { __typename: 'NavigationLink', title?: string | null, linkStatic?: string | null, description?: { __typename?: 'NavigationLinkDescription', json: any } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, linkEntryReferenceCollection?: { __typename?: 'NavigationLinkLinkEntryReferenceCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetNavigationQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  headerId: Scalars['String']['input'];
  footerId: Scalars['String']['input'];
}>;


export type GetNavigationQuery = { __typename?: 'Query', navigationPrimary?: { __typename: 'NavigationPrimary', title?: string | null, navigationItemsCollection?: { __typename?: 'NavigationPrimaryNavigationItemsCollection', items: Array<{ __typename: 'NavigationDropdown', title?: string | null, linksCollection?: { __typename?: 'NavigationDropdownLinksCollection', items: Array<{ __typename: 'NavigationLink', title?: string | null, linkStatic?: string | null, description?: { __typename?: 'NavigationLinkDescription', json: any } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, linkEntryReferenceCollection?: { __typename?: 'NavigationLinkLinkEntryReferenceCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', title?: string | null, linkStatic?: string | null, description?: { __typename?: 'NavigationLinkDescription', json: any } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, linkEntryReferenceCollection?: { __typename?: 'NavigationLinkLinkEntryReferenceCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, navigationSecondary?: { __typename: 'NavigationSecondary', title?: string | null, navigationItemsCollection?: { __typename?: 'NavigationSecondaryNavigationItemsCollection', items: Array<{ __typename: 'NavigationLink', title?: string | null, linkStatic?: string | null, description?: { __typename?: 'NavigationLinkDescription', json: any } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, linkEntryReferenceCollection?: { __typename?: 'NavigationLinkLinkEntryReferenceCollection', items: Array<{ __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null };

export type PageFragment = { __typename: 'Page', title?: string | null, slug?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, hideNavigation?: boolean | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'PageContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetLandingPageSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFilter>;
}>;


export type GetLandingPageSlugsQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'Page', title?: string | null, slug?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, hideNavigation?: boolean | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'PageContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPageSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPageSlugByIdQuery = { __typename?: 'Query', page?: { __typename?: 'Page', slug?: string | null } | null };

export type GetPagesQueryVariables = Exact<{
  where?: InputMaybe<PageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>> | InputMaybe<PageOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPagesQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename: 'Page', title?: string | null, slug?: string | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, hideNavigation?: boolean | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'PageContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPageIdBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPageIdBySlugQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', sys: { __typename?: 'Sys', id: string } } | null> } | null, programCollection?: { __typename?: 'ProgramCollection', items: Array<{ __typename?: 'Program', sys: { __typename?: 'Sys', id: string } } | null> } | null, basicPageCollection?: { __typename?: 'BasicPageCollection', items: Array<{ __typename?: 'BasicPage', sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type GetPageSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFilter>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>> | InputMaybe<PageOrder>>;
}>;


export type GetPageSlugsQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', total: number, items: Array<{ __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type PartnerPageFragment = { __typename: 'Partner', title?: string | null, slug?: string | null, headline?: string | null, campaignUrl?: string | null, createPage?: boolean | null, shortDescription?: { __typename?: 'PartnerShortDescription', json: any } | null, logo?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'PartnerContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetPartnerPageSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerFilter>;
  order?: InputMaybe<Array<InputMaybe<PartnerOrder>> | InputMaybe<PartnerOrder>>;
}>;


export type GetPartnerPageSlugsQuery = { __typename?: 'Query', partnerCollection?: { __typename?: 'PartnerCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'Partner', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPartnerPagesQueryVariables = Exact<{
  where?: InputMaybe<PartnerFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PartnerOrder>> | InputMaybe<PartnerOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPartnerPagesQuery = { __typename?: 'Query', partnerCollection?: { __typename?: 'PartnerCollection', items: Array<{ __typename: 'Partner', title?: string | null, slug?: string | null, headline?: string | null, campaignUrl?: string | null, createPage?: boolean | null, shortDescription?: { __typename?: 'PartnerShortDescription', json: any } | null, logo?: { __typename: 'Asset', width?: number | null, height?: number | null, url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'PartnerContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPartnerSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPartnerSlugByIdQuery = { __typename?: 'Query', partner?: { __typename?: 'Partner', slug?: string | null } | null };

export type PressReleaseTeaserFragment = { __typename: 'PressRelease', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type PressReleasePageFragment = { __typename: 'PressRelease', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, youTubeUrl?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, text?: { __typename?: 'PressReleaseText', json: any, links: { __typename?: 'PressReleaseTextLinks', entries: { __typename?: 'PressReleaseTextEntries', block: Array<{ __typename: 'BasicPage' } | { __typename: 'BlockBlogPosts' } | { __typename: 'BlockClassy' } | { __typename: 'BlockCollapsible' } | { __typename: 'BlockCta' } | { __typename: 'BlockCustomComponent' } | { __typename: 'BlockDonate' } | { __typename: 'BlockElfsightWidget' } | { __typename: 'BlockEmailCollection' } | { __typename: 'BlockFormAssembly' } | { __typename: 'BlockFundraiseUp' } | { __typename: 'BlockHighlight' } | { __typename: 'BlockImages' } | { __typename: 'BlockImpactStatistics' } | { __typename: 'BlockPartners' } | { __typename: 'BlockPeople' } | { __typename: 'BlockPrograms' } | { __typename: 'BlockQuotation' } | { __typename: 'BlockQuotations' } | { __typename: 'BlockShare' } | { __typename: 'BlockTabs' } | { __typename: 'BlockThermometer' } | { __typename: 'BlockVideo' } | { __typename: 'BlogCategory' } | { __typename: 'BlogPost' } | { __typename: 'Bulletin' } | { __typename: 'BulletinBoard' } | { __typename: 'DonationAppeal' } | { __typename: 'EmbedInstagram', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero' } | { __typename: 'Hospital' } | { __typename: 'KnowledgeBasedResource' } | { __typename: 'LayoutCopy' } | { __typename: 'NavigationDropdown' } | { __typename: 'NavigationLink' } | { __typename: 'NavigationPrimary' } | { __typename: 'NavigationSecondary' } | { __typename: 'Page' } | { __typename: 'Partner' } | { __typename: 'Person' } | { __typename: 'PressRelease' } | { __typename: 'Program' } | { __typename: 'Redirect' } | { __typename: 'Statistic' } | { __typename: 'Tab' } | null>, hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'PressReleaseTextAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetPressReleasesQueryVariables = Exact<{
  where?: InputMaybe<PressReleaseFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PressReleaseOrder>> | InputMaybe<PressReleaseOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  isTeaser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPressReleasesQuery = { __typename?: 'Query', pressReleases?: { __typename?: 'PressReleaseCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'PressRelease', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, youTubeUrl?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, text?: { __typename?: 'PressReleaseText', json: any, links: { __typename?: 'PressReleaseTextLinks', entries: { __typename?: 'PressReleaseTextEntries', block: Array<{ __typename: 'BasicPage' } | { __typename: 'BlockBlogPosts' } | { __typename: 'BlockClassy' } | { __typename: 'BlockCollapsible' } | { __typename: 'BlockCta' } | { __typename: 'BlockCustomComponent' } | { __typename: 'BlockDonate' } | { __typename: 'BlockElfsightWidget' } | { __typename: 'BlockEmailCollection' } | { __typename: 'BlockFormAssembly' } | { __typename: 'BlockFundraiseUp' } | { __typename: 'BlockHighlight' } | { __typename: 'BlockImages' } | { __typename: 'BlockImpactStatistics' } | { __typename: 'BlockPartners' } | { __typename: 'BlockPeople' } | { __typename: 'BlockPrograms' } | { __typename: 'BlockQuotation' } | { __typename: 'BlockQuotations' } | { __typename: 'BlockShare' } | { __typename: 'BlockTabs' } | { __typename: 'BlockThermometer' } | { __typename: 'BlockVideo' } | { __typename: 'BlogCategory' } | { __typename: 'BlogPost' } | { __typename: 'Bulletin' } | { __typename: 'BulletinBoard' } | { __typename: 'DonationAppeal' } | { __typename: 'EmbedInstagram', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero' } | { __typename: 'Hospital' } | { __typename: 'KnowledgeBasedResource' } | { __typename: 'LayoutCopy' } | { __typename: 'NavigationDropdown' } | { __typename: 'NavigationLink' } | { __typename: 'NavigationPrimary' } | { __typename: 'NavigationSecondary' } | { __typename: 'Page' } | { __typename: 'Partner' } | { __typename: 'Person' } | { __typename: 'PressRelease' } | { __typename: 'Program' } | { __typename: 'Redirect' } | { __typename: 'Statistic' } | { __typename: 'Tab' } | null>, hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'PressReleaseTextAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPressReleaseBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPressReleaseBySlugQuery = { __typename?: 'Query', pressReleaseCollection?: { __typename?: 'PressReleaseCollection', items: Array<{ __typename: 'PressRelease', title?: string | null, slug?: string | null, date?: any | null, metaDescription?: string | null, metaKeywords?: Array<string | null> | null, youTubeUrl?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, text?: { __typename?: 'PressReleaseText', json: any, links: { __typename?: 'PressReleaseTextLinks', entries: { __typename?: 'PressReleaseTextEntries', block: Array<{ __typename: 'BasicPage' } | { __typename: 'BlockBlogPosts' } | { __typename: 'BlockClassy' } | { __typename: 'BlockCollapsible' } | { __typename: 'BlockCta' } | { __typename: 'BlockCustomComponent' } | { __typename: 'BlockDonate' } | { __typename: 'BlockElfsightWidget' } | { __typename: 'BlockEmailCollection' } | { __typename: 'BlockFormAssembly' } | { __typename: 'BlockFundraiseUp' } | { __typename: 'BlockHighlight' } | { __typename: 'BlockImages' } | { __typename: 'BlockImpactStatistics' } | { __typename: 'BlockPartners' } | { __typename: 'BlockPeople' } | { __typename: 'BlockPrograms' } | { __typename: 'BlockQuotation' } | { __typename: 'BlockQuotations' } | { __typename: 'BlockShare' } | { __typename: 'BlockTabs' } | { __typename: 'BlockThermometer' } | { __typename: 'BlockVideo' } | { __typename: 'BlogCategory' } | { __typename: 'BlogPost' } | { __typename: 'Bulletin' } | { __typename: 'BulletinBoard' } | { __typename: 'DonationAppeal' } | { __typename: 'EmbedInstagram', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', title?: string | null, url?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero' } | { __typename: 'Hospital' } | { __typename: 'KnowledgeBasedResource' } | { __typename: 'LayoutCopy' } | { __typename: 'NavigationDropdown' } | { __typename: 'NavigationLink' } | { __typename: 'NavigationPrimary' } | { __typename: 'NavigationSecondary' } | { __typename: 'Page' } | { __typename: 'Partner' } | { __typename: 'Person' } | { __typename: 'PressRelease' } | { __typename: 'Program' } | { __typename: 'Redirect' } | { __typename: 'Statistic' } | { __typename: 'Tab' } | null>, hyperlink: Array<{ __typename: 'BasicPage', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockBlogPosts', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCta', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockElfsightWidget', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFormAssembly', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPartners', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockShare', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockThermometer', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BlogPost', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Bulletin', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'DonationAppeal', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedInstagram', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'EmbedTwitter', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Hospital', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'KnowledgeBasedResource', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationDropdown', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationPrimary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'NavigationSecondary', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Partner', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Person', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'PressRelease', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Program', slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Redirect', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Statistic', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> }, assets: { __typename?: 'PressReleaseTextAssets', block: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetPressReleaseSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPressReleaseSlugByIdQuery = { __typename?: 'Query', pressRelease?: { __typename?: 'PressRelease', slug?: string | null } | null };

export type GetPressReleaseSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPressReleaseSlugsQuery = { __typename?: 'Query', pressReleaseCollection?: { __typename?: 'PressReleaseCollection', total: number, items: Array<{ __typename: 'PressRelease', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type ProgramPageFragment = { __typename: 'Program', title?: string | null, slug?: string | null, overview?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'ProgramContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type ProgramFragment = { __typename: 'Program', title?: string | null, slug?: string | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } };

export type GetProgramPageSlugsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgramFilter>;
  order?: InputMaybe<Array<InputMaybe<ProgramOrder>> | InputMaybe<ProgramOrder>>;
}>;


export type GetProgramPageSlugsQuery = { __typename?: 'Query', programCollection?: { __typename?: 'ProgramCollection', total: number, items: Array<{ __typename: 'Program', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetProgramPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProgramPageBySlugQuery = { __typename?: 'Query', programCollection?: { __typename?: 'ProgramCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'Program', title?: string | null, slug?: string | null, overview?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'ProgramContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetProgramSlugByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProgramSlugByIdQuery = { __typename?: 'Query', program?: { __typename?: 'Program', slug?: string | null } | null };

export type GetProgramsQueryVariables = Exact<{
  where?: InputMaybe<ProgramFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramOrder>> | InputMaybe<ProgramOrder>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProgramsQuery = { __typename?: 'Query', programCollection?: { __typename?: 'ProgramCollection', items: Array<{ __typename: 'Program', title?: string | null, slug?: string | null, overview?: string | null, metaKeywords?: Array<string | null> | null, image?: { __typename: 'Asset', url?: string | null, title?: string | null, description?: string | null, contentType?: string | null, height?: number | null, width?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null, blocks?: { __typename?: 'ProgramContentBlocksCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'BlockClassy', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCollapsible', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockCustomComponent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockDonate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockEmailCollection', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockFundraiseUp', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockHighlight', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImages', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockImpactStatistics', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPeople', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockPrograms', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockQuotations', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockTabs', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlockVideo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BulletinBoard', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Hero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LayoutCopy', sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null } } | null> } | null };

export type GetRedirectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectsQuery = { __typename?: 'Query', redirectCollection?: { __typename?: 'RedirectCollection', items: Array<{ __typename?: 'Redirect', source?: string | null, destination?: string | null } | null> } | null };

export type GetRedirectBySourceQueryVariables = Exact<{
  source: Scalars['String']['input'];
}>;


export type GetRedirectBySourceQuery = { __typename?: 'Query', redirectCollection?: { __typename?: 'RedirectCollection', items: Array<{ __typename?: 'Redirect', source?: string | null, destination?: string | null } | null> } | null };

export type SysFragment = { __typename?: 'Sys', id: string, spaceId: string, environmentId: string, publishedAt?: any | null, firstPublishedAt?: any | null };

export const SysFragmentDoc = gql`
    fragment Sys on Sys {
  id
  spaceId
  environmentId
  publishedAt
  firstPublishedAt
}
    `;
export const EntryFragmentDoc = gql`
    fragment Entry on Entry {
  __typename
  sys {
    ...Sys
  }
}
    ${SysFragmentDoc}`;
export const AssetFragmentDoc = gql`
    fragment Asset on Asset {
  __typename
  sys {
    ...Sys
  }
  url
  title
  description
  contentType
  height
  width
}
    ${SysFragmentDoc}`;
export const LinkedContentSlugsFragmentDoc = gql`
    fragment LinkedContentSlugs on Entry {
  ...Entry
  ... on Page {
    slug
  }
  ... on BlogPost {
    slug
  }
  ... on Program {
    slug
  }
  ... on PressRelease {
    slug
  }
}
    ${EntryFragmentDoc}`;
export const BasicPageFragmentDoc = gql`
    fragment BasicPage on BasicPage {
  ...Entry
  title
  slug
  metaDescription
  metaKeywords
  image {
    ...Asset
  }
  copy {
    json
    links {
      entries {
        hyperlink {
          ...LinkedContentSlugs
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on BlogCategory {
  sys {
    id
  }
  title
  icon {
    ...Asset
  }
  color
}
    ${AssetFragmentDoc}`;
export const BlogTeaserFragmentDoc = gql`
    fragment BlogTeaser on BlogPost {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  categories: categoriesCollection(limit: 2) {
    items {
      ...BlogCategory
    }
  }
  date
  summary
  metaDescription
  metaKeywords
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const BlockBlogPostsFragmentDoc = gql`
    fragment BlockBlogPosts on BlockBlogPosts {
  ...Entry
  headline
  blogPostsCollection {
    items {
      ...BlogTeaser
    }
  }
}
    ${EntryFragmentDoc}
${BlogTeaserFragmentDoc}`;
export const BulletinItemFragmentDoc = gql`
    fragment BulletinItem on Bulletin {
  ...Entry
  image {
    ...Asset
  }
  imageCaption
  icon
  copy
  title
  ctaTitle
  ctaLinkAsset {
    ...Asset
  }
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockBulletinBoardFragmentDoc = gql`
    fragment BlockBulletinBoard on BulletinBoard {
  ...Entry
  icon
  headline
  ctaHeadline
  ctaTitle
  ctaLinkAsset {
    ...Asset
  }
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  visualStyle
  separator
  bulletinsCollection(limit: 20) {
    items {
      ...BulletinItem
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${BulletinItemFragmentDoc}`;
export const BlockClassyFragmentDoc = gql`
    fragment BlockClassy on BlockClassy {
  ...Entry
  image {
    ...Asset
  }
  headline
  campaignId
  recurringNudges
  size
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const ContentBlockFragmentDoc = gql`
    fragment ContentBlock on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const BlockCollapsibleFragmentDoc = gql`
    fragment BlockCollapsible on BlockCollapsible {
  ...Entry
  ctaTitle
  block {
    ...ContentBlock
  }
  collapsedBlock {
    ...ContentBlock
  }
}
    ${EntryFragmentDoc}
${ContentBlockFragmentDoc}`;
export const BlockCopyFragmentDoc = gql`
    fragment BlockCopy on LayoutCopy {
  ...Entry
  icon
  headline
  text: copy {
    json
    links {
      entries {
        block {
          __typename
          ... on EmbedInstagram {
            ...Entry
            title
            url
          }
          ... on EmbedTwitter {
            ...Entry
            title
            url
          }
        }
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  visualStyle
  dropCap
  separator
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockCtaFragmentDoc = gql`
    fragment BlockCta on BlockCta {
  ...Entry
  headline
  copy {
    json
    links {
      entries {
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  image {
    ...Asset
  }
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  variant
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockCustomComponentFragmentDoc = gql`
    fragment BlockCustomComponent on BlockCustomComponent {
  ...Entry
  componentName
}
    ${EntryFragmentDoc}`;
export const DonateAppealItemFragmentDoc = gql`
    fragment DonateAppealItem on DonationAppeal {
  ...Entry
  icon
  headline
  copy
  image {
    ...Asset
  }
  imageCaption
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  moreLink
  moreLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  moreLinkAsset {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockDonateFragmentDoc = gql`
    fragment BlockDonate on BlockDonate {
  ...Entry
  icon
  headline
  separator
  donationAppealsCollection(limit: 3) {
    items {
      ...DonateAppealItem
    }
  }
}
    ${EntryFragmentDoc}
${DonateAppealItemFragmentDoc}`;
export const BlockElfsightWidgetFragmentDoc = gql`
    fragment BlockElfsightWidget on BlockElfsightWidget {
  ...Entry
  headline
  icon
  appId
  separator
}
    ${EntryFragmentDoc}`;
export const BlockEmailCollectionFragmentDoc = gql`
    fragment BlockEmailCollection on BlockEmailCollection {
  ...Entry
  heading
  copy
  icon
  ctaTitle
  formId
  separator
  urlEndpoint
}
    ${EntryFragmentDoc}`;
export const BlockFormAssemblyFragmentDoc = gql`
    fragment BlockFormAssembly on BlockFormAssembly {
  ...Entry
  html
  separator
}
    ${EntryFragmentDoc}`;
export const BlockFundraiseUpFragmentDoc = gql`
    fragment BlockFundraiseUp on BlockFundraiseUp {
  ...Entry
  elementId
  image {
    ...Asset
  }
  headline
  widgetType
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockHeroFragmentDoc = gql`
    fragment BlockHero on Hero {
  ...Entry
  kicker
  headline
  copy
  image {
    ...Asset
  }
  logo {
    ...Asset
  }
  videoAsset {
    ...Asset
  }
  ctaTitlePrimary
  ctaLinkPrimary
  ctaLinkContentPrimaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetPrimary {
    ...Asset
  }
  ctaTitleSecondary
  ctaLinkSecondary
  ctaLinkContentSecondaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetSecondary {
    ...Asset
  }
  ctaProminence
  separator
  aspectRatio
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockHighlightFragmentDoc = gql`
    fragment BlockHighlight on BlockHighlight {
  ...Entry
  headline
  copy
  text {
    json
    links {
      entries {
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  image {
    ...Asset
  }
  imageCaption
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  ctaVariant
  decoration
  aspectRatio
  reversed
  videoAsset {
    ...Asset
  }
  background
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockImagesFragmentDoc = gql`
    fragment BlockImages on BlockImages {
  ...Entry
  icon
  headline
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  imagesCollection(limit: 10) {
    items {
      title
      description
      ...Asset
    }
  }
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const StatisticItemFragmentDoc = gql`
    fragment StatisticItem on Statistic {
  ...Entry
  image {
    ...Asset
  }
  headline
  copy
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  statType
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockStatisticsFragmentDoc = gql`
    fragment BlockStatistics on BlockImpactStatistics {
  ...Entry
  icon
  headline
  copy
  statisticsCollection(limit: 4) {
    items {
      ...StatisticItem
    }
  }
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkAsset {
    ...Asset
  }
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  separator
}
    ${EntryFragmentDoc}
${StatisticItemFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const PartnerTeaserFragmentDoc = gql`
    fragment PartnerTeaser on Partner {
  ...Entry
  title
  shortDescription {
    json
  }
  slug
  logo {
    ...Asset
    width
    height
  }
  image {
    ...Asset
    width
    height
  }
  createPage
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockPartnersFragmentDoc = gql`
    fragment BlockPartners on BlockPartners {
  ...Entry
  headline
  partnersCollection {
    items {
      ...PartnerTeaser
    }
  }
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  layout
}
    ${EntryFragmentDoc}
${PartnerTeaserFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const PersonItemFragmentDoc = gql`
    fragment PersonItem on Person {
  ...Entry
  fullName
  firstName
  lastName
  jobTitle
  emailAddress
  photo {
    ...Asset
  }
  shortBio
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockPeopleFragmentDoc = gql`
    fragment BlockPeople on BlockPeople {
  ...Entry
  headline
  icon
  separator
  peopleCollection(limit: 10) {
    items {
      ...PersonItem
    }
  }
}
    ${EntryFragmentDoc}
${PersonItemFragmentDoc}`;
export const ProgramItemFragmentDoc = gql`
    fragment ProgramItem on Program {
  ...Entry
  title
  icon
  slug
  overview
  donateLink
  image {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockProgramsFragmentDoc = gql`
    fragment BlockPrograms on BlockPrograms {
  ...Entry
  icon
  headline
  separator
  programsCollection(limit: 10) {
    items {
      ...ProgramItem
    }
  }
}
    ${EntryFragmentDoc}
${ProgramItemFragmentDoc}`;
export const BlockQuotationFragmentDoc = gql`
    fragment BlockQuotation on BlockQuotation {
  ...Entry
  quote
  image {
    ...Asset
  }
  attribution
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  variant
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockQuotationsFragmentDoc = gql`
    fragment BlockQuotations on BlockQuotations {
  ...Entry
  quotationsCollection {
    items {
      ...BlockQuotation
    }
  }
  variant
}
    ${EntryFragmentDoc}
${BlockQuotationFragmentDoc}`;
export const BlockShareFragmentDoc = gql`
    fragment BlockShare on BlockShare {
  ...Entry
  icon
  heading
  copy
  url
  separator
}
    ${EntryFragmentDoc}`;
export const TabItemFragmentDoc = gql`
    fragment TabItem on Tab {
  ...Entry
  headline
  image {
    ...Asset
  }
  copy {
    json
    links {
      assets {
        hyperlink {
          ...Asset
        }
      }
    }
  }
  ctaTitlePrimary
  ctaLinkPrimary
  ctaLinkContentPrimaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetPrimary {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockTabsFragmentDoc = gql`
    fragment BlockTabs on BlockTabs {
  ...Entry
  tabsCollection(limit: 10) {
    items {
      ...TabItem
    }
  }
}
    ${EntryFragmentDoc}
${TabItemFragmentDoc}`;
export const BlockThermometerFragmentDoc = gql`
    fragment BlockThermometer on BlockThermometer {
  ...Entry
  title
  milestones
  amountRaised
  amountGoal
}
    ${EntryFragmentDoc}`;
export const BlockVideoFragmentDoc = gql`
    fragment BlockVideo on BlockVideo {
  ...Entry
  icon
  headline
  autoplay
  playerSize
  thumbnail {
    ...Asset
  }
  videoUrl
  description
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  videoAsset {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlogPageFragmentDoc = gql`
    fragment BlogPage on BlogPost {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  closerBlocks: closerBlocksCollection(limit: 2) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  authors: authorsCollection(limit: 2) {
    items {
      ...PersonItem
    }
  }
  categories: categoriesCollection(limit: 2) {
    items {
      ...BlogCategory
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}
${PersonItemFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const NavigationDropdownFragmentDoc = gql`
    fragment NavigationDropdown on NavigationDropdown {
  ...Entry
  title
  linksCollection(limit: 12) {
    items {
      title
      description {
        json
      }
      image {
        ...Asset
      }
      ...Entry
      linkStatic
      linkEntryReferenceCollection(limit: 10) {
        items {
          ...LinkedContentSlugs
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const NavigationLinkFragmentDoc = gql`
    fragment NavigationLink on NavigationLink {
  ...Entry
  title
  description {
    json
  }
  image {
    ...Asset
  }
  linkStatic
  linkEntryReferenceCollection(limit: 10) {
    items {
      ...LinkedContentSlugs
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  ...Entry
  title
  slug
  metaDescription
  metaKeywords
  hideNavigation
  image {
    ...Asset
  }
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const PartnerPageFragmentDoc = gql`
    fragment PartnerPage on Partner {
  ...Entry
  title
  slug
  headline
  shortDescription {
    json
  }
  logo {
    ...Asset
    width
    height
  }
  image {
    ...Asset
  }
  campaignUrl
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  createPage
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const PressReleaseTeaserFragmentDoc = gql`
    fragment PressReleaseTeaser on PressRelease {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const PressReleasePageFragmentDoc = gql`
    fragment PressReleasePage on PressRelease {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
  youTubeUrl
  text {
    json
    links {
      entries {
        block {
          __typename
          ... on EmbedInstagram {
            ...Entry
            title
            url
          }
          ... on EmbedTwitter {
            ...Entry
            title
            url
          }
        }
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const ProgramPageFragmentDoc = gql`
    fragment ProgramPage on Program {
  ...Entry
  title
  slug
  overview
  metaKeywords
  image {
    ...Asset
  }
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const ProgramFragmentDoc = gql`
    fragment Program on Program {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const GetBasicPageBySlugDocument = gql`
    query getBasicPageBySlug($slug: String, $preview: Boolean) {
  basicPageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      ...BasicPage
    }
  }
}
    ${BasicPageFragmentDoc}`;
export const GetBasicPageSlugByIdDocument = gql`
    query getBasicPageSlugById($id: String!, $preview: Boolean) {
  basicPage(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetBasicPageSlugsDocument = gql`
    query getBasicPageSlugs($limit: Int, $skip: Int) {
  basicPageCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetBlockBlogPostsDocument = gql`
    query getBlockBlogPosts($id: String!, $preview: Boolean) {
  blockBlogPosts(id: $id, preview: $preview) {
    ...BlockBlogPosts
  }
}
    ${BlockBlogPostsFragmentDoc}`;
export const GetBlockBulletinBoardDocument = gql`
    query getBlockBulletinBoard($id: String!, $preview: Boolean) {
  bulletinBoard(id: $id, preview: $preview) {
    ...BlockBulletinBoard
  }
}
    ${BlockBulletinBoardFragmentDoc}`;
export const GetBlockClassyDocument = gql`
    query getBlockClassy($id: String!, $preview: Boolean) {
  blockClassy(id: $id, preview: $preview) {
    ...BlockClassy
  }
}
    ${BlockClassyFragmentDoc}`;
export const GetBlockCollapsibleDocument = gql`
    query getBlockCollapsible($id: String!, $preview: Boolean) {
  blockCollapsible(id: $id, preview: $preview) {
    ...BlockCollapsible
  }
}
    ${BlockCollapsibleFragmentDoc}`;
export const GetBlockCopyDocument = gql`
    query getBlockCopy($id: String!, $preview: Boolean) {
  layoutCopy(id: $id, preview: $preview) {
    ...BlockCopy
  }
}
    ${BlockCopyFragmentDoc}`;
export const GetBlockCtaDocument = gql`
    query getBlockCta($id: String!, $preview: Boolean) {
  blockCta(id: $id, preview: $preview) {
    ...BlockCta
  }
}
    ${BlockCtaFragmentDoc}`;
export const GetBlockCustomComponentDocument = gql`
    query getBlockCustomComponent($id: String!, $preview: Boolean) {
  blockCustomComponent(id: $id, preview: $preview) {
    ...BlockCustomComponent
  }
}
    ${BlockCustomComponentFragmentDoc}`;
export const GetBlockDonateDocument = gql`
    query getBlockDonate($id: String!, $preview: Boolean) {
  blockDonate(id: $id, preview: $preview) {
    ...BlockDonate
  }
}
    ${BlockDonateFragmentDoc}`;
export const GetBlockElfsightCalendarDocument = gql`
    query getBlockElfsightCalendar($id: String!, $preview: Boolean) {
  blockElfsightWidget(id: $id, preview: $preview) {
    ...BlockElfsightWidget
  }
}
    ${BlockElfsightWidgetFragmentDoc}`;
export const GetBlockEmailCollectionDocument = gql`
    query getBlockEmailCollection($id: String!, $preview: Boolean) {
  blockEmailCollection(id: $id, preview: $preview) {
    ...BlockEmailCollection
  }
}
    ${BlockEmailCollectionFragmentDoc}`;
export const GetBlockFormAssemblyDocument = gql`
    query getBlockFormAssembly($id: String!, $preview: Boolean) {
  blockFormAssembly(id: $id, preview: $preview) {
    ...BlockFormAssembly
  }
}
    ${BlockFormAssemblyFragmentDoc}`;
export const GetBlockFundraiseUpDocument = gql`
    query getBlockFundraiseUp($id: String!, $preview: Boolean) {
  blockFundraiseUp(id: $id, preview: $preview) {
    ...BlockFundraiseUp
  }
}
    ${BlockFundraiseUpFragmentDoc}`;
export const GetBlockHeroDocument = gql`
    query getBlockHero($id: String!, $preview: Boolean) {
  hero(id: $id, preview: $preview) {
    ...BlockHero
  }
}
    ${BlockHeroFragmentDoc}`;
export const GetBlockHighlightDocument = gql`
    query getBlockHighlight($id: String!, $preview: Boolean) {
  blockHighlight(id: $id, preview: $preview) {
    ...BlockHighlight
  }
}
    ${BlockHighlightFragmentDoc}`;
export const GetBlockImagesDocument = gql`
    query getBlockImages($id: String!, $preview: Boolean) {
  blockImages(id: $id, preview: $preview) {
    ...BlockImages
  }
}
    ${BlockImagesFragmentDoc}`;
export const GetBlockStatisticsDocument = gql`
    query getBlockStatistics($id: String!, $preview: Boolean) {
  blockImpactStatistics(id: $id, preview: $preview) {
    ...BlockStatistics
  }
}
    ${BlockStatisticsFragmentDoc}`;
export const GetBlockImpactStatisticIdsByStatisticIdDocument = gql`
    query getBlockImpactStatisticIdsByStatisticId($id: String!) {
  statistic(id: $id) {
    linkedFrom {
      blockImpactStatisticsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockPartnersDocument = gql`
    query getBlockPartners($id: String!, $preview: Boolean) {
  blockPartners(id: $id, preview: $preview) {
    ...BlockPartners
  }
}
    ${BlockPartnersFragmentDoc}`;
export const GetBlockPeopleDocument = gql`
    query getBlockPeople($id: String!, $preview: Boolean) {
  blockPeople(id: $id, preview: $preview) {
    ...BlockPeople
  }
}
    ${BlockPeopleFragmentDoc}`;
export const GetBlockPeopleIdsByPersonIdDocument = gql`
    query getBlockPeopleIdsByPersonId($id: String!) {
  person(id: $id) {
    linkedFrom {
      blockPeopleCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockProgramsDocument = gql`
    query getBlockPrograms($id: String!, $preview: Boolean) {
  blockPrograms(id: $id, preview: $preview) {
    ...BlockPrograms
  }
}
    ${BlockProgramsFragmentDoc}`;
export const GetBlockProgramIdsByProgramIdDocument = gql`
    query getBlockProgramIdsByProgramId($id: String!) {
  program(id: $id) {
    linkedFrom {
      blockProgramsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockQuotationDocument = gql`
    query getBlockQuotation($id: String!, $preview: Boolean) {
  blockQuotation(id: $id, preview: $preview) {
    ...BlockQuotation
  }
}
    ${BlockQuotationFragmentDoc}`;
export const GetBlockQuotationsDocument = gql`
    query getBlockQuotations($id: String!, $preview: Boolean) {
  blockQuotations(id: $id, preview: $preview) {
    ...BlockQuotations
  }
}
    ${BlockQuotationsFragmentDoc}`;
export const GetBlockShareDocument = gql`
    query getBlockShare($id: String!, $preview: Boolean) {
  blockShare(id: $id, preview: $preview) {
    ...BlockShare
  }
}
    ${BlockShareFragmentDoc}`;
export const GetBlockTabsDocument = gql`
    query getBlockTabs($id: String!, $preview: Boolean) {
  blockTabs(id: $id, preview: $preview) {
    ...BlockTabs
  }
}
    ${BlockTabsFragmentDoc}`;
export const GetBlockTabsIdsByTabIdDocument = gql`
    query getBlockTabsIdsByTabId($id: String!) {
  tab(id: $id) {
    linkedFrom {
      blockTabsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockThermometerDocument = gql`
    query getBlockThermometer($id: String!, $preview: Boolean) {
  blockThermometer(id: $id, preview: $preview) {
    ...BlockThermometer
  }
}
    ${BlockThermometerFragmentDoc}`;
export const GetBlockVideoDocument = gql`
    query getBlockVideo($id: String!, $preview: Boolean) {
  blockVideo(id: $id, preview: $preview) {
    ...BlockVideo
  }
}
    ${BlockVideoFragmentDoc}`;
export const GetBlogSlugsDocument = gql`
    query getBlogSlugs($limit: Int, $skip: Int, $where: BlogPostFilter, $order: [BlogPostOrder] = date_DESC) {
  blogPostCollection(limit: $limit, skip: $skip, order: date_DESC, where: $where) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetBlogPostsDocument = gql`
    query getBlogPosts($where: BlogPostFilter, $limit: Int, $skip: Int, $order: [BlogPostOrder] = date_DESC, $preview: Boolean = false, $isTeaser: Boolean = true) {
  blogs: blogPostCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...BlogTeaser @include(if: $isTeaser)
      ...BlogPage @skip(if: $isTeaser)
    }
  }
}
    ${BlogTeaserFragmentDoc}
${BlogPageFragmentDoc}`;
export const SearchBlogPostsDocument = gql`
    query searchBlogPosts($where: BlogPostFilter, $limit: Int, $skip: Int, $order: [BlogPostOrder] = date_DESC, $preview: Boolean = false) {
  blogs: blogPostCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...BlogTeaser
    }
  }
}
    ${BlogTeaserFragmentDoc}`;
export const GetBlogPostBySlugDocument = gql`
    query getBlogPostBySlug($slug: String, $preview: Boolean) {
  blogPostCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      ...BlogPage
    }
  }
}
    ${BlogPageFragmentDoc}`;
export const GetBlogPostSlugByIdDocument = gql`
    query getBlogPostSlugById($id: String!, $preview: Boolean) {
  blogPost(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetBlogPostSlugsDocument = gql`
    query getBlogPostSlugs($limit: Int, $skip: Int) {
  blogPostCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetNavigationDocument = gql`
    query getNavigation($preview: Boolean, $headerId: String!, $footerId: String!) {
  navigationPrimary(id: $headerId, preview: $preview) {
    title
    ...Entry
    navigationItemsCollection(limit: 10) {
      items {
        ...NavigationDropdown
        ...NavigationLink
      }
    }
  }
  navigationSecondary(id: $footerId, preview: $preview) {
    title
    ...Entry
    navigationItemsCollection(limit: 12) {
      items {
        ...NavigationLink
      }
    }
  }
}
    ${EntryFragmentDoc}
${NavigationDropdownFragmentDoc}
${NavigationLinkFragmentDoc}`;
export const GetLandingPageSlugsDocument = gql`
    query getLandingPageSlugs($limit: Int, $skip: Int, $where: PageFilter) {
  pageCollection(limit: $limit, skip: $skip, where: $where) {
    total
    skip
    limit
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPageBySlugDocument = gql`
    query getPageBySlug($slug: String, $preview: Boolean) {
  pageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    total
    skip
    limit
    items {
      ...Page
    }
  }
}
    ${PageFragmentDoc}`;
export const GetPageSlugByIdDocument = gql`
    query getPageSlugById($id: String!, $preview: Boolean) {
  page(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPagesDocument = gql`
    query getPages($where: PageFilter, $limit: Int, $skip: Int, $order: [PageOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  pageCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...Page
    }
  }
}
    ${PageFragmentDoc}`;
export const GetPageIdBySlugDocument = gql`
    query getPageIdBySlug($slug: String!, $preview: Boolean = false) {
  pageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
  programCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
  basicPageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
}
    `;
export const GetPageSlugsDocument = gql`
    query getPageSlugs($limit: Int, $skip: Int, $where: PageFilter, $order: [PageOrder] = sys_publishedAt_DESC) {
  pageCollection(limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPartnerPageSlugsDocument = gql`
    query getPartnerPageSlugs($limit: Int, $skip: Int, $where: PartnerFilter, $order: [PartnerOrder] = sys_publishedAt_DESC) {
  partnerCollection(limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    skip
    limit
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPartnerPagesDocument = gql`
    query getPartnerPages($where: PartnerFilter, $limit: Int, $skip: Int, $order: [PartnerOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  partnerCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...PartnerPage
    }
  }
}
    ${PartnerPageFragmentDoc}`;
export const GetPartnerSlugByIdDocument = gql`
    query getPartnerSlugById($id: String!, $preview: Boolean) {
  partner(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPressReleasesDocument = gql`
    query getPressReleases($where: PressReleaseFilter, $limit: Int, $skip: Int, $order: [PressReleaseOrder] = date_DESC, $preview: Boolean = false, $isTeaser: Boolean = true) {
  pressReleases: pressReleaseCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...PressReleaseTeaser @include(if: $isTeaser)
      ...PressReleasePage @skip(if: $isTeaser)
    }
  }
}
    ${PressReleaseTeaserFragmentDoc}
${PressReleasePageFragmentDoc}`;
export const GetPressReleaseBySlugDocument = gql`
    query getPressReleaseBySlug($slug: String, $preview: Boolean) {
  pressReleaseCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      ...PressReleasePage
    }
  }
}
    ${PressReleasePageFragmentDoc}`;
export const GetPressReleaseSlugByIdDocument = gql`
    query getPressReleaseSlugById($id: String!, $preview: Boolean) {
  pressRelease(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPressReleaseSlugsDocument = gql`
    query getPressReleaseSlugs($limit: Int, $skip: Int) {
  pressReleaseCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetProgramPageSlugsDocument = gql`
    query getProgramPageSlugs($limit: Int, $skip: Int, $where: ProgramFilter, $order: [ProgramOrder] = sys_publishedAt_DESC) {
  programCollection(where: $where, limit: $limit, skip: $skip, order: $order) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetProgramPageBySlugDocument = gql`
    query getProgramPageBySlug($slug: String, $preview: Boolean) {
  programCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    total
    skip
    limit
    items {
      ...ProgramPage
    }
  }
}
    ${ProgramPageFragmentDoc}`;
export const GetProgramSlugByIdDocument = gql`
    query getProgramSlugById($id: String!, $preview: Boolean) {
  program(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetProgramsDocument = gql`
    query getPrograms($where: ProgramFilter, $limit: Int, $skip: Int, $order: [ProgramOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  programCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...ProgramPage
    }
  }
}
    ${ProgramPageFragmentDoc}`;
export const GetRedirectsDocument = gql`
    query getRedirects {
  redirectCollection {
    items {
      source
      destination
    }
  }
}
    `;
export const GetRedirectBySourceDocument = gql`
    query getRedirectBySource($source: String!) {
  redirectCollection(where: {source: $source}) {
    items {
      source
      destination
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getBasicPageBySlug(variables?: GetBasicPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageBySlugQuery>({ document: GetBasicPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageBySlug', 'query', variables);
    },
    getBasicPageSlugById(variables: GetBasicPageSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageSlugByIdQuery>({ document: GetBasicPageSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageSlugById', 'query', variables);
    },
    getBasicPageSlugs(variables?: GetBasicPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageSlugsQuery>({ document: GetBasicPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageSlugs', 'query', variables);
    },
    getBlockBlogPosts(variables: GetBlockBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockBlogPostsQuery>({ document: GetBlockBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockBlogPosts', 'query', variables);
    },
    getBlockBulletinBoard(variables: GetBlockBulletinBoardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockBulletinBoardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockBulletinBoardQuery>({ document: GetBlockBulletinBoardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockBulletinBoard', 'query', variables);
    },
    getBlockClassy(variables: GetBlockClassyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockClassyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockClassyQuery>({ document: GetBlockClassyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockClassy', 'query', variables);
    },
    getBlockCollapsible(variables: GetBlockCollapsibleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCollapsibleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCollapsibleQuery>({ document: GetBlockCollapsibleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCollapsible', 'query', variables);
    },
    getBlockCopy(variables: GetBlockCopyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCopyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCopyQuery>({ document: GetBlockCopyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCopy', 'query', variables);
    },
    getBlockCta(variables: GetBlockCtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCtaQuery>({ document: GetBlockCtaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCta', 'query', variables);
    },
    getBlockCustomComponent(variables: GetBlockCustomComponentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCustomComponentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCustomComponentQuery>({ document: GetBlockCustomComponentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCustomComponent', 'query', variables);
    },
    getBlockDonate(variables: GetBlockDonateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockDonateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockDonateQuery>({ document: GetBlockDonateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockDonate', 'query', variables);
    },
    getBlockElfsightCalendar(variables: GetBlockElfsightCalendarQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockElfsightCalendarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockElfsightCalendarQuery>({ document: GetBlockElfsightCalendarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockElfsightCalendar', 'query', variables);
    },
    getBlockEmailCollection(variables: GetBlockEmailCollectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockEmailCollectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockEmailCollectionQuery>({ document: GetBlockEmailCollectionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockEmailCollection', 'query', variables);
    },
    getBlockFormAssembly(variables: GetBlockFormAssemblyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockFormAssemblyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockFormAssemblyQuery>({ document: GetBlockFormAssemblyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockFormAssembly', 'query', variables);
    },
    getBlockFundraiseUp(variables: GetBlockFundraiseUpQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockFundraiseUpQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockFundraiseUpQuery>({ document: GetBlockFundraiseUpDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockFundraiseUp', 'query', variables);
    },
    getBlockHero(variables: GetBlockHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockHeroQuery>({ document: GetBlockHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockHero', 'query', variables);
    },
    getBlockHighlight(variables: GetBlockHighlightQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockHighlightQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockHighlightQuery>({ document: GetBlockHighlightDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockHighlight', 'query', variables);
    },
    getBlockImages(variables: GetBlockImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockImagesQuery>({ document: GetBlockImagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockImages', 'query', variables);
    },
    getBlockStatistics(variables: GetBlockStatisticsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockStatisticsQuery>({ document: GetBlockStatisticsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockStatistics', 'query', variables);
    },
    getBlockImpactStatisticIdsByStatisticId(variables: GetBlockImpactStatisticIdsByStatisticIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockImpactStatisticIdsByStatisticIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockImpactStatisticIdsByStatisticIdQuery>({ document: GetBlockImpactStatisticIdsByStatisticIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockImpactStatisticIdsByStatisticId', 'query', variables);
    },
    getBlockPartners(variables: GetBlockPartnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPartnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPartnersQuery>({ document: GetBlockPartnersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPartners', 'query', variables);
    },
    getBlockPeople(variables: GetBlockPeopleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPeopleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPeopleQuery>({ document: GetBlockPeopleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPeople', 'query', variables);
    },
    getBlockPeopleIdsByPersonId(variables: GetBlockPeopleIdsByPersonIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPeopleIdsByPersonIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPeopleIdsByPersonIdQuery>({ document: GetBlockPeopleIdsByPersonIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPeopleIdsByPersonId', 'query', variables);
    },
    getBlockPrograms(variables: GetBlockProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockProgramsQuery>({ document: GetBlockProgramsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPrograms', 'query', variables);
    },
    getBlockProgramIdsByProgramId(variables: GetBlockProgramIdsByProgramIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockProgramIdsByProgramIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockProgramIdsByProgramIdQuery>({ document: GetBlockProgramIdsByProgramIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockProgramIdsByProgramId', 'query', variables);
    },
    getBlockQuotation(variables: GetBlockQuotationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockQuotationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockQuotationQuery>({ document: GetBlockQuotationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockQuotation', 'query', variables);
    },
    getBlockQuotations(variables: GetBlockQuotationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockQuotationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockQuotationsQuery>({ document: GetBlockQuotationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockQuotations', 'query', variables);
    },
    getBlockShare(variables: GetBlockShareQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockShareQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockShareQuery>({ document: GetBlockShareDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockShare', 'query', variables);
    },
    getBlockTabs(variables: GetBlockTabsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockTabsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockTabsQuery>({ document: GetBlockTabsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockTabs', 'query', variables);
    },
    getBlockTabsIdsByTabId(variables: GetBlockTabsIdsByTabIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockTabsIdsByTabIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockTabsIdsByTabIdQuery>({ document: GetBlockTabsIdsByTabIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockTabsIdsByTabId', 'query', variables);
    },
    getBlockThermometer(variables: GetBlockThermometerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockThermometerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockThermometerQuery>({ document: GetBlockThermometerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockThermometer', 'query', variables);
    },
    getBlockVideo(variables: GetBlockVideoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockVideoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockVideoQuery>({ document: GetBlockVideoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockVideo', 'query', variables);
    },
    getBlogSlugs(variables?: GetBlogSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogSlugsQuery>({ document: GetBlogSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogSlugs', 'query', variables);
    },
    getBlogPosts(variables?: GetBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostsQuery>({ document: GetBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPosts', 'query', variables);
    },
    searchBlogPosts(variables?: SearchBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SearchBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchBlogPostsQuery>({ document: SearchBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'searchBlogPosts', 'query', variables);
    },
    getBlogPostBySlug(variables?: GetBlogPostBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostBySlugQuery>({ document: GetBlogPostBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostBySlug', 'query', variables);
    },
    getBlogPostSlugById(variables: GetBlogPostSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostSlugByIdQuery>({ document: GetBlogPostSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostSlugById', 'query', variables);
    },
    getBlogPostSlugs(variables?: GetBlogPostSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostSlugsQuery>({ document: GetBlogPostSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostSlugs', 'query', variables);
    },
    getNavigation(variables: GetNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNavigationQuery>({ document: GetNavigationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getNavigation', 'query', variables);
    },
    getLandingPageSlugs(variables?: GetLandingPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetLandingPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLandingPageSlugsQuery>({ document: GetLandingPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getLandingPageSlugs', 'query', variables);
    },
    getPageBySlug(variables?: GetPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageBySlugQuery>({ document: GetPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageBySlug', 'query', variables);
    },
    getPageSlugById(variables: GetPageSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSlugByIdQuery>({ document: GetPageSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageSlugById', 'query', variables);
    },
    getPages(variables?: GetPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPagesQuery>({ document: GetPagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPages', 'query', variables);
    },
    getPageIdBySlug(variables: GetPageIdBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageIdBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageIdBySlugQuery>({ document: GetPageIdBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageIdBySlug', 'query', variables);
    },
    getPageSlugs(variables?: GetPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSlugsQuery>({ document: GetPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageSlugs', 'query', variables);
    },
    getPartnerPageSlugs(variables?: GetPartnerPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerPageSlugsQuery>({ document: GetPartnerPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerPageSlugs', 'query', variables);
    },
    getPartnerPages(variables?: GetPartnerPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerPagesQuery>({ document: GetPartnerPagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerPages', 'query', variables);
    },
    getPartnerSlugById(variables: GetPartnerSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerSlugByIdQuery>({ document: GetPartnerSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerSlugById', 'query', variables);
    },
    getPressReleases(variables?: GetPressReleasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleasesQuery>({ document: GetPressReleasesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleases', 'query', variables);
    },
    getPressReleaseBySlug(variables?: GetPressReleaseBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseBySlugQuery>({ document: GetPressReleaseBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseBySlug', 'query', variables);
    },
    getPressReleaseSlugById(variables: GetPressReleaseSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseSlugByIdQuery>({ document: GetPressReleaseSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseSlugById', 'query', variables);
    },
    getPressReleaseSlugs(variables?: GetPressReleaseSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseSlugsQuery>({ document: GetPressReleaseSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseSlugs', 'query', variables);
    },
    getProgramPageSlugs(variables?: GetProgramPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramPageSlugsQuery>({ document: GetProgramPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramPageSlugs', 'query', variables);
    },
    getProgramPageBySlug(variables?: GetProgramPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramPageBySlugQuery>({ document: GetProgramPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramPageBySlug', 'query', variables);
    },
    getProgramSlugById(variables: GetProgramSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramSlugByIdQuery>({ document: GetProgramSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramSlugById', 'query', variables);
    },
    getPrograms(variables?: GetProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramsQuery>({ document: GetProgramsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPrograms', 'query', variables);
    },
    getRedirects(variables?: GetRedirectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRedirectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRedirectsQuery>({ document: GetRedirectsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getRedirects', 'query', variables);
    },
    getRedirectBySource(variables: GetRedirectBySourceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRedirectBySourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRedirectBySourceQuery>({ document: GetRedirectBySourceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getRedirectBySource', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;